/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
import * as $protobuf from "protobufjs/minimal";

// Common aliases
const $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
const $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

export const common = $root.common = (() => {

    /**
     * Namespace common.
     * @exports common
     * @namespace
     */
    const common = {};

    common.Date = (function() {

        /**
         * Properties of a Date.
         * @memberof common
         * @interface IDate
         * @property {number|null} [year] Date year
         * @property {number|null} [month] Date month
         * @property {number|null} [day] Date day
         * @property {number|null} [hour] Date hour
         * @property {number|null} [minute] Date minute
         * @property {number|null} [second] Date second
         * @property {string|null} [tz] Date tz
         * @property {number|Long|null} [ts] Date ts
         * @property {common.DateGranularity|null} [granularity] Date granularity
         */

        /**
         * Constructs a new Date.
         * @memberof common
         * @classdesc Represents a Date.
         * @implements IDate
         * @constructor
         * @param {common.IDate=} [properties] Properties to set
         */
        function Date(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Date year.
         * @member {number} year
         * @memberof common.Date
         * @instance
         */
        Date.prototype.year = 0;

        /**
         * Date month.
         * @member {number} month
         * @memberof common.Date
         * @instance
         */
        Date.prototype.month = 0;

        /**
         * Date day.
         * @member {number} day
         * @memberof common.Date
         * @instance
         */
        Date.prototype.day = 0;

        /**
         * Date hour.
         * @member {number} hour
         * @memberof common.Date
         * @instance
         */
        Date.prototype.hour = 0;

        /**
         * Date minute.
         * @member {number} minute
         * @memberof common.Date
         * @instance
         */
        Date.prototype.minute = 0;

        /**
         * Date second.
         * @member {number} second
         * @memberof common.Date
         * @instance
         */
        Date.prototype.second = 0;

        /**
         * Date tz.
         * @member {string} tz
         * @memberof common.Date
         * @instance
         */
        Date.prototype.tz = "";

        /**
         * Date ts.
         * @member {number|Long} ts
         * @memberof common.Date
         * @instance
         */
        Date.prototype.ts = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Date granularity.
         * @member {common.DateGranularity} granularity
         * @memberof common.Date
         * @instance
         */
        Date.prototype.granularity = 0;

        /**
         * Creates a new Date instance using the specified properties.
         * @function create
         * @memberof common.Date
         * @static
         * @param {common.IDate=} [properties] Properties to set
         * @returns {common.Date} Date instance
         */
        Date.create = function create(properties) {
            return new Date(properties);
        };

        /**
         * Encodes the specified Date message. Does not implicitly {@link common.Date.verify|verify} messages.
         * @function encode
         * @memberof common.Date
         * @static
         * @param {common.IDate} message Date message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Date.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.year != null && Object.hasOwnProperty.call(message, "year"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.year);
            if (message.month != null && Object.hasOwnProperty.call(message, "month"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.month);
            if (message.day != null && Object.hasOwnProperty.call(message, "day"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.day);
            if (message.hour != null && Object.hasOwnProperty.call(message, "hour"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.hour);
            if (message.minute != null && Object.hasOwnProperty.call(message, "minute"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.minute);
            if (message.second != null && Object.hasOwnProperty.call(message, "second"))
                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.second);
            if (message.tz != null && Object.hasOwnProperty.call(message, "tz"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.tz);
            if (message.ts != null && Object.hasOwnProperty.call(message, "ts"))
                writer.uint32(/* id 8, wireType 0 =*/64).int64(message.ts);
            if (message.granularity != null && Object.hasOwnProperty.call(message, "granularity"))
                writer.uint32(/* id 9, wireType 0 =*/72).int32(message.granularity);
            return writer;
        };

        /**
         * Encodes the specified Date message, length delimited. Does not implicitly {@link common.Date.verify|verify} messages.
         * @function encodeDelimited
         * @memberof common.Date
         * @static
         * @param {common.IDate} message Date message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Date.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Date message from the specified reader or buffer.
         * @function decode
         * @memberof common.Date
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {common.Date} Date
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Date.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.common.Date();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.year = reader.int32();
                        break;
                    }
                case 2: {
                        message.month = reader.int32();
                        break;
                    }
                case 3: {
                        message.day = reader.int32();
                        break;
                    }
                case 4: {
                        message.hour = reader.int32();
                        break;
                    }
                case 5: {
                        message.minute = reader.int32();
                        break;
                    }
                case 6: {
                        message.second = reader.int32();
                        break;
                    }
                case 7: {
                        message.tz = reader.string();
                        break;
                    }
                case 8: {
                        message.ts = reader.int64();
                        break;
                    }
                case 9: {
                        message.granularity = reader.int32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Date message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof common.Date
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {common.Date} Date
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Date.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Date message.
         * @function verify
         * @memberof common.Date
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Date.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.year != null && message.hasOwnProperty("year"))
                if (!$util.isInteger(message.year))
                    return "year: integer expected";
            if (message.month != null && message.hasOwnProperty("month"))
                if (!$util.isInteger(message.month))
                    return "month: integer expected";
            if (message.day != null && message.hasOwnProperty("day"))
                if (!$util.isInteger(message.day))
                    return "day: integer expected";
            if (message.hour != null && message.hasOwnProperty("hour"))
                if (!$util.isInteger(message.hour))
                    return "hour: integer expected";
            if (message.minute != null && message.hasOwnProperty("minute"))
                if (!$util.isInteger(message.minute))
                    return "minute: integer expected";
            if (message.second != null && message.hasOwnProperty("second"))
                if (!$util.isInteger(message.second))
                    return "second: integer expected";
            if (message.tz != null && message.hasOwnProperty("tz"))
                if (!$util.isString(message.tz))
                    return "tz: string expected";
            if (message.ts != null && message.hasOwnProperty("ts"))
                if (!$util.isInteger(message.ts) && !(message.ts && $util.isInteger(message.ts.low) && $util.isInteger(message.ts.high)))
                    return "ts: integer|Long expected";
            if (message.granularity != null && message.hasOwnProperty("granularity"))
                switch (message.granularity) {
                default:
                    return "granularity: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                    break;
                }
            return null;
        };

        /**
         * Creates a Date message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof common.Date
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {common.Date} Date
         */
        Date.fromObject = function fromObject(object) {
            if (object instanceof $root.common.Date)
                return object;
            let message = new $root.common.Date();
            if (object.year != null)
                message.year = object.year | 0;
            if (object.month != null)
                message.month = object.month | 0;
            if (object.day != null)
                message.day = object.day | 0;
            if (object.hour != null)
                message.hour = object.hour | 0;
            if (object.minute != null)
                message.minute = object.minute | 0;
            if (object.second != null)
                message.second = object.second | 0;
            if (object.tz != null)
                message.tz = String(object.tz);
            if (object.ts != null)
                if ($util.Long)
                    (message.ts = $util.Long.fromValue(object.ts)).unsigned = false;
                else if (typeof object.ts === "string")
                    message.ts = parseInt(object.ts, 10);
                else if (typeof object.ts === "number")
                    message.ts = object.ts;
                else if (typeof object.ts === "object")
                    message.ts = new $util.LongBits(object.ts.low >>> 0, object.ts.high >>> 0).toNumber();
            switch (object.granularity) {
            default:
                if (typeof object.granularity === "number") {
                    message.granularity = object.granularity;
                    break;
                }
                break;
            case "no_granularity":
            case 0:
                message.granularity = 0;
                break;
            case "year":
            case 1:
                message.granularity = 1;
                break;
            case "month":
            case 2:
                message.granularity = 2;
                break;
            case "day":
            case 3:
                message.granularity = 3;
                break;
            case "hour":
            case 4:
                message.granularity = 4;
                break;
            case "minute":
            case 5:
                message.granularity = 5;
                break;
            case "second":
            case 6:
                message.granularity = 6;
                break;
            }
            return message;
        };

        /**
         * Creates a plain object from a Date message. Also converts values to other types if specified.
         * @function toObject
         * @memberof common.Date
         * @static
         * @param {common.Date} message Date
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Date.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.year = 0;
                object.month = 0;
                object.day = 0;
                object.hour = 0;
                object.minute = 0;
                object.second = 0;
                object.tz = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.ts = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.ts = options.longs === String ? "0" : 0;
                object.granularity = options.enums === String ? "no_granularity" : 0;
            }
            if (message.year != null && message.hasOwnProperty("year"))
                object.year = message.year;
            if (message.month != null && message.hasOwnProperty("month"))
                object.month = message.month;
            if (message.day != null && message.hasOwnProperty("day"))
                object.day = message.day;
            if (message.hour != null && message.hasOwnProperty("hour"))
                object.hour = message.hour;
            if (message.minute != null && message.hasOwnProperty("minute"))
                object.minute = message.minute;
            if (message.second != null && message.hasOwnProperty("second"))
                object.second = message.second;
            if (message.tz != null && message.hasOwnProperty("tz"))
                object.tz = message.tz;
            if (message.ts != null && message.hasOwnProperty("ts"))
                if (typeof message.ts === "number")
                    object.ts = options.longs === String ? String(message.ts) : message.ts;
                else
                    object.ts = options.longs === String ? $util.Long.prototype.toString.call(message.ts) : options.longs === Number ? new $util.LongBits(message.ts.low >>> 0, message.ts.high >>> 0).toNumber() : message.ts;
            if (message.granularity != null && message.hasOwnProperty("granularity"))
                object.granularity = options.enums === String ? $root.common.DateGranularity[message.granularity] === undefined ? message.granularity : $root.common.DateGranularity[message.granularity] : message.granularity;
            return object;
        };

        /**
         * Converts this Date to JSON.
         * @function toJSON
         * @memberof common.Date
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Date.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Date
         * @function getTypeUrl
         * @memberof common.Date
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Date.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/common.Date";
        };

        return Date;
    })();

    /**
     * DateGranularity enum.
     * @name common.DateGranularity
     * @enum {number}
     * @property {number} no_granularity=0 no_granularity value
     * @property {number} year=1 year value
     * @property {number} month=2 month value
     * @property {number} day=3 day value
     * @property {number} hour=4 hour value
     * @property {number} minute=5 minute value
     * @property {number} second=6 second value
     */
    common.DateGranularity = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "no_granularity"] = 0;
        values[valuesById[1] = "year"] = 1;
        values[valuesById[2] = "month"] = 2;
        values[valuesById[3] = "day"] = 3;
        values[valuesById[4] = "hour"] = 4;
        values[valuesById[5] = "minute"] = 5;
        values[valuesById[6] = "second"] = 6;
        return values;
    })();

    /**
     * Ordering enum.
     * @name common.Ordering
     * @enum {number}
     * @property {number} ordering_disabled=0 ordering_disabled value
     * @property {number} ascending=1 ascending value
     * @property {number} descending=2 descending value
     */
    common.Ordering = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "ordering_disabled"] = 0;
        values[valuesById[1] = "ascending"] = 1;
        values[valuesById[2] = "descending"] = 2;
        return values;
    })();

    common.Pagination = (function() {

        /**
         * Properties of a Pagination.
         * @memberof common
         * @interface IPagination
         * @property {number|null} [page] Pagination page
         * @property {number|null} [nPages] Pagination nPages
         * @property {number|null} [pageSize] Pagination pageSize
         * @property {number|null} [total] Pagination total
         * @property {number|null} [esTotal] Pagination esTotal
         */

        /**
         * Constructs a new Pagination.
         * @memberof common
         * @classdesc Represents a Pagination.
         * @implements IPagination
         * @constructor
         * @param {common.IPagination=} [properties] Properties to set
         */
        function Pagination(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Pagination page.
         * @member {number} page
         * @memberof common.Pagination
         * @instance
         */
        Pagination.prototype.page = 0;

        /**
         * Pagination nPages.
         * @member {number} nPages
         * @memberof common.Pagination
         * @instance
         */
        Pagination.prototype.nPages = 0;

        /**
         * Pagination pageSize.
         * @member {number} pageSize
         * @memberof common.Pagination
         * @instance
         */
        Pagination.prototype.pageSize = 0;

        /**
         * Pagination total.
         * @member {number} total
         * @memberof common.Pagination
         * @instance
         */
        Pagination.prototype.total = 0;

        /**
         * Pagination esTotal.
         * @member {number} esTotal
         * @memberof common.Pagination
         * @instance
         */
        Pagination.prototype.esTotal = 0;

        /**
         * Creates a new Pagination instance using the specified properties.
         * @function create
         * @memberof common.Pagination
         * @static
         * @param {common.IPagination=} [properties] Properties to set
         * @returns {common.Pagination} Pagination instance
         */
        Pagination.create = function create(properties) {
            return new Pagination(properties);
        };

        /**
         * Encodes the specified Pagination message. Does not implicitly {@link common.Pagination.verify|verify} messages.
         * @function encode
         * @memberof common.Pagination
         * @static
         * @param {common.IPagination} message Pagination message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Pagination.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.page != null && Object.hasOwnProperty.call(message, "page"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.page);
            if (message.nPages != null && Object.hasOwnProperty.call(message, "nPages"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.nPages);
            if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.pageSize);
            if (message.total != null && Object.hasOwnProperty.call(message, "total"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.total);
            if (message.esTotal != null && Object.hasOwnProperty.call(message, "esTotal"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.esTotal);
            return writer;
        };

        /**
         * Encodes the specified Pagination message, length delimited. Does not implicitly {@link common.Pagination.verify|verify} messages.
         * @function encodeDelimited
         * @memberof common.Pagination
         * @static
         * @param {common.IPagination} message Pagination message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Pagination.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Pagination message from the specified reader or buffer.
         * @function decode
         * @memberof common.Pagination
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {common.Pagination} Pagination
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Pagination.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.common.Pagination();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.page = reader.int32();
                        break;
                    }
                case 2: {
                        message.nPages = reader.int32();
                        break;
                    }
                case 3: {
                        message.pageSize = reader.int32();
                        break;
                    }
                case 4: {
                        message.total = reader.int32();
                        break;
                    }
                case 5: {
                        message.esTotal = reader.int32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Pagination message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof common.Pagination
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {common.Pagination} Pagination
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Pagination.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Pagination message.
         * @function verify
         * @memberof common.Pagination
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Pagination.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.page != null && message.hasOwnProperty("page"))
                if (!$util.isInteger(message.page))
                    return "page: integer expected";
            if (message.nPages != null && message.hasOwnProperty("nPages"))
                if (!$util.isInteger(message.nPages))
                    return "nPages: integer expected";
            if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                if (!$util.isInteger(message.pageSize))
                    return "pageSize: integer expected";
            if (message.total != null && message.hasOwnProperty("total"))
                if (!$util.isInteger(message.total))
                    return "total: integer expected";
            if (message.esTotal != null && message.hasOwnProperty("esTotal"))
                if (!$util.isInteger(message.esTotal))
                    return "esTotal: integer expected";
            return null;
        };

        /**
         * Creates a Pagination message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof common.Pagination
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {common.Pagination} Pagination
         */
        Pagination.fromObject = function fromObject(object) {
            if (object instanceof $root.common.Pagination)
                return object;
            let message = new $root.common.Pagination();
            if (object.page != null)
                message.page = object.page | 0;
            if (object.nPages != null)
                message.nPages = object.nPages | 0;
            if (object.pageSize != null)
                message.pageSize = object.pageSize | 0;
            if (object.total != null)
                message.total = object.total | 0;
            if (object.esTotal != null)
                message.esTotal = object.esTotal | 0;
            return message;
        };

        /**
         * Creates a plain object from a Pagination message. Also converts values to other types if specified.
         * @function toObject
         * @memberof common.Pagination
         * @static
         * @param {common.Pagination} message Pagination
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Pagination.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.page = 0;
                object.nPages = 0;
                object.pageSize = 0;
                object.total = 0;
                object.esTotal = 0;
            }
            if (message.page != null && message.hasOwnProperty("page"))
                object.page = message.page;
            if (message.nPages != null && message.hasOwnProperty("nPages"))
                object.nPages = message.nPages;
            if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                object.pageSize = message.pageSize;
            if (message.total != null && message.hasOwnProperty("total"))
                object.total = message.total;
            if (message.esTotal != null && message.hasOwnProperty("esTotal"))
                object.esTotal = message.esTotal;
            return object;
        };

        /**
         * Converts this Pagination to JSON.
         * @function toJSON
         * @memberof common.Pagination
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Pagination.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Pagination
         * @function getTypeUrl
         * @memberof common.Pagination
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Pagination.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/common.Pagination";
        };

        return Pagination;
    })();

    common.Href = (function() {

        /**
         * Properties of a Href.
         * @memberof common
         * @interface IHref
         * @property {string|null} [url] Href url
         * @property {string|null} [text] Href text
         * @property {boolean|null} [newTab] Href newTab
         */

        /**
         * Constructs a new Href.
         * @memberof common
         * @classdesc Represents a Href.
         * @implements IHref
         * @constructor
         * @param {common.IHref=} [properties] Properties to set
         */
        function Href(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Href url.
         * @member {string} url
         * @memberof common.Href
         * @instance
         */
        Href.prototype.url = "";

        /**
         * Href text.
         * @member {string} text
         * @memberof common.Href
         * @instance
         */
        Href.prototype.text = "";

        /**
         * Href newTab.
         * @member {boolean} newTab
         * @memberof common.Href
         * @instance
         */
        Href.prototype.newTab = false;

        /**
         * Creates a new Href instance using the specified properties.
         * @function create
         * @memberof common.Href
         * @static
         * @param {common.IHref=} [properties] Properties to set
         * @returns {common.Href} Href instance
         */
        Href.create = function create(properties) {
            return new Href(properties);
        };

        /**
         * Encodes the specified Href message. Does not implicitly {@link common.Href.verify|verify} messages.
         * @function encode
         * @memberof common.Href
         * @static
         * @param {common.IHref} message Href message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Href.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.url != null && Object.hasOwnProperty.call(message, "url"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.url);
            if (message.text != null && Object.hasOwnProperty.call(message, "text"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.text);
            if (message.newTab != null && Object.hasOwnProperty.call(message, "newTab"))
                writer.uint32(/* id 3, wireType 0 =*/24).bool(message.newTab);
            return writer;
        };

        /**
         * Encodes the specified Href message, length delimited. Does not implicitly {@link common.Href.verify|verify} messages.
         * @function encodeDelimited
         * @memberof common.Href
         * @static
         * @param {common.IHref} message Href message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Href.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Href message from the specified reader or buffer.
         * @function decode
         * @memberof common.Href
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {common.Href} Href
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Href.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.common.Href();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.url = reader.string();
                        break;
                    }
                case 2: {
                        message.text = reader.string();
                        break;
                    }
                case 3: {
                        message.newTab = reader.bool();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Href message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof common.Href
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {common.Href} Href
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Href.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Href message.
         * @function verify
         * @memberof common.Href
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Href.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.url != null && message.hasOwnProperty("url"))
                if (!$util.isString(message.url))
                    return "url: string expected";
            if (message.text != null && message.hasOwnProperty("text"))
                if (!$util.isString(message.text))
                    return "text: string expected";
            if (message.newTab != null && message.hasOwnProperty("newTab"))
                if (typeof message.newTab !== "boolean")
                    return "newTab: boolean expected";
            return null;
        };

        /**
         * Creates a Href message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof common.Href
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {common.Href} Href
         */
        Href.fromObject = function fromObject(object) {
            if (object instanceof $root.common.Href)
                return object;
            let message = new $root.common.Href();
            if (object.url != null)
                message.url = String(object.url);
            if (object.text != null)
                message.text = String(object.text);
            if (object.newTab != null)
                message.newTab = Boolean(object.newTab);
            return message;
        };

        /**
         * Creates a plain object from a Href message. Also converts values to other types if specified.
         * @function toObject
         * @memberof common.Href
         * @static
         * @param {common.Href} message Href
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Href.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.url = "";
                object.text = "";
                object.newTab = false;
            }
            if (message.url != null && message.hasOwnProperty("url"))
                object.url = message.url;
            if (message.text != null && message.hasOwnProperty("text"))
                object.text = message.text;
            if (message.newTab != null && message.hasOwnProperty("newTab"))
                object.newTab = message.newTab;
            return object;
        };

        /**
         * Converts this Href to JSON.
         * @function toJSON
         * @memberof common.Href
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Href.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Href
         * @function getTypeUrl
         * @memberof common.Href
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Href.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/common.Href";
        };

        return Href;
    })();

    return common;
})();

export const inputs = $root.inputs = (() => {

    /**
     * Namespace inputs.
     * @exports inputs
     * @namespace
     */
    const inputs = {};

    inputs.FileInput = (function() {

        /**
         * Properties of a FileInput.
         * @memberof inputs
         * @interface IFileInput
         * @property {uploader.IUFile|null} [value] FileInput value
         * @property {Array.<string>|null} [extensions] FileInput extensions
         */

        /**
         * Constructs a new FileInput.
         * @memberof inputs
         * @classdesc Represents a FileInput.
         * @implements IFileInput
         * @constructor
         * @param {inputs.IFileInput=} [properties] Properties to set
         */
        function FileInput(properties) {
            this.extensions = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * FileInput value.
         * @member {uploader.IUFile|null|undefined} value
         * @memberof inputs.FileInput
         * @instance
         */
        FileInput.prototype.value = null;

        /**
         * FileInput extensions.
         * @member {Array.<string>} extensions
         * @memberof inputs.FileInput
         * @instance
         */
        FileInput.prototype.extensions = $util.emptyArray;

        /**
         * Creates a new FileInput instance using the specified properties.
         * @function create
         * @memberof inputs.FileInput
         * @static
         * @param {inputs.IFileInput=} [properties] Properties to set
         * @returns {inputs.FileInput} FileInput instance
         */
        FileInput.create = function create(properties) {
            return new FileInput(properties);
        };

        /**
         * Encodes the specified FileInput message. Does not implicitly {@link inputs.FileInput.verify|verify} messages.
         * @function encode
         * @memberof inputs.FileInput
         * @static
         * @param {inputs.IFileInput} message FileInput message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FileInput.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                $root.uploader.UFile.encode(message.value, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.extensions != null && message.extensions.length)
                for (let i = 0; i < message.extensions.length; ++i)
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.extensions[i]);
            return writer;
        };

        /**
         * Encodes the specified FileInput message, length delimited. Does not implicitly {@link inputs.FileInput.verify|verify} messages.
         * @function encodeDelimited
         * @memberof inputs.FileInput
         * @static
         * @param {inputs.IFileInput} message FileInput message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FileInput.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a FileInput message from the specified reader or buffer.
         * @function decode
         * @memberof inputs.FileInput
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {inputs.FileInput} FileInput
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FileInput.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.inputs.FileInput();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.value = $root.uploader.UFile.decode(reader, reader.uint32());
                        break;
                    }
                case 2: {
                        if (!(message.extensions && message.extensions.length))
                            message.extensions = [];
                        message.extensions.push(reader.string());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a FileInput message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof inputs.FileInput
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {inputs.FileInput} FileInput
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FileInput.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a FileInput message.
         * @function verify
         * @memberof inputs.FileInput
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        FileInput.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.value != null && message.hasOwnProperty("value")) {
                let error = $root.uploader.UFile.verify(message.value);
                if (error)
                    return "value." + error;
            }
            if (message.extensions != null && message.hasOwnProperty("extensions")) {
                if (!Array.isArray(message.extensions))
                    return "extensions: array expected";
                for (let i = 0; i < message.extensions.length; ++i)
                    if (!$util.isString(message.extensions[i]))
                        return "extensions: string[] expected";
            }
            return null;
        };

        /**
         * Creates a FileInput message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof inputs.FileInput
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {inputs.FileInput} FileInput
         */
        FileInput.fromObject = function fromObject(object) {
            if (object instanceof $root.inputs.FileInput)
                return object;
            let message = new $root.inputs.FileInput();
            if (object.value != null) {
                if (typeof object.value !== "object")
                    throw TypeError(".inputs.FileInput.value: object expected");
                message.value = $root.uploader.UFile.fromObject(object.value);
            }
            if (object.extensions) {
                if (!Array.isArray(object.extensions))
                    throw TypeError(".inputs.FileInput.extensions: array expected");
                message.extensions = [];
                for (let i = 0; i < object.extensions.length; ++i)
                    message.extensions[i] = String(object.extensions[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from a FileInput message. Also converts values to other types if specified.
         * @function toObject
         * @memberof inputs.FileInput
         * @static
         * @param {inputs.FileInput} message FileInput
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        FileInput.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.extensions = [];
            if (options.defaults)
                object.value = null;
            if (message.value != null && message.hasOwnProperty("value"))
                object.value = $root.uploader.UFile.toObject(message.value, options);
            if (message.extensions && message.extensions.length) {
                object.extensions = [];
                for (let j = 0; j < message.extensions.length; ++j)
                    object.extensions[j] = message.extensions[j];
            }
            return object;
        };

        /**
         * Converts this FileInput to JSON.
         * @function toJSON
         * @memberof inputs.FileInput
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        FileInput.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for FileInput
         * @function getTypeUrl
         * @memberof inputs.FileInput
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        FileInput.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/inputs.FileInput";
        };

        return FileInput;
    })();

    return inputs;
})();

export const uploader = $root.uploader = (() => {

    /**
     * Namespace uploader.
     * @exports uploader
     * @namespace
     */
    const uploader = {};

    uploader.UploadTask = (function() {

        /**
         * Properties of an UploadTask.
         * @memberof uploader
         * @interface IUploadTask
         * @property {number|Long|null} [created] UploadTask created
         * @property {string|null} [path] UploadTask path
         * @property {string|null} [name] UploadTask name
         * @property {string|null} [mime] UploadTask mime
         * @property {uploader.UploadStatus|null} [status] UploadTask status
         * @property {number|null} [retryCounter] UploadTask retryCounter
         * @property {string|null} [error] UploadTask error
         * @property {string|null} [fingerprint] UploadTask fingerprint
         * @property {string|null} [url] UploadTask url
         * @property {Object.<string,string>|null} [metadata] UploadTask metadata
         */

        /**
         * Constructs a new UploadTask.
         * @memberof uploader
         * @classdesc Represents an UploadTask.
         * @implements IUploadTask
         * @constructor
         * @param {uploader.IUploadTask=} [properties] Properties to set
         */
        function UploadTask(properties) {
            this.metadata = {};
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UploadTask created.
         * @member {number|Long} created
         * @memberof uploader.UploadTask
         * @instance
         */
        UploadTask.prototype.created = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * UploadTask path.
         * @member {string} path
         * @memberof uploader.UploadTask
         * @instance
         */
        UploadTask.prototype.path = "";

        /**
         * UploadTask name.
         * @member {string} name
         * @memberof uploader.UploadTask
         * @instance
         */
        UploadTask.prototype.name = "";

        /**
         * UploadTask mime.
         * @member {string} mime
         * @memberof uploader.UploadTask
         * @instance
         */
        UploadTask.prototype.mime = "";

        /**
         * UploadTask status.
         * @member {uploader.UploadStatus} status
         * @memberof uploader.UploadTask
         * @instance
         */
        UploadTask.prototype.status = 0;

        /**
         * UploadTask retryCounter.
         * @member {number} retryCounter
         * @memberof uploader.UploadTask
         * @instance
         */
        UploadTask.prototype.retryCounter = 0;

        /**
         * UploadTask error.
         * @member {string} error
         * @memberof uploader.UploadTask
         * @instance
         */
        UploadTask.prototype.error = "";

        /**
         * UploadTask fingerprint.
         * @member {string} fingerprint
         * @memberof uploader.UploadTask
         * @instance
         */
        UploadTask.prototype.fingerprint = "";

        /**
         * UploadTask url.
         * @member {string} url
         * @memberof uploader.UploadTask
         * @instance
         */
        UploadTask.prototype.url = "";

        /**
         * UploadTask metadata.
         * @member {Object.<string,string>} metadata
         * @memberof uploader.UploadTask
         * @instance
         */
        UploadTask.prototype.metadata = $util.emptyObject;

        /**
         * Creates a new UploadTask instance using the specified properties.
         * @function create
         * @memberof uploader.UploadTask
         * @static
         * @param {uploader.IUploadTask=} [properties] Properties to set
         * @returns {uploader.UploadTask} UploadTask instance
         */
        UploadTask.create = function create(properties) {
            return new UploadTask(properties);
        };

        /**
         * Encodes the specified UploadTask message. Does not implicitly {@link uploader.UploadTask.verify|verify} messages.
         * @function encode
         * @memberof uploader.UploadTask
         * @static
         * @param {uploader.IUploadTask} message UploadTask message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UploadTask.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.created != null && Object.hasOwnProperty.call(message, "created"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.created);
            if (message.path != null && Object.hasOwnProperty.call(message, "path"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.path);
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.name);
            if (message.mime != null && Object.hasOwnProperty.call(message, "mime"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.mime);
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.status);
            if (message.retryCounter != null && Object.hasOwnProperty.call(message, "retryCounter"))
                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.retryCounter);
            if (message.error != null && Object.hasOwnProperty.call(message, "error"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.error);
            if (message.fingerprint != null && Object.hasOwnProperty.call(message, "fingerprint"))
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.fingerprint);
            if (message.url != null && Object.hasOwnProperty.call(message, "url"))
                writer.uint32(/* id 9, wireType 2 =*/74).string(message.url);
            if (message.metadata != null && Object.hasOwnProperty.call(message, "metadata"))
                for (let keys = Object.keys(message.metadata), i = 0; i < keys.length; ++i)
                    writer.uint32(/* id 10, wireType 2 =*/82).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.metadata[keys[i]]).ldelim();
            return writer;
        };

        /**
         * Encodes the specified UploadTask message, length delimited. Does not implicitly {@link uploader.UploadTask.verify|verify} messages.
         * @function encodeDelimited
         * @memberof uploader.UploadTask
         * @static
         * @param {uploader.IUploadTask} message UploadTask message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UploadTask.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an UploadTask message from the specified reader or buffer.
         * @function decode
         * @memberof uploader.UploadTask
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {uploader.UploadTask} UploadTask
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UploadTask.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.uploader.UploadTask(), key, value;
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.created = reader.uint64();
                        break;
                    }
                case 2: {
                        message.path = reader.string();
                        break;
                    }
                case 3: {
                        message.name = reader.string();
                        break;
                    }
                case 4: {
                        message.mime = reader.string();
                        break;
                    }
                case 5: {
                        message.status = reader.int32();
                        break;
                    }
                case 6: {
                        message.retryCounter = reader.int32();
                        break;
                    }
                case 7: {
                        message.error = reader.string();
                        break;
                    }
                case 8: {
                        message.fingerprint = reader.string();
                        break;
                    }
                case 9: {
                        message.url = reader.string();
                        break;
                    }
                case 10: {
                        if (message.metadata === $util.emptyObject)
                            message.metadata = {};
                        let end2 = reader.uint32() + reader.pos;
                        key = "";
                        value = "";
                        while (reader.pos < end2) {
                            let tag2 = reader.uint32();
                            switch (tag2 >>> 3) {
                            case 1:
                                key = reader.string();
                                break;
                            case 2:
                                value = reader.string();
                                break;
                            default:
                                reader.skipType(tag2 & 7);
                                break;
                            }
                        }
                        message.metadata[key] = value;
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an UploadTask message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof uploader.UploadTask
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {uploader.UploadTask} UploadTask
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UploadTask.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an UploadTask message.
         * @function verify
         * @memberof uploader.UploadTask
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UploadTask.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.created != null && message.hasOwnProperty("created"))
                if (!$util.isInteger(message.created) && !(message.created && $util.isInteger(message.created.low) && $util.isInteger(message.created.high)))
                    return "created: integer|Long expected";
            if (message.path != null && message.hasOwnProperty("path"))
                if (!$util.isString(message.path))
                    return "path: string expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            if (message.mime != null && message.hasOwnProperty("mime"))
                if (!$util.isString(message.mime))
                    return "mime: string expected";
            if (message.status != null && message.hasOwnProperty("status"))
                switch (message.status) {
                default:
                    return "status: enum value expected";
                case 0:
                case 1:
                case 3:
                case 4:
                case 5:
                case 6:
                    break;
                }
            if (message.retryCounter != null && message.hasOwnProperty("retryCounter"))
                if (!$util.isInteger(message.retryCounter))
                    return "retryCounter: integer expected";
            if (message.error != null && message.hasOwnProperty("error"))
                if (!$util.isString(message.error))
                    return "error: string expected";
            if (message.fingerprint != null && message.hasOwnProperty("fingerprint"))
                if (!$util.isString(message.fingerprint))
                    return "fingerprint: string expected";
            if (message.url != null && message.hasOwnProperty("url"))
                if (!$util.isString(message.url))
                    return "url: string expected";
            if (message.metadata != null && message.hasOwnProperty("metadata")) {
                if (!$util.isObject(message.metadata))
                    return "metadata: object expected";
                let key = Object.keys(message.metadata);
                for (let i = 0; i < key.length; ++i)
                    if (!$util.isString(message.metadata[key[i]]))
                        return "metadata: string{k:string} expected";
            }
            return null;
        };

        /**
         * Creates an UploadTask message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof uploader.UploadTask
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {uploader.UploadTask} UploadTask
         */
        UploadTask.fromObject = function fromObject(object) {
            if (object instanceof $root.uploader.UploadTask)
                return object;
            let message = new $root.uploader.UploadTask();
            if (object.created != null)
                if ($util.Long)
                    (message.created = $util.Long.fromValue(object.created)).unsigned = true;
                else if (typeof object.created === "string")
                    message.created = parseInt(object.created, 10);
                else if (typeof object.created === "number")
                    message.created = object.created;
                else if (typeof object.created === "object")
                    message.created = new $util.LongBits(object.created.low >>> 0, object.created.high >>> 0).toNumber(true);
            if (object.path != null)
                message.path = String(object.path);
            if (object.name != null)
                message.name = String(object.name);
            if (object.mime != null)
                message.mime = String(object.mime);
            switch (object.status) {
            default:
                if (typeof object.status === "number") {
                    message.status = object.status;
                    break;
                }
                break;
            case "scheduled":
            case 0:
                message.status = 0;
                break;
            case "uploading":
            case 1:
                message.status = 1;
                break;
            case "paused":
            case 3:
                message.status = 3;
                break;
            case "done":
            case 4:
                message.status = 4;
                break;
            case "error":
            case 5:
                message.status = 5;
                break;
            case "restored":
            case 6:
                message.status = 6;
                break;
            }
            if (object.retryCounter != null)
                message.retryCounter = object.retryCounter | 0;
            if (object.error != null)
                message.error = String(object.error);
            if (object.fingerprint != null)
                message.fingerprint = String(object.fingerprint);
            if (object.url != null)
                message.url = String(object.url);
            if (object.metadata) {
                if (typeof object.metadata !== "object")
                    throw TypeError(".uploader.UploadTask.metadata: object expected");
                message.metadata = {};
                for (let keys = Object.keys(object.metadata), i = 0; i < keys.length; ++i)
                    message.metadata[keys[i]] = String(object.metadata[keys[i]]);
            }
            return message;
        };

        /**
         * Creates a plain object from an UploadTask message. Also converts values to other types if specified.
         * @function toObject
         * @memberof uploader.UploadTask
         * @static
         * @param {uploader.UploadTask} message UploadTask
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UploadTask.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.objects || options.defaults)
                object.metadata = {};
            if (options.defaults) {
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.created = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.created = options.longs === String ? "0" : 0;
                object.path = "";
                object.name = "";
                object.mime = "";
                object.status = options.enums === String ? "scheduled" : 0;
                object.retryCounter = 0;
                object.error = "";
                object.fingerprint = "";
                object.url = "";
            }
            if (message.created != null && message.hasOwnProperty("created"))
                if (typeof message.created === "number")
                    object.created = options.longs === String ? String(message.created) : message.created;
                else
                    object.created = options.longs === String ? $util.Long.prototype.toString.call(message.created) : options.longs === Number ? new $util.LongBits(message.created.low >>> 0, message.created.high >>> 0).toNumber(true) : message.created;
            if (message.path != null && message.hasOwnProperty("path"))
                object.path = message.path;
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.mime != null && message.hasOwnProperty("mime"))
                object.mime = message.mime;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = options.enums === String ? $root.uploader.UploadStatus[message.status] === undefined ? message.status : $root.uploader.UploadStatus[message.status] : message.status;
            if (message.retryCounter != null && message.hasOwnProperty("retryCounter"))
                object.retryCounter = message.retryCounter;
            if (message.error != null && message.hasOwnProperty("error"))
                object.error = message.error;
            if (message.fingerprint != null && message.hasOwnProperty("fingerprint"))
                object.fingerprint = message.fingerprint;
            if (message.url != null && message.hasOwnProperty("url"))
                object.url = message.url;
            let keys2;
            if (message.metadata && (keys2 = Object.keys(message.metadata)).length) {
                object.metadata = {};
                for (let j = 0; j < keys2.length; ++j)
                    object.metadata[keys2[j]] = message.metadata[keys2[j]];
            }
            return object;
        };

        /**
         * Converts this UploadTask to JSON.
         * @function toJSON
         * @memberof uploader.UploadTask
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UploadTask.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for UploadTask
         * @function getTypeUrl
         * @memberof uploader.UploadTask
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        UploadTask.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/uploader.UploadTask";
        };

        return UploadTask;
    })();

    /**
     * UploadStatus enum.
     * @name uploader.UploadStatus
     * @enum {number}
     * @property {number} scheduled=0 scheduled value
     * @property {number} uploading=1 uploading value
     * @property {number} paused=3 paused value
     * @property {number} done=4 done value
     * @property {number} error=5 error value
     * @property {number} restored=6 restored value
     */
    uploader.UploadStatus = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "scheduled"] = 0;
        values[valuesById[1] = "uploading"] = 1;
        values[valuesById[3] = "paused"] = 3;
        values[valuesById[4] = "done"] = 4;
        values[valuesById[5] = "error"] = 5;
        values[valuesById[6] = "restored"] = 6;
        return values;
    })();

    uploader.UploadUFile = (function() {

        /**
         * Properties of an UploadUFile.
         * @memberof uploader
         * @interface IUploadUFile
         * @property {string|null} [fileId] UploadUFile fileId
         * @property {uploader.IUploadTask|null} [task] UploadUFile task
         */

        /**
         * Constructs a new UploadUFile.
         * @memberof uploader
         * @classdesc Represents an UploadUFile.
         * @implements IUploadUFile
         * @constructor
         * @param {uploader.IUploadUFile=} [properties] Properties to set
         */
        function UploadUFile(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UploadUFile fileId.
         * @member {string} fileId
         * @memberof uploader.UploadUFile
         * @instance
         */
        UploadUFile.prototype.fileId = "";

        /**
         * UploadUFile task.
         * @member {uploader.IUploadTask|null|undefined} task
         * @memberof uploader.UploadUFile
         * @instance
         */
        UploadUFile.prototype.task = null;

        /**
         * Creates a new UploadUFile instance using the specified properties.
         * @function create
         * @memberof uploader.UploadUFile
         * @static
         * @param {uploader.IUploadUFile=} [properties] Properties to set
         * @returns {uploader.UploadUFile} UploadUFile instance
         */
        UploadUFile.create = function create(properties) {
            return new UploadUFile(properties);
        };

        /**
         * Encodes the specified UploadUFile message. Does not implicitly {@link uploader.UploadUFile.verify|verify} messages.
         * @function encode
         * @memberof uploader.UploadUFile
         * @static
         * @param {uploader.IUploadUFile} message UploadUFile message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UploadUFile.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.fileId != null && Object.hasOwnProperty.call(message, "fileId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.fileId);
            if (message.task != null && Object.hasOwnProperty.call(message, "task"))
                $root.uploader.UploadTask.encode(message.task, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified UploadUFile message, length delimited. Does not implicitly {@link uploader.UploadUFile.verify|verify} messages.
         * @function encodeDelimited
         * @memberof uploader.UploadUFile
         * @static
         * @param {uploader.IUploadUFile} message UploadUFile message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UploadUFile.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an UploadUFile message from the specified reader or buffer.
         * @function decode
         * @memberof uploader.UploadUFile
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {uploader.UploadUFile} UploadUFile
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UploadUFile.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.uploader.UploadUFile();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.fileId = reader.string();
                        break;
                    }
                case 2: {
                        message.task = $root.uploader.UploadTask.decode(reader, reader.uint32());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an UploadUFile message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof uploader.UploadUFile
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {uploader.UploadUFile} UploadUFile
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UploadUFile.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an UploadUFile message.
         * @function verify
         * @memberof uploader.UploadUFile
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UploadUFile.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.fileId != null && message.hasOwnProperty("fileId"))
                if (!$util.isString(message.fileId))
                    return "fileId: string expected";
            if (message.task != null && message.hasOwnProperty("task")) {
                let error = $root.uploader.UploadTask.verify(message.task);
                if (error)
                    return "task." + error;
            }
            return null;
        };

        /**
         * Creates an UploadUFile message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof uploader.UploadUFile
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {uploader.UploadUFile} UploadUFile
         */
        UploadUFile.fromObject = function fromObject(object) {
            if (object instanceof $root.uploader.UploadUFile)
                return object;
            let message = new $root.uploader.UploadUFile();
            if (object.fileId != null)
                message.fileId = String(object.fileId);
            if (object.task != null) {
                if (typeof object.task !== "object")
                    throw TypeError(".uploader.UploadUFile.task: object expected");
                message.task = $root.uploader.UploadTask.fromObject(object.task);
            }
            return message;
        };

        /**
         * Creates a plain object from an UploadUFile message. Also converts values to other types if specified.
         * @function toObject
         * @memberof uploader.UploadUFile
         * @static
         * @param {uploader.UploadUFile} message UploadUFile
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UploadUFile.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.fileId = "";
                object.task = null;
            }
            if (message.fileId != null && message.hasOwnProperty("fileId"))
                object.fileId = message.fileId;
            if (message.task != null && message.hasOwnProperty("task"))
                object.task = $root.uploader.UploadTask.toObject(message.task, options);
            return object;
        };

        /**
         * Converts this UploadUFile to JSON.
         * @function toJSON
         * @memberof uploader.UploadUFile
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UploadUFile.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for UploadUFile
         * @function getTypeUrl
         * @memberof uploader.UploadUFile
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        UploadUFile.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/uploader.UploadUFile";
        };

        return UploadUFile;
    })();

    uploader.DeleteUFile = (function() {

        /**
         * Properties of a DeleteUFile.
         * @memberof uploader
         * @interface IDeleteUFile
         * @property {string|null} [id] DeleteUFile id
         */

        /**
         * Constructs a new DeleteUFile.
         * @memberof uploader
         * @classdesc Represents a DeleteUFile.
         * @implements IDeleteUFile
         * @constructor
         * @param {uploader.IDeleteUFile=} [properties] Properties to set
         */
        function DeleteUFile(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * DeleteUFile id.
         * @member {string} id
         * @memberof uploader.DeleteUFile
         * @instance
         */
        DeleteUFile.prototype.id = "";

        /**
         * Creates a new DeleteUFile instance using the specified properties.
         * @function create
         * @memberof uploader.DeleteUFile
         * @static
         * @param {uploader.IDeleteUFile=} [properties] Properties to set
         * @returns {uploader.DeleteUFile} DeleteUFile instance
         */
        DeleteUFile.create = function create(properties) {
            return new DeleteUFile(properties);
        };

        /**
         * Encodes the specified DeleteUFile message. Does not implicitly {@link uploader.DeleteUFile.verify|verify} messages.
         * @function encode
         * @memberof uploader.DeleteUFile
         * @static
         * @param {uploader.IDeleteUFile} message DeleteUFile message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DeleteUFile.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            return writer;
        };

        /**
         * Encodes the specified DeleteUFile message, length delimited. Does not implicitly {@link uploader.DeleteUFile.verify|verify} messages.
         * @function encodeDelimited
         * @memberof uploader.DeleteUFile
         * @static
         * @param {uploader.IDeleteUFile} message DeleteUFile message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DeleteUFile.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a DeleteUFile message from the specified reader or buffer.
         * @function decode
         * @memberof uploader.DeleteUFile
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {uploader.DeleteUFile} DeleteUFile
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DeleteUFile.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.uploader.DeleteUFile();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.id = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a DeleteUFile message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof uploader.DeleteUFile
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {uploader.DeleteUFile} DeleteUFile
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DeleteUFile.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a DeleteUFile message.
         * @function verify
         * @memberof uploader.DeleteUFile
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        DeleteUFile.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            return null;
        };

        /**
         * Creates a DeleteUFile message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof uploader.DeleteUFile
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {uploader.DeleteUFile} DeleteUFile
         */
        DeleteUFile.fromObject = function fromObject(object) {
            if (object instanceof $root.uploader.DeleteUFile)
                return object;
            let message = new $root.uploader.DeleteUFile();
            if (object.id != null)
                message.id = String(object.id);
            return message;
        };

        /**
         * Creates a plain object from a DeleteUFile message. Also converts values to other types if specified.
         * @function toObject
         * @memberof uploader.DeleteUFile
         * @static
         * @param {uploader.DeleteUFile} message DeleteUFile
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DeleteUFile.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.id = "";
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            return object;
        };

        /**
         * Converts this DeleteUFile to JSON.
         * @function toJSON
         * @memberof uploader.DeleteUFile
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DeleteUFile.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for DeleteUFile
         * @function getTypeUrl
         * @memberof uploader.DeleteUFile
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        DeleteUFile.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/uploader.DeleteUFile";
        };

        return DeleteUFile;
    })();

    uploader.UploadSlot = (function() {

        /**
         * Properties of an UploadSlot.
         * @memberof uploader
         * @interface IUploadSlot
         * @property {uploader.IUFile|null} [file] UploadSlot file
         * @property {Object.<string,string>|null} [metadata] UploadSlot metadata
         */

        /**
         * Constructs a new UploadSlot.
         * @memberof uploader
         * @classdesc Represents an UploadSlot.
         * @implements IUploadSlot
         * @constructor
         * @param {uploader.IUploadSlot=} [properties] Properties to set
         */
        function UploadSlot(properties) {
            this.metadata = {};
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UploadSlot file.
         * @member {uploader.IUFile|null|undefined} file
         * @memberof uploader.UploadSlot
         * @instance
         */
        UploadSlot.prototype.file = null;

        /**
         * UploadSlot metadata.
         * @member {Object.<string,string>} metadata
         * @memberof uploader.UploadSlot
         * @instance
         */
        UploadSlot.prototype.metadata = $util.emptyObject;

        /**
         * Creates a new UploadSlot instance using the specified properties.
         * @function create
         * @memberof uploader.UploadSlot
         * @static
         * @param {uploader.IUploadSlot=} [properties] Properties to set
         * @returns {uploader.UploadSlot} UploadSlot instance
         */
        UploadSlot.create = function create(properties) {
            return new UploadSlot(properties);
        };

        /**
         * Encodes the specified UploadSlot message. Does not implicitly {@link uploader.UploadSlot.verify|verify} messages.
         * @function encode
         * @memberof uploader.UploadSlot
         * @static
         * @param {uploader.IUploadSlot} message UploadSlot message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UploadSlot.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.file != null && Object.hasOwnProperty.call(message, "file"))
                $root.uploader.UFile.encode(message.file, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.metadata != null && Object.hasOwnProperty.call(message, "metadata"))
                for (let keys = Object.keys(message.metadata), i = 0; i < keys.length; ++i)
                    writer.uint32(/* id 2, wireType 2 =*/18).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.metadata[keys[i]]).ldelim();
            return writer;
        };

        /**
         * Encodes the specified UploadSlot message, length delimited. Does not implicitly {@link uploader.UploadSlot.verify|verify} messages.
         * @function encodeDelimited
         * @memberof uploader.UploadSlot
         * @static
         * @param {uploader.IUploadSlot} message UploadSlot message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UploadSlot.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an UploadSlot message from the specified reader or buffer.
         * @function decode
         * @memberof uploader.UploadSlot
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {uploader.UploadSlot} UploadSlot
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UploadSlot.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.uploader.UploadSlot(), key, value;
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.file = $root.uploader.UFile.decode(reader, reader.uint32());
                        break;
                    }
                case 2: {
                        if (message.metadata === $util.emptyObject)
                            message.metadata = {};
                        let end2 = reader.uint32() + reader.pos;
                        key = "";
                        value = "";
                        while (reader.pos < end2) {
                            let tag2 = reader.uint32();
                            switch (tag2 >>> 3) {
                            case 1:
                                key = reader.string();
                                break;
                            case 2:
                                value = reader.string();
                                break;
                            default:
                                reader.skipType(tag2 & 7);
                                break;
                            }
                        }
                        message.metadata[key] = value;
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an UploadSlot message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof uploader.UploadSlot
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {uploader.UploadSlot} UploadSlot
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UploadSlot.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an UploadSlot message.
         * @function verify
         * @memberof uploader.UploadSlot
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UploadSlot.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.file != null && message.hasOwnProperty("file")) {
                let error = $root.uploader.UFile.verify(message.file);
                if (error)
                    return "file." + error;
            }
            if (message.metadata != null && message.hasOwnProperty("metadata")) {
                if (!$util.isObject(message.metadata))
                    return "metadata: object expected";
                let key = Object.keys(message.metadata);
                for (let i = 0; i < key.length; ++i)
                    if (!$util.isString(message.metadata[key[i]]))
                        return "metadata: string{k:string} expected";
            }
            return null;
        };

        /**
         * Creates an UploadSlot message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof uploader.UploadSlot
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {uploader.UploadSlot} UploadSlot
         */
        UploadSlot.fromObject = function fromObject(object) {
            if (object instanceof $root.uploader.UploadSlot)
                return object;
            let message = new $root.uploader.UploadSlot();
            if (object.file != null) {
                if (typeof object.file !== "object")
                    throw TypeError(".uploader.UploadSlot.file: object expected");
                message.file = $root.uploader.UFile.fromObject(object.file);
            }
            if (object.metadata) {
                if (typeof object.metadata !== "object")
                    throw TypeError(".uploader.UploadSlot.metadata: object expected");
                message.metadata = {};
                for (let keys = Object.keys(object.metadata), i = 0; i < keys.length; ++i)
                    message.metadata[keys[i]] = String(object.metadata[keys[i]]);
            }
            return message;
        };

        /**
         * Creates a plain object from an UploadSlot message. Also converts values to other types if specified.
         * @function toObject
         * @memberof uploader.UploadSlot
         * @static
         * @param {uploader.UploadSlot} message UploadSlot
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UploadSlot.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.objects || options.defaults)
                object.metadata = {};
            if (options.defaults)
                object.file = null;
            if (message.file != null && message.hasOwnProperty("file"))
                object.file = $root.uploader.UFile.toObject(message.file, options);
            let keys2;
            if (message.metadata && (keys2 = Object.keys(message.metadata)).length) {
                object.metadata = {};
                for (let j = 0; j < keys2.length; ++j)
                    object.metadata[keys2[j]] = message.metadata[keys2[j]];
            }
            return object;
        };

        /**
         * Converts this UploadSlot to JSON.
         * @function toJSON
         * @memberof uploader.UploadSlot
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UploadSlot.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for UploadSlot
         * @function getTypeUrl
         * @memberof uploader.UploadSlot
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        UploadSlot.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/uploader.UploadSlot";
        };

        return UploadSlot;
    })();

    uploader.UFile = (function() {

        /**
         * Properties of a UFile.
         * @memberof uploader
         * @interface IUFile
         * @property {string|null} [id] UFile id
         * @property {string|null} [src] UFile src
         * @property {string|null} [preview] UFile preview
         * @property {string|null} [previewLarge] UFile previewLarge
         * @property {string|null} [name] UFile name
         * @property {string|null} [uploadTask] UFile uploadTask
         * @property {string|null} [localPath] UFile localPath
         */

        /**
         * Constructs a new UFile.
         * @memberof uploader
         * @classdesc Represents a UFile.
         * @implements IUFile
         * @constructor
         * @param {uploader.IUFile=} [properties] Properties to set
         */
        function UFile(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UFile id.
         * @member {string} id
         * @memberof uploader.UFile
         * @instance
         */
        UFile.prototype.id = "";

        /**
         * UFile src.
         * @member {string} src
         * @memberof uploader.UFile
         * @instance
         */
        UFile.prototype.src = "";

        /**
         * UFile preview.
         * @member {string} preview
         * @memberof uploader.UFile
         * @instance
         */
        UFile.prototype.preview = "";

        /**
         * UFile previewLarge.
         * @member {string} previewLarge
         * @memberof uploader.UFile
         * @instance
         */
        UFile.prototype.previewLarge = "";

        /**
         * UFile name.
         * @member {string} name
         * @memberof uploader.UFile
         * @instance
         */
        UFile.prototype.name = "";

        /**
         * UFile uploadTask.
         * @member {string} uploadTask
         * @memberof uploader.UFile
         * @instance
         */
        UFile.prototype.uploadTask = "";

        /**
         * UFile localPath.
         * @member {string} localPath
         * @memberof uploader.UFile
         * @instance
         */
        UFile.prototype.localPath = "";

        /**
         * Creates a new UFile instance using the specified properties.
         * @function create
         * @memberof uploader.UFile
         * @static
         * @param {uploader.IUFile=} [properties] Properties to set
         * @returns {uploader.UFile} UFile instance
         */
        UFile.create = function create(properties) {
            return new UFile(properties);
        };

        /**
         * Encodes the specified UFile message. Does not implicitly {@link uploader.UFile.verify|verify} messages.
         * @function encode
         * @memberof uploader.UFile
         * @static
         * @param {uploader.IUFile} message UFile message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UFile.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            if (message.src != null && Object.hasOwnProperty.call(message, "src"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.src);
            if (message.preview != null && Object.hasOwnProperty.call(message, "preview"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.preview);
            if (message.previewLarge != null && Object.hasOwnProperty.call(message, "previewLarge"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.previewLarge);
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.name);
            if (message.uploadTask != null && Object.hasOwnProperty.call(message, "uploadTask"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.uploadTask);
            if (message.localPath != null && Object.hasOwnProperty.call(message, "localPath"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.localPath);
            return writer;
        };

        /**
         * Encodes the specified UFile message, length delimited. Does not implicitly {@link uploader.UFile.verify|verify} messages.
         * @function encodeDelimited
         * @memberof uploader.UFile
         * @static
         * @param {uploader.IUFile} message UFile message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UFile.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a UFile message from the specified reader or buffer.
         * @function decode
         * @memberof uploader.UFile
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {uploader.UFile} UFile
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UFile.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.uploader.UFile();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.id = reader.string();
                        break;
                    }
                case 2: {
                        message.src = reader.string();
                        break;
                    }
                case 3: {
                        message.preview = reader.string();
                        break;
                    }
                case 4: {
                        message.previewLarge = reader.string();
                        break;
                    }
                case 5: {
                        message.name = reader.string();
                        break;
                    }
                case 6: {
                        message.uploadTask = reader.string();
                        break;
                    }
                case 7: {
                        message.localPath = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a UFile message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof uploader.UFile
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {uploader.UFile} UFile
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UFile.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a UFile message.
         * @function verify
         * @memberof uploader.UFile
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UFile.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.src != null && message.hasOwnProperty("src"))
                if (!$util.isString(message.src))
                    return "src: string expected";
            if (message.preview != null && message.hasOwnProperty("preview"))
                if (!$util.isString(message.preview))
                    return "preview: string expected";
            if (message.previewLarge != null && message.hasOwnProperty("previewLarge"))
                if (!$util.isString(message.previewLarge))
                    return "previewLarge: string expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            if (message.uploadTask != null && message.hasOwnProperty("uploadTask"))
                if (!$util.isString(message.uploadTask))
                    return "uploadTask: string expected";
            if (message.localPath != null && message.hasOwnProperty("localPath"))
                if (!$util.isString(message.localPath))
                    return "localPath: string expected";
            return null;
        };

        /**
         * Creates a UFile message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof uploader.UFile
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {uploader.UFile} UFile
         */
        UFile.fromObject = function fromObject(object) {
            if (object instanceof $root.uploader.UFile)
                return object;
            let message = new $root.uploader.UFile();
            if (object.id != null)
                message.id = String(object.id);
            if (object.src != null)
                message.src = String(object.src);
            if (object.preview != null)
                message.preview = String(object.preview);
            if (object.previewLarge != null)
                message.previewLarge = String(object.previewLarge);
            if (object.name != null)
                message.name = String(object.name);
            if (object.uploadTask != null)
                message.uploadTask = String(object.uploadTask);
            if (object.localPath != null)
                message.localPath = String(object.localPath);
            return message;
        };

        /**
         * Creates a plain object from a UFile message. Also converts values to other types if specified.
         * @function toObject
         * @memberof uploader.UFile
         * @static
         * @param {uploader.UFile} message UFile
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UFile.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.id = "";
                object.src = "";
                object.preview = "";
                object.previewLarge = "";
                object.name = "";
                object.uploadTask = "";
                object.localPath = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.src != null && message.hasOwnProperty("src"))
                object.src = message.src;
            if (message.preview != null && message.hasOwnProperty("preview"))
                object.preview = message.preview;
            if (message.previewLarge != null && message.hasOwnProperty("previewLarge"))
                object.previewLarge = message.previewLarge;
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.uploadTask != null && message.hasOwnProperty("uploadTask"))
                object.uploadTask = message.uploadTask;
            if (message.localPath != null && message.hasOwnProperty("localPath"))
                object.localPath = message.localPath;
            return object;
        };

        /**
         * Converts this UFile to JSON.
         * @function toJSON
         * @memberof uploader.UFile
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UFile.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for UFile
         * @function getTypeUrl
         * @memberof uploader.UFile
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        UFile.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/uploader.UFile";
        };

        return UFile;
    })();

    return uploader;
})();

export const lesson = $root.lesson = (() => {

    /**
     * Namespace lesson.
     * @exports lesson
     * @namespace
     */
    const lesson = {};

    lesson.GetLesson = (function() {

        /**
         * Properties of a GetLesson.
         * @memberof lesson
         * @interface IGetLesson
         * @property {string|null} [id] GetLesson id
         */

        /**
         * Constructs a new GetLesson.
         * @memberof lesson
         * @classdesc Represents a GetLesson.
         * @implements IGetLesson
         * @constructor
         * @param {lesson.IGetLesson=} [properties] Properties to set
         */
        function GetLesson(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetLesson id.
         * @member {string} id
         * @memberof lesson.GetLesson
         * @instance
         */
        GetLesson.prototype.id = "";

        /**
         * Creates a new GetLesson instance using the specified properties.
         * @function create
         * @memberof lesson.GetLesson
         * @static
         * @param {lesson.IGetLesson=} [properties] Properties to set
         * @returns {lesson.GetLesson} GetLesson instance
         */
        GetLesson.create = function create(properties) {
            return new GetLesson(properties);
        };

        /**
         * Encodes the specified GetLesson message. Does not implicitly {@link lesson.GetLesson.verify|verify} messages.
         * @function encode
         * @memberof lesson.GetLesson
         * @static
         * @param {lesson.IGetLesson} message GetLesson message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetLesson.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            return writer;
        };

        /**
         * Encodes the specified GetLesson message, length delimited. Does not implicitly {@link lesson.GetLesson.verify|verify} messages.
         * @function encodeDelimited
         * @memberof lesson.GetLesson
         * @static
         * @param {lesson.IGetLesson} message GetLesson message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetLesson.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetLesson message from the specified reader or buffer.
         * @function decode
         * @memberof lesson.GetLesson
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {lesson.GetLesson} GetLesson
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetLesson.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.lesson.GetLesson();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.id = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetLesson message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof lesson.GetLesson
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {lesson.GetLesson} GetLesson
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetLesson.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetLesson message.
         * @function verify
         * @memberof lesson.GetLesson
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetLesson.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            return null;
        };

        /**
         * Creates a GetLesson message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof lesson.GetLesson
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {lesson.GetLesson} GetLesson
         */
        GetLesson.fromObject = function fromObject(object) {
            if (object instanceof $root.lesson.GetLesson)
                return object;
            let message = new $root.lesson.GetLesson();
            if (object.id != null)
                message.id = String(object.id);
            return message;
        };

        /**
         * Creates a plain object from a GetLesson message. Also converts values to other types if specified.
         * @function toObject
         * @memberof lesson.GetLesson
         * @static
         * @param {lesson.GetLesson} message GetLesson
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetLesson.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.id = "";
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            return object;
        };

        /**
         * Converts this GetLesson to JSON.
         * @function toJSON
         * @memberof lesson.GetLesson
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetLesson.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GetLesson
         * @function getTypeUrl
         * @memberof lesson.GetLesson
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GetLesson.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/lesson.GetLesson";
        };

        return GetLesson;
    })();

    lesson.GetLessonResponse = (function() {

        /**
         * Properties of a GetLessonResponse.
         * @memberof lesson
         * @interface IGetLessonResponse
         * @property {lessons.ILessonDetail|null} [lesson] GetLessonResponse lesson
         */

        /**
         * Constructs a new GetLessonResponse.
         * @memberof lesson
         * @classdesc Represents a GetLessonResponse.
         * @implements IGetLessonResponse
         * @constructor
         * @param {lesson.IGetLessonResponse=} [properties] Properties to set
         */
        function GetLessonResponse(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetLessonResponse lesson.
         * @member {lessons.ILessonDetail|null|undefined} lesson
         * @memberof lesson.GetLessonResponse
         * @instance
         */
        GetLessonResponse.prototype.lesson = null;

        /**
         * Creates a new GetLessonResponse instance using the specified properties.
         * @function create
         * @memberof lesson.GetLessonResponse
         * @static
         * @param {lesson.IGetLessonResponse=} [properties] Properties to set
         * @returns {lesson.GetLessonResponse} GetLessonResponse instance
         */
        GetLessonResponse.create = function create(properties) {
            return new GetLessonResponse(properties);
        };

        /**
         * Encodes the specified GetLessonResponse message. Does not implicitly {@link lesson.GetLessonResponse.verify|verify} messages.
         * @function encode
         * @memberof lesson.GetLessonResponse
         * @static
         * @param {lesson.IGetLessonResponse} message GetLessonResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetLessonResponse.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.lesson != null && Object.hasOwnProperty.call(message, "lesson"))
                $root.lessons.LessonDetail.encode(message.lesson, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified GetLessonResponse message, length delimited. Does not implicitly {@link lesson.GetLessonResponse.verify|verify} messages.
         * @function encodeDelimited
         * @memberof lesson.GetLessonResponse
         * @static
         * @param {lesson.IGetLessonResponse} message GetLessonResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetLessonResponse.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetLessonResponse message from the specified reader or buffer.
         * @function decode
         * @memberof lesson.GetLessonResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {lesson.GetLessonResponse} GetLessonResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetLessonResponse.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.lesson.GetLessonResponse();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.lesson = $root.lessons.LessonDetail.decode(reader, reader.uint32());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetLessonResponse message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof lesson.GetLessonResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {lesson.GetLessonResponse} GetLessonResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetLessonResponse.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetLessonResponse message.
         * @function verify
         * @memberof lesson.GetLessonResponse
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetLessonResponse.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.lesson != null && message.hasOwnProperty("lesson")) {
                let error = $root.lessons.LessonDetail.verify(message.lesson);
                if (error)
                    return "lesson." + error;
            }
            return null;
        };

        /**
         * Creates a GetLessonResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof lesson.GetLessonResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {lesson.GetLessonResponse} GetLessonResponse
         */
        GetLessonResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.lesson.GetLessonResponse)
                return object;
            let message = new $root.lesson.GetLessonResponse();
            if (object.lesson != null) {
                if (typeof object.lesson !== "object")
                    throw TypeError(".lesson.GetLessonResponse.lesson: object expected");
                message.lesson = $root.lessons.LessonDetail.fromObject(object.lesson);
            }
            return message;
        };

        /**
         * Creates a plain object from a GetLessonResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof lesson.GetLessonResponse
         * @static
         * @param {lesson.GetLessonResponse} message GetLessonResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetLessonResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.lesson = null;
            if (message.lesson != null && message.hasOwnProperty("lesson"))
                object.lesson = $root.lessons.LessonDetail.toObject(message.lesson, options);
            return object;
        };

        /**
         * Converts this GetLessonResponse to JSON.
         * @function toJSON
         * @memberof lesson.GetLessonResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetLessonResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GetLessonResponse
         * @function getTypeUrl
         * @memberof lesson.GetLessonResponse
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GetLessonResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/lesson.GetLessonResponse";
        };

        return GetLessonResponse;
    })();

    return lesson;
})();

export const lessons = $root.lessons = (() => {

    /**
     * Namespace lessons.
     * @exports lessons
     * @namespace
     */
    const lessons = {};

    /**
     * ContentBlockType enum.
     * @name lessons.ContentBlockType
     * @enum {number}
     * @property {number} CONTENT_BLOCK_TEXT=0 CONTENT_BLOCK_TEXT value
     * @property {number} CONTENT_BLOCK_ANNOTATION=1 CONTENT_BLOCK_ANNOTATION value
     */
    lessons.ContentBlockType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "CONTENT_BLOCK_TEXT"] = 0;
        values[valuesById[1] = "CONTENT_BLOCK_ANNOTATION"] = 1;
        return values;
    })();

    /**
     * TextBlockStyle enum.
     * @name lessons.TextBlockStyle
     * @enum {number}
     * @property {number} TEXT_STYLE_NORMAL=0 TEXT_STYLE_NORMAL value
     * @property {number} TEXT_STYLE_GOOD_EMPHASIS=1 TEXT_STYLE_GOOD_EMPHASIS value
     * @property {number} TEXT_STYLE_BAD_EMPHASIS=2 TEXT_STYLE_BAD_EMPHASIS value
     * @property {number} TEXT_STYLE_EMPHASIS=3 TEXT_STYLE_EMPHASIS value
     * @property {number} TEXT_STYLE_THEORY=4 TEXT_STYLE_THEORY value
     */
    lessons.TextBlockStyle = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "TEXT_STYLE_NORMAL"] = 0;
        values[valuesById[1] = "TEXT_STYLE_GOOD_EMPHASIS"] = 1;
        values[valuesById[2] = "TEXT_STYLE_BAD_EMPHASIS"] = 2;
        values[valuesById[3] = "TEXT_STYLE_EMPHASIS"] = 3;
        values[valuesById[4] = "TEXT_STYLE_THEORY"] = 4;
        return values;
    })();

    lessons.ListLessons = (function() {

        /**
         * Properties of a ListLessons.
         * @memberof lessons
         * @interface IListLessons
         * @property {common.IPagination|null} [pagination] ListLessons pagination
         */

        /**
         * Constructs a new ListLessons.
         * @memberof lessons
         * @classdesc Represents a ListLessons.
         * @implements IListLessons
         * @constructor
         * @param {lessons.IListLessons=} [properties] Properties to set
         */
        function ListLessons(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListLessons pagination.
         * @member {common.IPagination|null|undefined} pagination
         * @memberof lessons.ListLessons
         * @instance
         */
        ListLessons.prototype.pagination = null;

        /**
         * Creates a new ListLessons instance using the specified properties.
         * @function create
         * @memberof lessons.ListLessons
         * @static
         * @param {lessons.IListLessons=} [properties] Properties to set
         * @returns {lessons.ListLessons} ListLessons instance
         */
        ListLessons.create = function create(properties) {
            return new ListLessons(properties);
        };

        /**
         * Encodes the specified ListLessons message. Does not implicitly {@link lessons.ListLessons.verify|verify} messages.
         * @function encode
         * @memberof lessons.ListLessons
         * @static
         * @param {lessons.IListLessons} message ListLessons message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListLessons.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pagination != null && Object.hasOwnProperty.call(message, "pagination"))
                $root.common.Pagination.encode(message.pagination, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified ListLessons message, length delimited. Does not implicitly {@link lessons.ListLessons.verify|verify} messages.
         * @function encodeDelimited
         * @memberof lessons.ListLessons
         * @static
         * @param {lessons.IListLessons} message ListLessons message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListLessons.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ListLessons message from the specified reader or buffer.
         * @function decode
         * @memberof lessons.ListLessons
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {lessons.ListLessons} ListLessons
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListLessons.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.lessons.ListLessons();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.pagination = $root.common.Pagination.decode(reader, reader.uint32());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ListLessons message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof lessons.ListLessons
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {lessons.ListLessons} ListLessons
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListLessons.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ListLessons message.
         * @function verify
         * @memberof lessons.ListLessons
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ListLessons.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.pagination != null && message.hasOwnProperty("pagination")) {
                let error = $root.common.Pagination.verify(message.pagination);
                if (error)
                    return "pagination." + error;
            }
            return null;
        };

        /**
         * Creates a ListLessons message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof lessons.ListLessons
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {lessons.ListLessons} ListLessons
         */
        ListLessons.fromObject = function fromObject(object) {
            if (object instanceof $root.lessons.ListLessons)
                return object;
            let message = new $root.lessons.ListLessons();
            if (object.pagination != null) {
                if (typeof object.pagination !== "object")
                    throw TypeError(".lessons.ListLessons.pagination: object expected");
                message.pagination = $root.common.Pagination.fromObject(object.pagination);
            }
            return message;
        };

        /**
         * Creates a plain object from a ListLessons message. Also converts values to other types if specified.
         * @function toObject
         * @memberof lessons.ListLessons
         * @static
         * @param {lessons.ListLessons} message ListLessons
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListLessons.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.pagination = null;
            if (message.pagination != null && message.hasOwnProperty("pagination"))
                object.pagination = $root.common.Pagination.toObject(message.pagination, options);
            return object;
        };

        /**
         * Converts this ListLessons to JSON.
         * @function toJSON
         * @memberof lessons.ListLessons
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListLessons.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ListLessons
         * @function getTypeUrl
         * @memberof lessons.ListLessons
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ListLessons.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/lessons.ListLessons";
        };

        return ListLessons;
    })();

    lessons.ListLessonsResponse = (function() {

        /**
         * Properties of a ListLessonsResponse.
         * @memberof lessons
         * @interface IListLessonsResponse
         * @property {common.IPagination|null} [pagination] ListLessonsResponse pagination
         * @property {Array.<lessons.ILessonSummary>|null} [lessons] ListLessonsResponse lessons
         */

        /**
         * Constructs a new ListLessonsResponse.
         * @memberof lessons
         * @classdesc Represents a ListLessonsResponse.
         * @implements IListLessonsResponse
         * @constructor
         * @param {lessons.IListLessonsResponse=} [properties] Properties to set
         */
        function ListLessonsResponse(properties) {
            this.lessons = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListLessonsResponse pagination.
         * @member {common.IPagination|null|undefined} pagination
         * @memberof lessons.ListLessonsResponse
         * @instance
         */
        ListLessonsResponse.prototype.pagination = null;

        /**
         * ListLessonsResponse lessons.
         * @member {Array.<lessons.ILessonSummary>} lessons
         * @memberof lessons.ListLessonsResponse
         * @instance
         */
        ListLessonsResponse.prototype.lessons = $util.emptyArray;

        /**
         * Creates a new ListLessonsResponse instance using the specified properties.
         * @function create
         * @memberof lessons.ListLessonsResponse
         * @static
         * @param {lessons.IListLessonsResponse=} [properties] Properties to set
         * @returns {lessons.ListLessonsResponse} ListLessonsResponse instance
         */
        ListLessonsResponse.create = function create(properties) {
            return new ListLessonsResponse(properties);
        };

        /**
         * Encodes the specified ListLessonsResponse message. Does not implicitly {@link lessons.ListLessonsResponse.verify|verify} messages.
         * @function encode
         * @memberof lessons.ListLessonsResponse
         * @static
         * @param {lessons.IListLessonsResponse} message ListLessonsResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListLessonsResponse.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pagination != null && Object.hasOwnProperty.call(message, "pagination"))
                $root.common.Pagination.encode(message.pagination, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.lessons != null && message.lessons.length)
                for (let i = 0; i < message.lessons.length; ++i)
                    $root.lessons.LessonSummary.encode(message.lessons[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified ListLessonsResponse message, length delimited. Does not implicitly {@link lessons.ListLessonsResponse.verify|verify} messages.
         * @function encodeDelimited
         * @memberof lessons.ListLessonsResponse
         * @static
         * @param {lessons.IListLessonsResponse} message ListLessonsResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListLessonsResponse.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ListLessonsResponse message from the specified reader or buffer.
         * @function decode
         * @memberof lessons.ListLessonsResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {lessons.ListLessonsResponse} ListLessonsResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListLessonsResponse.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.lessons.ListLessonsResponse();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.pagination = $root.common.Pagination.decode(reader, reader.uint32());
                        break;
                    }
                case 2: {
                        if (!(message.lessons && message.lessons.length))
                            message.lessons = [];
                        message.lessons.push($root.lessons.LessonSummary.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ListLessonsResponse message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof lessons.ListLessonsResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {lessons.ListLessonsResponse} ListLessonsResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListLessonsResponse.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ListLessonsResponse message.
         * @function verify
         * @memberof lessons.ListLessonsResponse
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ListLessonsResponse.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.pagination != null && message.hasOwnProperty("pagination")) {
                let error = $root.common.Pagination.verify(message.pagination);
                if (error)
                    return "pagination." + error;
            }
            if (message.lessons != null && message.hasOwnProperty("lessons")) {
                if (!Array.isArray(message.lessons))
                    return "lessons: array expected";
                for (let i = 0; i < message.lessons.length; ++i) {
                    let error = $root.lessons.LessonSummary.verify(message.lessons[i]);
                    if (error)
                        return "lessons." + error;
                }
            }
            return null;
        };

        /**
         * Creates a ListLessonsResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof lessons.ListLessonsResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {lessons.ListLessonsResponse} ListLessonsResponse
         */
        ListLessonsResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.lessons.ListLessonsResponse)
                return object;
            let message = new $root.lessons.ListLessonsResponse();
            if (object.pagination != null) {
                if (typeof object.pagination !== "object")
                    throw TypeError(".lessons.ListLessonsResponse.pagination: object expected");
                message.pagination = $root.common.Pagination.fromObject(object.pagination);
            }
            if (object.lessons) {
                if (!Array.isArray(object.lessons))
                    throw TypeError(".lessons.ListLessonsResponse.lessons: array expected");
                message.lessons = [];
                for (let i = 0; i < object.lessons.length; ++i) {
                    if (typeof object.lessons[i] !== "object")
                        throw TypeError(".lessons.ListLessonsResponse.lessons: object expected");
                    message.lessons[i] = $root.lessons.LessonSummary.fromObject(object.lessons[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a ListLessonsResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof lessons.ListLessonsResponse
         * @static
         * @param {lessons.ListLessonsResponse} message ListLessonsResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListLessonsResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.lessons = [];
            if (options.defaults)
                object.pagination = null;
            if (message.pagination != null && message.hasOwnProperty("pagination"))
                object.pagination = $root.common.Pagination.toObject(message.pagination, options);
            if (message.lessons && message.lessons.length) {
                object.lessons = [];
                for (let j = 0; j < message.lessons.length; ++j)
                    object.lessons[j] = $root.lessons.LessonSummary.toObject(message.lessons[j], options);
            }
            return object;
        };

        /**
         * Converts this ListLessonsResponse to JSON.
         * @function toJSON
         * @memberof lessons.ListLessonsResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListLessonsResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ListLessonsResponse
         * @function getTypeUrl
         * @memberof lessons.ListLessonsResponse
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ListLessonsResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/lessons.ListLessonsResponse";
        };

        return ListLessonsResponse;
    })();

    lessons.GetLesson = (function() {

        /**
         * Properties of a GetLesson.
         * @memberof lessons
         * @interface IGetLesson
         * @property {string|null} [id] GetLesson id
         */

        /**
         * Constructs a new GetLesson.
         * @memberof lessons
         * @classdesc Represents a GetLesson.
         * @implements IGetLesson
         * @constructor
         * @param {lessons.IGetLesson=} [properties] Properties to set
         */
        function GetLesson(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetLesson id.
         * @member {string} id
         * @memberof lessons.GetLesson
         * @instance
         */
        GetLesson.prototype.id = "";

        /**
         * Creates a new GetLesson instance using the specified properties.
         * @function create
         * @memberof lessons.GetLesson
         * @static
         * @param {lessons.IGetLesson=} [properties] Properties to set
         * @returns {lessons.GetLesson} GetLesson instance
         */
        GetLesson.create = function create(properties) {
            return new GetLesson(properties);
        };

        /**
         * Encodes the specified GetLesson message. Does not implicitly {@link lessons.GetLesson.verify|verify} messages.
         * @function encode
         * @memberof lessons.GetLesson
         * @static
         * @param {lessons.IGetLesson} message GetLesson message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetLesson.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            return writer;
        };

        /**
         * Encodes the specified GetLesson message, length delimited. Does not implicitly {@link lessons.GetLesson.verify|verify} messages.
         * @function encodeDelimited
         * @memberof lessons.GetLesson
         * @static
         * @param {lessons.IGetLesson} message GetLesson message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetLesson.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetLesson message from the specified reader or buffer.
         * @function decode
         * @memberof lessons.GetLesson
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {lessons.GetLesson} GetLesson
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetLesson.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.lessons.GetLesson();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.id = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetLesson message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof lessons.GetLesson
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {lessons.GetLesson} GetLesson
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetLesson.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetLesson message.
         * @function verify
         * @memberof lessons.GetLesson
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetLesson.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            return null;
        };

        /**
         * Creates a GetLesson message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof lessons.GetLesson
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {lessons.GetLesson} GetLesson
         */
        GetLesson.fromObject = function fromObject(object) {
            if (object instanceof $root.lessons.GetLesson)
                return object;
            let message = new $root.lessons.GetLesson();
            if (object.id != null)
                message.id = String(object.id);
            return message;
        };

        /**
         * Creates a plain object from a GetLesson message. Also converts values to other types if specified.
         * @function toObject
         * @memberof lessons.GetLesson
         * @static
         * @param {lessons.GetLesson} message GetLesson
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetLesson.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.id = "";
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            return object;
        };

        /**
         * Converts this GetLesson to JSON.
         * @function toJSON
         * @memberof lessons.GetLesson
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetLesson.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GetLesson
         * @function getTypeUrl
         * @memberof lessons.GetLesson
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GetLesson.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/lessons.GetLesson";
        };

        return GetLesson;
    })();

    lessons.GetLessonResponse = (function() {

        /**
         * Properties of a GetLessonResponse.
         * @memberof lessons
         * @interface IGetLessonResponse
         * @property {lessons.ILessonDetail|null} [lesson] GetLessonResponse lesson
         */

        /**
         * Constructs a new GetLessonResponse.
         * @memberof lessons
         * @classdesc Represents a GetLessonResponse.
         * @implements IGetLessonResponse
         * @constructor
         * @param {lessons.IGetLessonResponse=} [properties] Properties to set
         */
        function GetLessonResponse(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetLessonResponse lesson.
         * @member {lessons.ILessonDetail|null|undefined} lesson
         * @memberof lessons.GetLessonResponse
         * @instance
         */
        GetLessonResponse.prototype.lesson = null;

        /**
         * Creates a new GetLessonResponse instance using the specified properties.
         * @function create
         * @memberof lessons.GetLessonResponse
         * @static
         * @param {lessons.IGetLessonResponse=} [properties] Properties to set
         * @returns {lessons.GetLessonResponse} GetLessonResponse instance
         */
        GetLessonResponse.create = function create(properties) {
            return new GetLessonResponse(properties);
        };

        /**
         * Encodes the specified GetLessonResponse message. Does not implicitly {@link lessons.GetLessonResponse.verify|verify} messages.
         * @function encode
         * @memberof lessons.GetLessonResponse
         * @static
         * @param {lessons.IGetLessonResponse} message GetLessonResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetLessonResponse.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.lesson != null && Object.hasOwnProperty.call(message, "lesson"))
                $root.lessons.LessonDetail.encode(message.lesson, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified GetLessonResponse message, length delimited. Does not implicitly {@link lessons.GetLessonResponse.verify|verify} messages.
         * @function encodeDelimited
         * @memberof lessons.GetLessonResponse
         * @static
         * @param {lessons.IGetLessonResponse} message GetLessonResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetLessonResponse.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetLessonResponse message from the specified reader or buffer.
         * @function decode
         * @memberof lessons.GetLessonResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {lessons.GetLessonResponse} GetLessonResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetLessonResponse.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.lessons.GetLessonResponse();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.lesson = $root.lessons.LessonDetail.decode(reader, reader.uint32());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetLessonResponse message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof lessons.GetLessonResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {lessons.GetLessonResponse} GetLessonResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetLessonResponse.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetLessonResponse message.
         * @function verify
         * @memberof lessons.GetLessonResponse
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetLessonResponse.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.lesson != null && message.hasOwnProperty("lesson")) {
                let error = $root.lessons.LessonDetail.verify(message.lesson);
                if (error)
                    return "lesson." + error;
            }
            return null;
        };

        /**
         * Creates a GetLessonResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof lessons.GetLessonResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {lessons.GetLessonResponse} GetLessonResponse
         */
        GetLessonResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.lessons.GetLessonResponse)
                return object;
            let message = new $root.lessons.GetLessonResponse();
            if (object.lesson != null) {
                if (typeof object.lesson !== "object")
                    throw TypeError(".lessons.GetLessonResponse.lesson: object expected");
                message.lesson = $root.lessons.LessonDetail.fromObject(object.lesson);
            }
            return message;
        };

        /**
         * Creates a plain object from a GetLessonResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof lessons.GetLessonResponse
         * @static
         * @param {lessons.GetLessonResponse} message GetLessonResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetLessonResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.lesson = null;
            if (message.lesson != null && message.hasOwnProperty("lesson"))
                object.lesson = $root.lessons.LessonDetail.toObject(message.lesson, options);
            return object;
        };

        /**
         * Converts this GetLessonResponse to JSON.
         * @function toJSON
         * @memberof lessons.GetLessonResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetLessonResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GetLessonResponse
         * @function getTypeUrl
         * @memberof lessons.GetLessonResponse
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GetLessonResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/lessons.GetLessonResponse";
        };

        return GetLessonResponse;
    })();

    lessons.CreateLesson = (function() {

        /**
         * Properties of a CreateLesson.
         * @memberof lessons
         * @interface ICreateLesson
         * @property {string|null} [title] CreateLesson title
         * @property {string|null} [description] CreateLesson description
         * @property {string|null} [thumbnailFileId] CreateLesson thumbnailFileId
         */

        /**
         * Constructs a new CreateLesson.
         * @memberof lessons
         * @classdesc Represents a CreateLesson.
         * @implements ICreateLesson
         * @constructor
         * @param {lessons.ICreateLesson=} [properties] Properties to set
         */
        function CreateLesson(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CreateLesson title.
         * @member {string} title
         * @memberof lessons.CreateLesson
         * @instance
         */
        CreateLesson.prototype.title = "";

        /**
         * CreateLesson description.
         * @member {string} description
         * @memberof lessons.CreateLesson
         * @instance
         */
        CreateLesson.prototype.description = "";

        /**
         * CreateLesson thumbnailFileId.
         * @member {string} thumbnailFileId
         * @memberof lessons.CreateLesson
         * @instance
         */
        CreateLesson.prototype.thumbnailFileId = "";

        /**
         * Creates a new CreateLesson instance using the specified properties.
         * @function create
         * @memberof lessons.CreateLesson
         * @static
         * @param {lessons.ICreateLesson=} [properties] Properties to set
         * @returns {lessons.CreateLesson} CreateLesson instance
         */
        CreateLesson.create = function create(properties) {
            return new CreateLesson(properties);
        };

        /**
         * Encodes the specified CreateLesson message. Does not implicitly {@link lessons.CreateLesson.verify|verify} messages.
         * @function encode
         * @memberof lessons.CreateLesson
         * @static
         * @param {lessons.ICreateLesson} message CreateLesson message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateLesson.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.title != null && Object.hasOwnProperty.call(message, "title"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.title);
            if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.description);
            if (message.thumbnailFileId != null && Object.hasOwnProperty.call(message, "thumbnailFileId"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.thumbnailFileId);
            return writer;
        };

        /**
         * Encodes the specified CreateLesson message, length delimited. Does not implicitly {@link lessons.CreateLesson.verify|verify} messages.
         * @function encodeDelimited
         * @memberof lessons.CreateLesson
         * @static
         * @param {lessons.ICreateLesson} message CreateLesson message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateLesson.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CreateLesson message from the specified reader or buffer.
         * @function decode
         * @memberof lessons.CreateLesson
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {lessons.CreateLesson} CreateLesson
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateLesson.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.lessons.CreateLesson();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.title = reader.string();
                        break;
                    }
                case 2: {
                        message.description = reader.string();
                        break;
                    }
                case 3: {
                        message.thumbnailFileId = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CreateLesson message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof lessons.CreateLesson
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {lessons.CreateLesson} CreateLesson
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateLesson.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CreateLesson message.
         * @function verify
         * @memberof lessons.CreateLesson
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CreateLesson.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.title != null && message.hasOwnProperty("title"))
                if (!$util.isString(message.title))
                    return "title: string expected";
            if (message.description != null && message.hasOwnProperty("description"))
                if (!$util.isString(message.description))
                    return "description: string expected";
            if (message.thumbnailFileId != null && message.hasOwnProperty("thumbnailFileId"))
                if (!$util.isString(message.thumbnailFileId))
                    return "thumbnailFileId: string expected";
            return null;
        };

        /**
         * Creates a CreateLesson message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof lessons.CreateLesson
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {lessons.CreateLesson} CreateLesson
         */
        CreateLesson.fromObject = function fromObject(object) {
            if (object instanceof $root.lessons.CreateLesson)
                return object;
            let message = new $root.lessons.CreateLesson();
            if (object.title != null)
                message.title = String(object.title);
            if (object.description != null)
                message.description = String(object.description);
            if (object.thumbnailFileId != null)
                message.thumbnailFileId = String(object.thumbnailFileId);
            return message;
        };

        /**
         * Creates a plain object from a CreateLesson message. Also converts values to other types if specified.
         * @function toObject
         * @memberof lessons.CreateLesson
         * @static
         * @param {lessons.CreateLesson} message CreateLesson
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CreateLesson.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.title = "";
                object.description = "";
                object.thumbnailFileId = "";
            }
            if (message.title != null && message.hasOwnProperty("title"))
                object.title = message.title;
            if (message.description != null && message.hasOwnProperty("description"))
                object.description = message.description;
            if (message.thumbnailFileId != null && message.hasOwnProperty("thumbnailFileId"))
                object.thumbnailFileId = message.thumbnailFileId;
            return object;
        };

        /**
         * Converts this CreateLesson to JSON.
         * @function toJSON
         * @memberof lessons.CreateLesson
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CreateLesson.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for CreateLesson
         * @function getTypeUrl
         * @memberof lessons.CreateLesson
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        CreateLesson.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/lessons.CreateLesson";
        };

        return CreateLesson;
    })();

    lessons.CreateLessonResponse = (function() {

        /**
         * Properties of a CreateLessonResponse.
         * @memberof lessons
         * @interface ICreateLessonResponse
         * @property {string|null} [lessonId] CreateLessonResponse lessonId
         */

        /**
         * Constructs a new CreateLessonResponse.
         * @memberof lessons
         * @classdesc Represents a CreateLessonResponse.
         * @implements ICreateLessonResponse
         * @constructor
         * @param {lessons.ICreateLessonResponse=} [properties] Properties to set
         */
        function CreateLessonResponse(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CreateLessonResponse lessonId.
         * @member {string} lessonId
         * @memberof lessons.CreateLessonResponse
         * @instance
         */
        CreateLessonResponse.prototype.lessonId = "";

        /**
         * Creates a new CreateLessonResponse instance using the specified properties.
         * @function create
         * @memberof lessons.CreateLessonResponse
         * @static
         * @param {lessons.ICreateLessonResponse=} [properties] Properties to set
         * @returns {lessons.CreateLessonResponse} CreateLessonResponse instance
         */
        CreateLessonResponse.create = function create(properties) {
            return new CreateLessonResponse(properties);
        };

        /**
         * Encodes the specified CreateLessonResponse message. Does not implicitly {@link lessons.CreateLessonResponse.verify|verify} messages.
         * @function encode
         * @memberof lessons.CreateLessonResponse
         * @static
         * @param {lessons.ICreateLessonResponse} message CreateLessonResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateLessonResponse.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.lessonId != null && Object.hasOwnProperty.call(message, "lessonId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.lessonId);
            return writer;
        };

        /**
         * Encodes the specified CreateLessonResponse message, length delimited. Does not implicitly {@link lessons.CreateLessonResponse.verify|verify} messages.
         * @function encodeDelimited
         * @memberof lessons.CreateLessonResponse
         * @static
         * @param {lessons.ICreateLessonResponse} message CreateLessonResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateLessonResponse.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CreateLessonResponse message from the specified reader or buffer.
         * @function decode
         * @memberof lessons.CreateLessonResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {lessons.CreateLessonResponse} CreateLessonResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateLessonResponse.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.lessons.CreateLessonResponse();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.lessonId = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CreateLessonResponse message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof lessons.CreateLessonResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {lessons.CreateLessonResponse} CreateLessonResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateLessonResponse.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CreateLessonResponse message.
         * @function verify
         * @memberof lessons.CreateLessonResponse
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CreateLessonResponse.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.lessonId != null && message.hasOwnProperty("lessonId"))
                if (!$util.isString(message.lessonId))
                    return "lessonId: string expected";
            return null;
        };

        /**
         * Creates a CreateLessonResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof lessons.CreateLessonResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {lessons.CreateLessonResponse} CreateLessonResponse
         */
        CreateLessonResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.lessons.CreateLessonResponse)
                return object;
            let message = new $root.lessons.CreateLessonResponse();
            if (object.lessonId != null)
                message.lessonId = String(object.lessonId);
            return message;
        };

        /**
         * Creates a plain object from a CreateLessonResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof lessons.CreateLessonResponse
         * @static
         * @param {lessons.CreateLessonResponse} message CreateLessonResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CreateLessonResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.lessonId = "";
            if (message.lessonId != null && message.hasOwnProperty("lessonId"))
                object.lessonId = message.lessonId;
            return object;
        };

        /**
         * Converts this CreateLessonResponse to JSON.
         * @function toJSON
         * @memberof lessons.CreateLessonResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CreateLessonResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for CreateLessonResponse
         * @function getTypeUrl
         * @memberof lessons.CreateLessonResponse
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        CreateLessonResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/lessons.CreateLessonResponse";
        };

        return CreateLessonResponse;
    })();

    lessons.UpdateLesson = (function() {

        /**
         * Properties of an UpdateLesson.
         * @memberof lessons
         * @interface IUpdateLesson
         * @property {string|null} [id] UpdateLesson id
         * @property {string|null} [title] UpdateLesson title
         * @property {string|null} [description] UpdateLesson description
         * @property {string|null} [thumbnailFileId] UpdateLesson thumbnailFileId
         * @property {boolean|null} [published] UpdateLesson published
         */

        /**
         * Constructs a new UpdateLesson.
         * @memberof lessons
         * @classdesc Represents an UpdateLesson.
         * @implements IUpdateLesson
         * @constructor
         * @param {lessons.IUpdateLesson=} [properties] Properties to set
         */
        function UpdateLesson(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateLesson id.
         * @member {string} id
         * @memberof lessons.UpdateLesson
         * @instance
         */
        UpdateLesson.prototype.id = "";

        /**
         * UpdateLesson title.
         * @member {string} title
         * @memberof lessons.UpdateLesson
         * @instance
         */
        UpdateLesson.prototype.title = "";

        /**
         * UpdateLesson description.
         * @member {string} description
         * @memberof lessons.UpdateLesson
         * @instance
         */
        UpdateLesson.prototype.description = "";

        /**
         * UpdateLesson thumbnailFileId.
         * @member {string} thumbnailFileId
         * @memberof lessons.UpdateLesson
         * @instance
         */
        UpdateLesson.prototype.thumbnailFileId = "";

        /**
         * UpdateLesson published.
         * @member {boolean} published
         * @memberof lessons.UpdateLesson
         * @instance
         */
        UpdateLesson.prototype.published = false;

        /**
         * Creates a new UpdateLesson instance using the specified properties.
         * @function create
         * @memberof lessons.UpdateLesson
         * @static
         * @param {lessons.IUpdateLesson=} [properties] Properties to set
         * @returns {lessons.UpdateLesson} UpdateLesson instance
         */
        UpdateLesson.create = function create(properties) {
            return new UpdateLesson(properties);
        };

        /**
         * Encodes the specified UpdateLesson message. Does not implicitly {@link lessons.UpdateLesson.verify|verify} messages.
         * @function encode
         * @memberof lessons.UpdateLesson
         * @static
         * @param {lessons.IUpdateLesson} message UpdateLesson message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateLesson.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            if (message.title != null && Object.hasOwnProperty.call(message, "title"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.title);
            if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.description);
            if (message.thumbnailFileId != null && Object.hasOwnProperty.call(message, "thumbnailFileId"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.thumbnailFileId);
            if (message.published != null && Object.hasOwnProperty.call(message, "published"))
                writer.uint32(/* id 5, wireType 0 =*/40).bool(message.published);
            return writer;
        };

        /**
         * Encodes the specified UpdateLesson message, length delimited. Does not implicitly {@link lessons.UpdateLesson.verify|verify} messages.
         * @function encodeDelimited
         * @memberof lessons.UpdateLesson
         * @static
         * @param {lessons.IUpdateLesson} message UpdateLesson message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateLesson.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an UpdateLesson message from the specified reader or buffer.
         * @function decode
         * @memberof lessons.UpdateLesson
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {lessons.UpdateLesson} UpdateLesson
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateLesson.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.lessons.UpdateLesson();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.id = reader.string();
                        break;
                    }
                case 2: {
                        message.title = reader.string();
                        break;
                    }
                case 3: {
                        message.description = reader.string();
                        break;
                    }
                case 4: {
                        message.thumbnailFileId = reader.string();
                        break;
                    }
                case 5: {
                        message.published = reader.bool();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an UpdateLesson message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof lessons.UpdateLesson
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {lessons.UpdateLesson} UpdateLesson
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateLesson.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an UpdateLesson message.
         * @function verify
         * @memberof lessons.UpdateLesson
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UpdateLesson.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.title != null && message.hasOwnProperty("title"))
                if (!$util.isString(message.title))
                    return "title: string expected";
            if (message.description != null && message.hasOwnProperty("description"))
                if (!$util.isString(message.description))
                    return "description: string expected";
            if (message.thumbnailFileId != null && message.hasOwnProperty("thumbnailFileId"))
                if (!$util.isString(message.thumbnailFileId))
                    return "thumbnailFileId: string expected";
            if (message.published != null && message.hasOwnProperty("published"))
                if (typeof message.published !== "boolean")
                    return "published: boolean expected";
            return null;
        };

        /**
         * Creates an UpdateLesson message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof lessons.UpdateLesson
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {lessons.UpdateLesson} UpdateLesson
         */
        UpdateLesson.fromObject = function fromObject(object) {
            if (object instanceof $root.lessons.UpdateLesson)
                return object;
            let message = new $root.lessons.UpdateLesson();
            if (object.id != null)
                message.id = String(object.id);
            if (object.title != null)
                message.title = String(object.title);
            if (object.description != null)
                message.description = String(object.description);
            if (object.thumbnailFileId != null)
                message.thumbnailFileId = String(object.thumbnailFileId);
            if (object.published != null)
                message.published = Boolean(object.published);
            return message;
        };

        /**
         * Creates a plain object from an UpdateLesson message. Also converts values to other types if specified.
         * @function toObject
         * @memberof lessons.UpdateLesson
         * @static
         * @param {lessons.UpdateLesson} message UpdateLesson
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateLesson.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.id = "";
                object.title = "";
                object.description = "";
                object.thumbnailFileId = "";
                object.published = false;
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.title != null && message.hasOwnProperty("title"))
                object.title = message.title;
            if (message.description != null && message.hasOwnProperty("description"))
                object.description = message.description;
            if (message.thumbnailFileId != null && message.hasOwnProperty("thumbnailFileId"))
                object.thumbnailFileId = message.thumbnailFileId;
            if (message.published != null && message.hasOwnProperty("published"))
                object.published = message.published;
            return object;
        };

        /**
         * Converts this UpdateLesson to JSON.
         * @function toJSON
         * @memberof lessons.UpdateLesson
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateLesson.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for UpdateLesson
         * @function getTypeUrl
         * @memberof lessons.UpdateLesson
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        UpdateLesson.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/lessons.UpdateLesson";
        };

        return UpdateLesson;
    })();

    lessons.DeleteLesson = (function() {

        /**
         * Properties of a DeleteLesson.
         * @memberof lessons
         * @interface IDeleteLesson
         * @property {string|null} [id] DeleteLesson id
         */

        /**
         * Constructs a new DeleteLesson.
         * @memberof lessons
         * @classdesc Represents a DeleteLesson.
         * @implements IDeleteLesson
         * @constructor
         * @param {lessons.IDeleteLesson=} [properties] Properties to set
         */
        function DeleteLesson(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * DeleteLesson id.
         * @member {string} id
         * @memberof lessons.DeleteLesson
         * @instance
         */
        DeleteLesson.prototype.id = "";

        /**
         * Creates a new DeleteLesson instance using the specified properties.
         * @function create
         * @memberof lessons.DeleteLesson
         * @static
         * @param {lessons.IDeleteLesson=} [properties] Properties to set
         * @returns {lessons.DeleteLesson} DeleteLesson instance
         */
        DeleteLesson.create = function create(properties) {
            return new DeleteLesson(properties);
        };

        /**
         * Encodes the specified DeleteLesson message. Does not implicitly {@link lessons.DeleteLesson.verify|verify} messages.
         * @function encode
         * @memberof lessons.DeleteLesson
         * @static
         * @param {lessons.IDeleteLesson} message DeleteLesson message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DeleteLesson.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            return writer;
        };

        /**
         * Encodes the specified DeleteLesson message, length delimited. Does not implicitly {@link lessons.DeleteLesson.verify|verify} messages.
         * @function encodeDelimited
         * @memberof lessons.DeleteLesson
         * @static
         * @param {lessons.IDeleteLesson} message DeleteLesson message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DeleteLesson.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a DeleteLesson message from the specified reader or buffer.
         * @function decode
         * @memberof lessons.DeleteLesson
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {lessons.DeleteLesson} DeleteLesson
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DeleteLesson.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.lessons.DeleteLesson();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.id = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a DeleteLesson message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof lessons.DeleteLesson
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {lessons.DeleteLesson} DeleteLesson
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DeleteLesson.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a DeleteLesson message.
         * @function verify
         * @memberof lessons.DeleteLesson
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        DeleteLesson.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            return null;
        };

        /**
         * Creates a DeleteLesson message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof lessons.DeleteLesson
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {lessons.DeleteLesson} DeleteLesson
         */
        DeleteLesson.fromObject = function fromObject(object) {
            if (object instanceof $root.lessons.DeleteLesson)
                return object;
            let message = new $root.lessons.DeleteLesson();
            if (object.id != null)
                message.id = String(object.id);
            return message;
        };

        /**
         * Creates a plain object from a DeleteLesson message. Also converts values to other types if specified.
         * @function toObject
         * @memberof lessons.DeleteLesson
         * @static
         * @param {lessons.DeleteLesson} message DeleteLesson
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DeleteLesson.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.id = "";
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            return object;
        };

        /**
         * Converts this DeleteLesson to JSON.
         * @function toJSON
         * @memberof lessons.DeleteLesson
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DeleteLesson.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for DeleteLesson
         * @function getTypeUrl
         * @memberof lessons.DeleteLesson
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        DeleteLesson.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/lessons.DeleteLesson";
        };

        return DeleteLesson;
    })();

    lessons.CreateChapter = (function() {

        /**
         * Properties of a CreateChapter.
         * @memberof lessons
         * @interface ICreateChapter
         * @property {string|null} [lessonId] CreateChapter lessonId
         * @property {string|null} [title] CreateChapter title
         * @property {number|null} [order] CreateChapter order
         */

        /**
         * Constructs a new CreateChapter.
         * @memberof lessons
         * @classdesc Represents a CreateChapter.
         * @implements ICreateChapter
         * @constructor
         * @param {lessons.ICreateChapter=} [properties] Properties to set
         */
        function CreateChapter(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CreateChapter lessonId.
         * @member {string} lessonId
         * @memberof lessons.CreateChapter
         * @instance
         */
        CreateChapter.prototype.lessonId = "";

        /**
         * CreateChapter title.
         * @member {string} title
         * @memberof lessons.CreateChapter
         * @instance
         */
        CreateChapter.prototype.title = "";

        /**
         * CreateChapter order.
         * @member {number} order
         * @memberof lessons.CreateChapter
         * @instance
         */
        CreateChapter.prototype.order = 0;

        /**
         * Creates a new CreateChapter instance using the specified properties.
         * @function create
         * @memberof lessons.CreateChapter
         * @static
         * @param {lessons.ICreateChapter=} [properties] Properties to set
         * @returns {lessons.CreateChapter} CreateChapter instance
         */
        CreateChapter.create = function create(properties) {
            return new CreateChapter(properties);
        };

        /**
         * Encodes the specified CreateChapter message. Does not implicitly {@link lessons.CreateChapter.verify|verify} messages.
         * @function encode
         * @memberof lessons.CreateChapter
         * @static
         * @param {lessons.ICreateChapter} message CreateChapter message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateChapter.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.lessonId != null && Object.hasOwnProperty.call(message, "lessonId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.lessonId);
            if (message.title != null && Object.hasOwnProperty.call(message, "title"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.title);
            if (message.order != null && Object.hasOwnProperty.call(message, "order"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.order);
            return writer;
        };

        /**
         * Encodes the specified CreateChapter message, length delimited. Does not implicitly {@link lessons.CreateChapter.verify|verify} messages.
         * @function encodeDelimited
         * @memberof lessons.CreateChapter
         * @static
         * @param {lessons.ICreateChapter} message CreateChapter message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateChapter.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CreateChapter message from the specified reader or buffer.
         * @function decode
         * @memberof lessons.CreateChapter
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {lessons.CreateChapter} CreateChapter
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateChapter.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.lessons.CreateChapter();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.lessonId = reader.string();
                        break;
                    }
                case 2: {
                        message.title = reader.string();
                        break;
                    }
                case 3: {
                        message.order = reader.int32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CreateChapter message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof lessons.CreateChapter
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {lessons.CreateChapter} CreateChapter
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateChapter.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CreateChapter message.
         * @function verify
         * @memberof lessons.CreateChapter
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CreateChapter.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.lessonId != null && message.hasOwnProperty("lessonId"))
                if (!$util.isString(message.lessonId))
                    return "lessonId: string expected";
            if (message.title != null && message.hasOwnProperty("title"))
                if (!$util.isString(message.title))
                    return "title: string expected";
            if (message.order != null && message.hasOwnProperty("order"))
                if (!$util.isInteger(message.order))
                    return "order: integer expected";
            return null;
        };

        /**
         * Creates a CreateChapter message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof lessons.CreateChapter
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {lessons.CreateChapter} CreateChapter
         */
        CreateChapter.fromObject = function fromObject(object) {
            if (object instanceof $root.lessons.CreateChapter)
                return object;
            let message = new $root.lessons.CreateChapter();
            if (object.lessonId != null)
                message.lessonId = String(object.lessonId);
            if (object.title != null)
                message.title = String(object.title);
            if (object.order != null)
                message.order = object.order | 0;
            return message;
        };

        /**
         * Creates a plain object from a CreateChapter message. Also converts values to other types if specified.
         * @function toObject
         * @memberof lessons.CreateChapter
         * @static
         * @param {lessons.CreateChapter} message CreateChapter
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CreateChapter.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.lessonId = "";
                object.title = "";
                object.order = 0;
            }
            if (message.lessonId != null && message.hasOwnProperty("lessonId"))
                object.lessonId = message.lessonId;
            if (message.title != null && message.hasOwnProperty("title"))
                object.title = message.title;
            if (message.order != null && message.hasOwnProperty("order"))
                object.order = message.order;
            return object;
        };

        /**
         * Converts this CreateChapter to JSON.
         * @function toJSON
         * @memberof lessons.CreateChapter
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CreateChapter.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for CreateChapter
         * @function getTypeUrl
         * @memberof lessons.CreateChapter
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        CreateChapter.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/lessons.CreateChapter";
        };

        return CreateChapter;
    })();

    lessons.CreateChapterResponse = (function() {

        /**
         * Properties of a CreateChapterResponse.
         * @memberof lessons
         * @interface ICreateChapterResponse
         * @property {lessons.ILessonChapter|null} [chapter] CreateChapterResponse chapter
         */

        /**
         * Constructs a new CreateChapterResponse.
         * @memberof lessons
         * @classdesc Represents a CreateChapterResponse.
         * @implements ICreateChapterResponse
         * @constructor
         * @param {lessons.ICreateChapterResponse=} [properties] Properties to set
         */
        function CreateChapterResponse(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CreateChapterResponse chapter.
         * @member {lessons.ILessonChapter|null|undefined} chapter
         * @memberof lessons.CreateChapterResponse
         * @instance
         */
        CreateChapterResponse.prototype.chapter = null;

        /**
         * Creates a new CreateChapterResponse instance using the specified properties.
         * @function create
         * @memberof lessons.CreateChapterResponse
         * @static
         * @param {lessons.ICreateChapterResponse=} [properties] Properties to set
         * @returns {lessons.CreateChapterResponse} CreateChapterResponse instance
         */
        CreateChapterResponse.create = function create(properties) {
            return new CreateChapterResponse(properties);
        };

        /**
         * Encodes the specified CreateChapterResponse message. Does not implicitly {@link lessons.CreateChapterResponse.verify|verify} messages.
         * @function encode
         * @memberof lessons.CreateChapterResponse
         * @static
         * @param {lessons.ICreateChapterResponse} message CreateChapterResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateChapterResponse.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.chapter != null && Object.hasOwnProperty.call(message, "chapter"))
                $root.lessons.LessonChapter.encode(message.chapter, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified CreateChapterResponse message, length delimited. Does not implicitly {@link lessons.CreateChapterResponse.verify|verify} messages.
         * @function encodeDelimited
         * @memberof lessons.CreateChapterResponse
         * @static
         * @param {lessons.ICreateChapterResponse} message CreateChapterResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateChapterResponse.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CreateChapterResponse message from the specified reader or buffer.
         * @function decode
         * @memberof lessons.CreateChapterResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {lessons.CreateChapterResponse} CreateChapterResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateChapterResponse.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.lessons.CreateChapterResponse();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.chapter = $root.lessons.LessonChapter.decode(reader, reader.uint32());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CreateChapterResponse message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof lessons.CreateChapterResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {lessons.CreateChapterResponse} CreateChapterResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateChapterResponse.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CreateChapterResponse message.
         * @function verify
         * @memberof lessons.CreateChapterResponse
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CreateChapterResponse.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.chapter != null && message.hasOwnProperty("chapter")) {
                let error = $root.lessons.LessonChapter.verify(message.chapter);
                if (error)
                    return "chapter." + error;
            }
            return null;
        };

        /**
         * Creates a CreateChapterResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof lessons.CreateChapterResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {lessons.CreateChapterResponse} CreateChapterResponse
         */
        CreateChapterResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.lessons.CreateChapterResponse)
                return object;
            let message = new $root.lessons.CreateChapterResponse();
            if (object.chapter != null) {
                if (typeof object.chapter !== "object")
                    throw TypeError(".lessons.CreateChapterResponse.chapter: object expected");
                message.chapter = $root.lessons.LessonChapter.fromObject(object.chapter);
            }
            return message;
        };

        /**
         * Creates a plain object from a CreateChapterResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof lessons.CreateChapterResponse
         * @static
         * @param {lessons.CreateChapterResponse} message CreateChapterResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CreateChapterResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.chapter = null;
            if (message.chapter != null && message.hasOwnProperty("chapter"))
                object.chapter = $root.lessons.LessonChapter.toObject(message.chapter, options);
            return object;
        };

        /**
         * Converts this CreateChapterResponse to JSON.
         * @function toJSON
         * @memberof lessons.CreateChapterResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CreateChapterResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for CreateChapterResponse
         * @function getTypeUrl
         * @memberof lessons.CreateChapterResponse
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        CreateChapterResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/lessons.CreateChapterResponse";
        };

        return CreateChapterResponse;
    })();

    lessons.UpdateChapter = (function() {

        /**
         * Properties of an UpdateChapter.
         * @memberof lessons
         * @interface IUpdateChapter
         * @property {string|null} [id] UpdateChapter id
         * @property {string|null} [title] UpdateChapter title
         * @property {number|null} [order] UpdateChapter order
         */

        /**
         * Constructs a new UpdateChapter.
         * @memberof lessons
         * @classdesc Represents an UpdateChapter.
         * @implements IUpdateChapter
         * @constructor
         * @param {lessons.IUpdateChapter=} [properties] Properties to set
         */
        function UpdateChapter(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateChapter id.
         * @member {string} id
         * @memberof lessons.UpdateChapter
         * @instance
         */
        UpdateChapter.prototype.id = "";

        /**
         * UpdateChapter title.
         * @member {string} title
         * @memberof lessons.UpdateChapter
         * @instance
         */
        UpdateChapter.prototype.title = "";

        /**
         * UpdateChapter order.
         * @member {number} order
         * @memberof lessons.UpdateChapter
         * @instance
         */
        UpdateChapter.prototype.order = 0;

        /**
         * Creates a new UpdateChapter instance using the specified properties.
         * @function create
         * @memberof lessons.UpdateChapter
         * @static
         * @param {lessons.IUpdateChapter=} [properties] Properties to set
         * @returns {lessons.UpdateChapter} UpdateChapter instance
         */
        UpdateChapter.create = function create(properties) {
            return new UpdateChapter(properties);
        };

        /**
         * Encodes the specified UpdateChapter message. Does not implicitly {@link lessons.UpdateChapter.verify|verify} messages.
         * @function encode
         * @memberof lessons.UpdateChapter
         * @static
         * @param {lessons.IUpdateChapter} message UpdateChapter message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateChapter.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            if (message.title != null && Object.hasOwnProperty.call(message, "title"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.title);
            if (message.order != null && Object.hasOwnProperty.call(message, "order"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.order);
            return writer;
        };

        /**
         * Encodes the specified UpdateChapter message, length delimited. Does not implicitly {@link lessons.UpdateChapter.verify|verify} messages.
         * @function encodeDelimited
         * @memberof lessons.UpdateChapter
         * @static
         * @param {lessons.IUpdateChapter} message UpdateChapter message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateChapter.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an UpdateChapter message from the specified reader or buffer.
         * @function decode
         * @memberof lessons.UpdateChapter
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {lessons.UpdateChapter} UpdateChapter
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateChapter.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.lessons.UpdateChapter();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.id = reader.string();
                        break;
                    }
                case 2: {
                        message.title = reader.string();
                        break;
                    }
                case 3: {
                        message.order = reader.int32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an UpdateChapter message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof lessons.UpdateChapter
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {lessons.UpdateChapter} UpdateChapter
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateChapter.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an UpdateChapter message.
         * @function verify
         * @memberof lessons.UpdateChapter
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UpdateChapter.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.title != null && message.hasOwnProperty("title"))
                if (!$util.isString(message.title))
                    return "title: string expected";
            if (message.order != null && message.hasOwnProperty("order"))
                if (!$util.isInteger(message.order))
                    return "order: integer expected";
            return null;
        };

        /**
         * Creates an UpdateChapter message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof lessons.UpdateChapter
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {lessons.UpdateChapter} UpdateChapter
         */
        UpdateChapter.fromObject = function fromObject(object) {
            if (object instanceof $root.lessons.UpdateChapter)
                return object;
            let message = new $root.lessons.UpdateChapter();
            if (object.id != null)
                message.id = String(object.id);
            if (object.title != null)
                message.title = String(object.title);
            if (object.order != null)
                message.order = object.order | 0;
            return message;
        };

        /**
         * Creates a plain object from an UpdateChapter message. Also converts values to other types if specified.
         * @function toObject
         * @memberof lessons.UpdateChapter
         * @static
         * @param {lessons.UpdateChapter} message UpdateChapter
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateChapter.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.id = "";
                object.title = "";
                object.order = 0;
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.title != null && message.hasOwnProperty("title"))
                object.title = message.title;
            if (message.order != null && message.hasOwnProperty("order"))
                object.order = message.order;
            return object;
        };

        /**
         * Converts this UpdateChapter to JSON.
         * @function toJSON
         * @memberof lessons.UpdateChapter
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateChapter.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for UpdateChapter
         * @function getTypeUrl
         * @memberof lessons.UpdateChapter
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        UpdateChapter.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/lessons.UpdateChapter";
        };

        return UpdateChapter;
    })();

    lessons.UpdateChapterResponse = (function() {

        /**
         * Properties of an UpdateChapterResponse.
         * @memberof lessons
         * @interface IUpdateChapterResponse
         * @property {lessons.ILessonChapter|null} [chapter] UpdateChapterResponse chapter
         */

        /**
         * Constructs a new UpdateChapterResponse.
         * @memberof lessons
         * @classdesc Represents an UpdateChapterResponse.
         * @implements IUpdateChapterResponse
         * @constructor
         * @param {lessons.IUpdateChapterResponse=} [properties] Properties to set
         */
        function UpdateChapterResponse(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateChapterResponse chapter.
         * @member {lessons.ILessonChapter|null|undefined} chapter
         * @memberof lessons.UpdateChapterResponse
         * @instance
         */
        UpdateChapterResponse.prototype.chapter = null;

        /**
         * Creates a new UpdateChapterResponse instance using the specified properties.
         * @function create
         * @memberof lessons.UpdateChapterResponse
         * @static
         * @param {lessons.IUpdateChapterResponse=} [properties] Properties to set
         * @returns {lessons.UpdateChapterResponse} UpdateChapterResponse instance
         */
        UpdateChapterResponse.create = function create(properties) {
            return new UpdateChapterResponse(properties);
        };

        /**
         * Encodes the specified UpdateChapterResponse message. Does not implicitly {@link lessons.UpdateChapterResponse.verify|verify} messages.
         * @function encode
         * @memberof lessons.UpdateChapterResponse
         * @static
         * @param {lessons.IUpdateChapterResponse} message UpdateChapterResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateChapterResponse.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.chapter != null && Object.hasOwnProperty.call(message, "chapter"))
                $root.lessons.LessonChapter.encode(message.chapter, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified UpdateChapterResponse message, length delimited. Does not implicitly {@link lessons.UpdateChapterResponse.verify|verify} messages.
         * @function encodeDelimited
         * @memberof lessons.UpdateChapterResponse
         * @static
         * @param {lessons.IUpdateChapterResponse} message UpdateChapterResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateChapterResponse.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an UpdateChapterResponse message from the specified reader or buffer.
         * @function decode
         * @memberof lessons.UpdateChapterResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {lessons.UpdateChapterResponse} UpdateChapterResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateChapterResponse.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.lessons.UpdateChapterResponse();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.chapter = $root.lessons.LessonChapter.decode(reader, reader.uint32());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an UpdateChapterResponse message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof lessons.UpdateChapterResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {lessons.UpdateChapterResponse} UpdateChapterResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateChapterResponse.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an UpdateChapterResponse message.
         * @function verify
         * @memberof lessons.UpdateChapterResponse
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UpdateChapterResponse.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.chapter != null && message.hasOwnProperty("chapter")) {
                let error = $root.lessons.LessonChapter.verify(message.chapter);
                if (error)
                    return "chapter." + error;
            }
            return null;
        };

        /**
         * Creates an UpdateChapterResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof lessons.UpdateChapterResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {lessons.UpdateChapterResponse} UpdateChapterResponse
         */
        UpdateChapterResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.lessons.UpdateChapterResponse)
                return object;
            let message = new $root.lessons.UpdateChapterResponse();
            if (object.chapter != null) {
                if (typeof object.chapter !== "object")
                    throw TypeError(".lessons.UpdateChapterResponse.chapter: object expected");
                message.chapter = $root.lessons.LessonChapter.fromObject(object.chapter);
            }
            return message;
        };

        /**
         * Creates a plain object from an UpdateChapterResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof lessons.UpdateChapterResponse
         * @static
         * @param {lessons.UpdateChapterResponse} message UpdateChapterResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateChapterResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.chapter = null;
            if (message.chapter != null && message.hasOwnProperty("chapter"))
                object.chapter = $root.lessons.LessonChapter.toObject(message.chapter, options);
            return object;
        };

        /**
         * Converts this UpdateChapterResponse to JSON.
         * @function toJSON
         * @memberof lessons.UpdateChapterResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateChapterResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for UpdateChapterResponse
         * @function getTypeUrl
         * @memberof lessons.UpdateChapterResponse
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        UpdateChapterResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/lessons.UpdateChapterResponse";
        };

        return UpdateChapterResponse;
    })();

    lessons.DeleteChapter = (function() {

        /**
         * Properties of a DeleteChapter.
         * @memberof lessons
         * @interface IDeleteChapter
         * @property {string|null} [id] DeleteChapter id
         */

        /**
         * Constructs a new DeleteChapter.
         * @memberof lessons
         * @classdesc Represents a DeleteChapter.
         * @implements IDeleteChapter
         * @constructor
         * @param {lessons.IDeleteChapter=} [properties] Properties to set
         */
        function DeleteChapter(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * DeleteChapter id.
         * @member {string} id
         * @memberof lessons.DeleteChapter
         * @instance
         */
        DeleteChapter.prototype.id = "";

        /**
         * Creates a new DeleteChapter instance using the specified properties.
         * @function create
         * @memberof lessons.DeleteChapter
         * @static
         * @param {lessons.IDeleteChapter=} [properties] Properties to set
         * @returns {lessons.DeleteChapter} DeleteChapter instance
         */
        DeleteChapter.create = function create(properties) {
            return new DeleteChapter(properties);
        };

        /**
         * Encodes the specified DeleteChapter message. Does not implicitly {@link lessons.DeleteChapter.verify|verify} messages.
         * @function encode
         * @memberof lessons.DeleteChapter
         * @static
         * @param {lessons.IDeleteChapter} message DeleteChapter message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DeleteChapter.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            return writer;
        };

        /**
         * Encodes the specified DeleteChapter message, length delimited. Does not implicitly {@link lessons.DeleteChapter.verify|verify} messages.
         * @function encodeDelimited
         * @memberof lessons.DeleteChapter
         * @static
         * @param {lessons.IDeleteChapter} message DeleteChapter message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DeleteChapter.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a DeleteChapter message from the specified reader or buffer.
         * @function decode
         * @memberof lessons.DeleteChapter
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {lessons.DeleteChapter} DeleteChapter
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DeleteChapter.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.lessons.DeleteChapter();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.id = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a DeleteChapter message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof lessons.DeleteChapter
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {lessons.DeleteChapter} DeleteChapter
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DeleteChapter.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a DeleteChapter message.
         * @function verify
         * @memberof lessons.DeleteChapter
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        DeleteChapter.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            return null;
        };

        /**
         * Creates a DeleteChapter message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof lessons.DeleteChapter
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {lessons.DeleteChapter} DeleteChapter
         */
        DeleteChapter.fromObject = function fromObject(object) {
            if (object instanceof $root.lessons.DeleteChapter)
                return object;
            let message = new $root.lessons.DeleteChapter();
            if (object.id != null)
                message.id = String(object.id);
            return message;
        };

        /**
         * Creates a plain object from a DeleteChapter message. Also converts values to other types if specified.
         * @function toObject
         * @memberof lessons.DeleteChapter
         * @static
         * @param {lessons.DeleteChapter} message DeleteChapter
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DeleteChapter.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.id = "";
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            return object;
        };

        /**
         * Converts this DeleteChapter to JSON.
         * @function toJSON
         * @memberof lessons.DeleteChapter
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DeleteChapter.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for DeleteChapter
         * @function getTypeUrl
         * @memberof lessons.DeleteChapter
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        DeleteChapter.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/lessons.DeleteChapter";
        };

        return DeleteChapter;
    })();

    lessons.CreateContentBlock = (function() {

        /**
         * Properties of a CreateContentBlock.
         * @memberof lessons
         * @interface ICreateContentBlock
         * @property {string|null} [chapterId] CreateContentBlock chapterId
         * @property {number|null} [order] CreateContentBlock order
         * @property {lessons.ContentBlockType|null} [blockType] CreateContentBlock blockType
         */

        /**
         * Constructs a new CreateContentBlock.
         * @memberof lessons
         * @classdesc Represents a CreateContentBlock.
         * @implements ICreateContentBlock
         * @constructor
         * @param {lessons.ICreateContentBlock=} [properties] Properties to set
         */
        function CreateContentBlock(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CreateContentBlock chapterId.
         * @member {string} chapterId
         * @memberof lessons.CreateContentBlock
         * @instance
         */
        CreateContentBlock.prototype.chapterId = "";

        /**
         * CreateContentBlock order.
         * @member {number} order
         * @memberof lessons.CreateContentBlock
         * @instance
         */
        CreateContentBlock.prototype.order = 0;

        /**
         * CreateContentBlock blockType.
         * @member {lessons.ContentBlockType} blockType
         * @memberof lessons.CreateContentBlock
         * @instance
         */
        CreateContentBlock.prototype.blockType = 0;

        /**
         * Creates a new CreateContentBlock instance using the specified properties.
         * @function create
         * @memberof lessons.CreateContentBlock
         * @static
         * @param {lessons.ICreateContentBlock=} [properties] Properties to set
         * @returns {lessons.CreateContentBlock} CreateContentBlock instance
         */
        CreateContentBlock.create = function create(properties) {
            return new CreateContentBlock(properties);
        };

        /**
         * Encodes the specified CreateContentBlock message. Does not implicitly {@link lessons.CreateContentBlock.verify|verify} messages.
         * @function encode
         * @memberof lessons.CreateContentBlock
         * @static
         * @param {lessons.ICreateContentBlock} message CreateContentBlock message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateContentBlock.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.chapterId != null && Object.hasOwnProperty.call(message, "chapterId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.chapterId);
            if (message.order != null && Object.hasOwnProperty.call(message, "order"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.order);
            if (message.blockType != null && Object.hasOwnProperty.call(message, "blockType"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.blockType);
            return writer;
        };

        /**
         * Encodes the specified CreateContentBlock message, length delimited. Does not implicitly {@link lessons.CreateContentBlock.verify|verify} messages.
         * @function encodeDelimited
         * @memberof lessons.CreateContentBlock
         * @static
         * @param {lessons.ICreateContentBlock} message CreateContentBlock message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateContentBlock.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CreateContentBlock message from the specified reader or buffer.
         * @function decode
         * @memberof lessons.CreateContentBlock
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {lessons.CreateContentBlock} CreateContentBlock
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateContentBlock.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.lessons.CreateContentBlock();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.chapterId = reader.string();
                        break;
                    }
                case 2: {
                        message.order = reader.int32();
                        break;
                    }
                case 3: {
                        message.blockType = reader.int32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CreateContentBlock message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof lessons.CreateContentBlock
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {lessons.CreateContentBlock} CreateContentBlock
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateContentBlock.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CreateContentBlock message.
         * @function verify
         * @memberof lessons.CreateContentBlock
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CreateContentBlock.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.chapterId != null && message.hasOwnProperty("chapterId"))
                if (!$util.isString(message.chapterId))
                    return "chapterId: string expected";
            if (message.order != null && message.hasOwnProperty("order"))
                if (!$util.isInteger(message.order))
                    return "order: integer expected";
            if (message.blockType != null && message.hasOwnProperty("blockType"))
                switch (message.blockType) {
                default:
                    return "blockType: enum value expected";
                case 0:
                case 1:
                    break;
                }
            return null;
        };

        /**
         * Creates a CreateContentBlock message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof lessons.CreateContentBlock
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {lessons.CreateContentBlock} CreateContentBlock
         */
        CreateContentBlock.fromObject = function fromObject(object) {
            if (object instanceof $root.lessons.CreateContentBlock)
                return object;
            let message = new $root.lessons.CreateContentBlock();
            if (object.chapterId != null)
                message.chapterId = String(object.chapterId);
            if (object.order != null)
                message.order = object.order | 0;
            switch (object.blockType) {
            default:
                if (typeof object.blockType === "number") {
                    message.blockType = object.blockType;
                    break;
                }
                break;
            case "CONTENT_BLOCK_TEXT":
            case 0:
                message.blockType = 0;
                break;
            case "CONTENT_BLOCK_ANNOTATION":
            case 1:
                message.blockType = 1;
                break;
            }
            return message;
        };

        /**
         * Creates a plain object from a CreateContentBlock message. Also converts values to other types if specified.
         * @function toObject
         * @memberof lessons.CreateContentBlock
         * @static
         * @param {lessons.CreateContentBlock} message CreateContentBlock
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CreateContentBlock.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.chapterId = "";
                object.order = 0;
                object.blockType = options.enums === String ? "CONTENT_BLOCK_TEXT" : 0;
            }
            if (message.chapterId != null && message.hasOwnProperty("chapterId"))
                object.chapterId = message.chapterId;
            if (message.order != null && message.hasOwnProperty("order"))
                object.order = message.order;
            if (message.blockType != null && message.hasOwnProperty("blockType"))
                object.blockType = options.enums === String ? $root.lessons.ContentBlockType[message.blockType] === undefined ? message.blockType : $root.lessons.ContentBlockType[message.blockType] : message.blockType;
            return object;
        };

        /**
         * Converts this CreateContentBlock to JSON.
         * @function toJSON
         * @memberof lessons.CreateContentBlock
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CreateContentBlock.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for CreateContentBlock
         * @function getTypeUrl
         * @memberof lessons.CreateContentBlock
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        CreateContentBlock.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/lessons.CreateContentBlock";
        };

        return CreateContentBlock;
    })();

    lessons.CreateContentBlockResponse = (function() {

        /**
         * Properties of a CreateContentBlockResponse.
         * @memberof lessons
         * @interface ICreateContentBlockResponse
         * @property {lessons.IContentBlock|null} [block] CreateContentBlockResponse block
         */

        /**
         * Constructs a new CreateContentBlockResponse.
         * @memberof lessons
         * @classdesc Represents a CreateContentBlockResponse.
         * @implements ICreateContentBlockResponse
         * @constructor
         * @param {lessons.ICreateContentBlockResponse=} [properties] Properties to set
         */
        function CreateContentBlockResponse(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CreateContentBlockResponse block.
         * @member {lessons.IContentBlock|null|undefined} block
         * @memberof lessons.CreateContentBlockResponse
         * @instance
         */
        CreateContentBlockResponse.prototype.block = null;

        /**
         * Creates a new CreateContentBlockResponse instance using the specified properties.
         * @function create
         * @memberof lessons.CreateContentBlockResponse
         * @static
         * @param {lessons.ICreateContentBlockResponse=} [properties] Properties to set
         * @returns {lessons.CreateContentBlockResponse} CreateContentBlockResponse instance
         */
        CreateContentBlockResponse.create = function create(properties) {
            return new CreateContentBlockResponse(properties);
        };

        /**
         * Encodes the specified CreateContentBlockResponse message. Does not implicitly {@link lessons.CreateContentBlockResponse.verify|verify} messages.
         * @function encode
         * @memberof lessons.CreateContentBlockResponse
         * @static
         * @param {lessons.ICreateContentBlockResponse} message CreateContentBlockResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateContentBlockResponse.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.block != null && Object.hasOwnProperty.call(message, "block"))
                $root.lessons.ContentBlock.encode(message.block, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified CreateContentBlockResponse message, length delimited. Does not implicitly {@link lessons.CreateContentBlockResponse.verify|verify} messages.
         * @function encodeDelimited
         * @memberof lessons.CreateContentBlockResponse
         * @static
         * @param {lessons.ICreateContentBlockResponse} message CreateContentBlockResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateContentBlockResponse.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CreateContentBlockResponse message from the specified reader or buffer.
         * @function decode
         * @memberof lessons.CreateContentBlockResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {lessons.CreateContentBlockResponse} CreateContentBlockResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateContentBlockResponse.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.lessons.CreateContentBlockResponse();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.block = $root.lessons.ContentBlock.decode(reader, reader.uint32());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CreateContentBlockResponse message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof lessons.CreateContentBlockResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {lessons.CreateContentBlockResponse} CreateContentBlockResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateContentBlockResponse.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CreateContentBlockResponse message.
         * @function verify
         * @memberof lessons.CreateContentBlockResponse
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CreateContentBlockResponse.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.block != null && message.hasOwnProperty("block")) {
                let error = $root.lessons.ContentBlock.verify(message.block);
                if (error)
                    return "block." + error;
            }
            return null;
        };

        /**
         * Creates a CreateContentBlockResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof lessons.CreateContentBlockResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {lessons.CreateContentBlockResponse} CreateContentBlockResponse
         */
        CreateContentBlockResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.lessons.CreateContentBlockResponse)
                return object;
            let message = new $root.lessons.CreateContentBlockResponse();
            if (object.block != null) {
                if (typeof object.block !== "object")
                    throw TypeError(".lessons.CreateContentBlockResponse.block: object expected");
                message.block = $root.lessons.ContentBlock.fromObject(object.block);
            }
            return message;
        };

        /**
         * Creates a plain object from a CreateContentBlockResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof lessons.CreateContentBlockResponse
         * @static
         * @param {lessons.CreateContentBlockResponse} message CreateContentBlockResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CreateContentBlockResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.block = null;
            if (message.block != null && message.hasOwnProperty("block"))
                object.block = $root.lessons.ContentBlock.toObject(message.block, options);
            return object;
        };

        /**
         * Converts this CreateContentBlockResponse to JSON.
         * @function toJSON
         * @memberof lessons.CreateContentBlockResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CreateContentBlockResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for CreateContentBlockResponse
         * @function getTypeUrl
         * @memberof lessons.CreateContentBlockResponse
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        CreateContentBlockResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/lessons.CreateContentBlockResponse";
        };

        return CreateContentBlockResponse;
    })();

    lessons.UpdateContentBlock = (function() {

        /**
         * Properties of an UpdateContentBlock.
         * @memberof lessons
         * @interface IUpdateContentBlock
         * @property {string|null} [id] UpdateContentBlock id
         * @property {number|null} [order] UpdateContentBlock order
         * @property {string|null} [richText] UpdateContentBlock richText
         * @property {lessons.TextBlockStyle|null} [textStyle] UpdateContentBlock textStyle
         * @property {string|null} [annotationId] UpdateContentBlock annotationId
         */

        /**
         * Constructs a new UpdateContentBlock.
         * @memberof lessons
         * @classdesc Represents an UpdateContentBlock.
         * @implements IUpdateContentBlock
         * @constructor
         * @param {lessons.IUpdateContentBlock=} [properties] Properties to set
         */
        function UpdateContentBlock(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateContentBlock id.
         * @member {string} id
         * @memberof lessons.UpdateContentBlock
         * @instance
         */
        UpdateContentBlock.prototype.id = "";

        /**
         * UpdateContentBlock order.
         * @member {number} order
         * @memberof lessons.UpdateContentBlock
         * @instance
         */
        UpdateContentBlock.prototype.order = 0;

        /**
         * UpdateContentBlock richText.
         * @member {string} richText
         * @memberof lessons.UpdateContentBlock
         * @instance
         */
        UpdateContentBlock.prototype.richText = "";

        /**
         * UpdateContentBlock textStyle.
         * @member {lessons.TextBlockStyle} textStyle
         * @memberof lessons.UpdateContentBlock
         * @instance
         */
        UpdateContentBlock.prototype.textStyle = 0;

        /**
         * UpdateContentBlock annotationId.
         * @member {string} annotationId
         * @memberof lessons.UpdateContentBlock
         * @instance
         */
        UpdateContentBlock.prototype.annotationId = "";

        /**
         * Creates a new UpdateContentBlock instance using the specified properties.
         * @function create
         * @memberof lessons.UpdateContentBlock
         * @static
         * @param {lessons.IUpdateContentBlock=} [properties] Properties to set
         * @returns {lessons.UpdateContentBlock} UpdateContentBlock instance
         */
        UpdateContentBlock.create = function create(properties) {
            return new UpdateContentBlock(properties);
        };

        /**
         * Encodes the specified UpdateContentBlock message. Does not implicitly {@link lessons.UpdateContentBlock.verify|verify} messages.
         * @function encode
         * @memberof lessons.UpdateContentBlock
         * @static
         * @param {lessons.IUpdateContentBlock} message UpdateContentBlock message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateContentBlock.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            if (message.order != null && Object.hasOwnProperty.call(message, "order"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.order);
            if (message.richText != null && Object.hasOwnProperty.call(message, "richText"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.richText);
            if (message.textStyle != null && Object.hasOwnProperty.call(message, "textStyle"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.textStyle);
            if (message.annotationId != null && Object.hasOwnProperty.call(message, "annotationId"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.annotationId);
            return writer;
        };

        /**
         * Encodes the specified UpdateContentBlock message, length delimited. Does not implicitly {@link lessons.UpdateContentBlock.verify|verify} messages.
         * @function encodeDelimited
         * @memberof lessons.UpdateContentBlock
         * @static
         * @param {lessons.IUpdateContentBlock} message UpdateContentBlock message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateContentBlock.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an UpdateContentBlock message from the specified reader or buffer.
         * @function decode
         * @memberof lessons.UpdateContentBlock
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {lessons.UpdateContentBlock} UpdateContentBlock
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateContentBlock.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.lessons.UpdateContentBlock();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.id = reader.string();
                        break;
                    }
                case 2: {
                        message.order = reader.int32();
                        break;
                    }
                case 3: {
                        message.richText = reader.string();
                        break;
                    }
                case 4: {
                        message.textStyle = reader.int32();
                        break;
                    }
                case 5: {
                        message.annotationId = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an UpdateContentBlock message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof lessons.UpdateContentBlock
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {lessons.UpdateContentBlock} UpdateContentBlock
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateContentBlock.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an UpdateContentBlock message.
         * @function verify
         * @memberof lessons.UpdateContentBlock
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UpdateContentBlock.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.order != null && message.hasOwnProperty("order"))
                if (!$util.isInteger(message.order))
                    return "order: integer expected";
            if (message.richText != null && message.hasOwnProperty("richText"))
                if (!$util.isString(message.richText))
                    return "richText: string expected";
            if (message.textStyle != null && message.hasOwnProperty("textStyle"))
                switch (message.textStyle) {
                default:
                    return "textStyle: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                    break;
                }
            if (message.annotationId != null && message.hasOwnProperty("annotationId"))
                if (!$util.isString(message.annotationId))
                    return "annotationId: string expected";
            return null;
        };

        /**
         * Creates an UpdateContentBlock message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof lessons.UpdateContentBlock
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {lessons.UpdateContentBlock} UpdateContentBlock
         */
        UpdateContentBlock.fromObject = function fromObject(object) {
            if (object instanceof $root.lessons.UpdateContentBlock)
                return object;
            let message = new $root.lessons.UpdateContentBlock();
            if (object.id != null)
                message.id = String(object.id);
            if (object.order != null)
                message.order = object.order | 0;
            if (object.richText != null)
                message.richText = String(object.richText);
            switch (object.textStyle) {
            default:
                if (typeof object.textStyle === "number") {
                    message.textStyle = object.textStyle;
                    break;
                }
                break;
            case "TEXT_STYLE_NORMAL":
            case 0:
                message.textStyle = 0;
                break;
            case "TEXT_STYLE_GOOD_EMPHASIS":
            case 1:
                message.textStyle = 1;
                break;
            case "TEXT_STYLE_BAD_EMPHASIS":
            case 2:
                message.textStyle = 2;
                break;
            case "TEXT_STYLE_EMPHASIS":
            case 3:
                message.textStyle = 3;
                break;
            case "TEXT_STYLE_THEORY":
            case 4:
                message.textStyle = 4;
                break;
            }
            if (object.annotationId != null)
                message.annotationId = String(object.annotationId);
            return message;
        };

        /**
         * Creates a plain object from an UpdateContentBlock message. Also converts values to other types if specified.
         * @function toObject
         * @memberof lessons.UpdateContentBlock
         * @static
         * @param {lessons.UpdateContentBlock} message UpdateContentBlock
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateContentBlock.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.id = "";
                object.order = 0;
                object.richText = "";
                object.textStyle = options.enums === String ? "TEXT_STYLE_NORMAL" : 0;
                object.annotationId = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.order != null && message.hasOwnProperty("order"))
                object.order = message.order;
            if (message.richText != null && message.hasOwnProperty("richText"))
                object.richText = message.richText;
            if (message.textStyle != null && message.hasOwnProperty("textStyle"))
                object.textStyle = options.enums === String ? $root.lessons.TextBlockStyle[message.textStyle] === undefined ? message.textStyle : $root.lessons.TextBlockStyle[message.textStyle] : message.textStyle;
            if (message.annotationId != null && message.hasOwnProperty("annotationId"))
                object.annotationId = message.annotationId;
            return object;
        };

        /**
         * Converts this UpdateContentBlock to JSON.
         * @function toJSON
         * @memberof lessons.UpdateContentBlock
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateContentBlock.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for UpdateContentBlock
         * @function getTypeUrl
         * @memberof lessons.UpdateContentBlock
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        UpdateContentBlock.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/lessons.UpdateContentBlock";
        };

        return UpdateContentBlock;
    })();

    lessons.UpdateContentBlockResponse = (function() {

        /**
         * Properties of an UpdateContentBlockResponse.
         * @memberof lessons
         * @interface IUpdateContentBlockResponse
         * @property {lessons.IContentBlock|null} [block] UpdateContentBlockResponse block
         */

        /**
         * Constructs a new UpdateContentBlockResponse.
         * @memberof lessons
         * @classdesc Represents an UpdateContentBlockResponse.
         * @implements IUpdateContentBlockResponse
         * @constructor
         * @param {lessons.IUpdateContentBlockResponse=} [properties] Properties to set
         */
        function UpdateContentBlockResponse(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateContentBlockResponse block.
         * @member {lessons.IContentBlock|null|undefined} block
         * @memberof lessons.UpdateContentBlockResponse
         * @instance
         */
        UpdateContentBlockResponse.prototype.block = null;

        /**
         * Creates a new UpdateContentBlockResponse instance using the specified properties.
         * @function create
         * @memberof lessons.UpdateContentBlockResponse
         * @static
         * @param {lessons.IUpdateContentBlockResponse=} [properties] Properties to set
         * @returns {lessons.UpdateContentBlockResponse} UpdateContentBlockResponse instance
         */
        UpdateContentBlockResponse.create = function create(properties) {
            return new UpdateContentBlockResponse(properties);
        };

        /**
         * Encodes the specified UpdateContentBlockResponse message. Does not implicitly {@link lessons.UpdateContentBlockResponse.verify|verify} messages.
         * @function encode
         * @memberof lessons.UpdateContentBlockResponse
         * @static
         * @param {lessons.IUpdateContentBlockResponse} message UpdateContentBlockResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateContentBlockResponse.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.block != null && Object.hasOwnProperty.call(message, "block"))
                $root.lessons.ContentBlock.encode(message.block, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified UpdateContentBlockResponse message, length delimited. Does not implicitly {@link lessons.UpdateContentBlockResponse.verify|verify} messages.
         * @function encodeDelimited
         * @memberof lessons.UpdateContentBlockResponse
         * @static
         * @param {lessons.IUpdateContentBlockResponse} message UpdateContentBlockResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateContentBlockResponse.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an UpdateContentBlockResponse message from the specified reader or buffer.
         * @function decode
         * @memberof lessons.UpdateContentBlockResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {lessons.UpdateContentBlockResponse} UpdateContentBlockResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateContentBlockResponse.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.lessons.UpdateContentBlockResponse();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.block = $root.lessons.ContentBlock.decode(reader, reader.uint32());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an UpdateContentBlockResponse message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof lessons.UpdateContentBlockResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {lessons.UpdateContentBlockResponse} UpdateContentBlockResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateContentBlockResponse.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an UpdateContentBlockResponse message.
         * @function verify
         * @memberof lessons.UpdateContentBlockResponse
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UpdateContentBlockResponse.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.block != null && message.hasOwnProperty("block")) {
                let error = $root.lessons.ContentBlock.verify(message.block);
                if (error)
                    return "block." + error;
            }
            return null;
        };

        /**
         * Creates an UpdateContentBlockResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof lessons.UpdateContentBlockResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {lessons.UpdateContentBlockResponse} UpdateContentBlockResponse
         */
        UpdateContentBlockResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.lessons.UpdateContentBlockResponse)
                return object;
            let message = new $root.lessons.UpdateContentBlockResponse();
            if (object.block != null) {
                if (typeof object.block !== "object")
                    throw TypeError(".lessons.UpdateContentBlockResponse.block: object expected");
                message.block = $root.lessons.ContentBlock.fromObject(object.block);
            }
            return message;
        };

        /**
         * Creates a plain object from an UpdateContentBlockResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof lessons.UpdateContentBlockResponse
         * @static
         * @param {lessons.UpdateContentBlockResponse} message UpdateContentBlockResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateContentBlockResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.block = null;
            if (message.block != null && message.hasOwnProperty("block"))
                object.block = $root.lessons.ContentBlock.toObject(message.block, options);
            return object;
        };

        /**
         * Converts this UpdateContentBlockResponse to JSON.
         * @function toJSON
         * @memberof lessons.UpdateContentBlockResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateContentBlockResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for UpdateContentBlockResponse
         * @function getTypeUrl
         * @memberof lessons.UpdateContentBlockResponse
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        UpdateContentBlockResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/lessons.UpdateContentBlockResponse";
        };

        return UpdateContentBlockResponse;
    })();

    lessons.DeleteContentBlock = (function() {

        /**
         * Properties of a DeleteContentBlock.
         * @memberof lessons
         * @interface IDeleteContentBlock
         * @property {string|null} [id] DeleteContentBlock id
         */

        /**
         * Constructs a new DeleteContentBlock.
         * @memberof lessons
         * @classdesc Represents a DeleteContentBlock.
         * @implements IDeleteContentBlock
         * @constructor
         * @param {lessons.IDeleteContentBlock=} [properties] Properties to set
         */
        function DeleteContentBlock(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * DeleteContentBlock id.
         * @member {string} id
         * @memberof lessons.DeleteContentBlock
         * @instance
         */
        DeleteContentBlock.prototype.id = "";

        /**
         * Creates a new DeleteContentBlock instance using the specified properties.
         * @function create
         * @memberof lessons.DeleteContentBlock
         * @static
         * @param {lessons.IDeleteContentBlock=} [properties] Properties to set
         * @returns {lessons.DeleteContentBlock} DeleteContentBlock instance
         */
        DeleteContentBlock.create = function create(properties) {
            return new DeleteContentBlock(properties);
        };

        /**
         * Encodes the specified DeleteContentBlock message. Does not implicitly {@link lessons.DeleteContentBlock.verify|verify} messages.
         * @function encode
         * @memberof lessons.DeleteContentBlock
         * @static
         * @param {lessons.IDeleteContentBlock} message DeleteContentBlock message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DeleteContentBlock.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            return writer;
        };

        /**
         * Encodes the specified DeleteContentBlock message, length delimited. Does not implicitly {@link lessons.DeleteContentBlock.verify|verify} messages.
         * @function encodeDelimited
         * @memberof lessons.DeleteContentBlock
         * @static
         * @param {lessons.IDeleteContentBlock} message DeleteContentBlock message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DeleteContentBlock.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a DeleteContentBlock message from the specified reader or buffer.
         * @function decode
         * @memberof lessons.DeleteContentBlock
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {lessons.DeleteContentBlock} DeleteContentBlock
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DeleteContentBlock.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.lessons.DeleteContentBlock();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.id = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a DeleteContentBlock message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof lessons.DeleteContentBlock
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {lessons.DeleteContentBlock} DeleteContentBlock
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DeleteContentBlock.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a DeleteContentBlock message.
         * @function verify
         * @memberof lessons.DeleteContentBlock
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        DeleteContentBlock.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            return null;
        };

        /**
         * Creates a DeleteContentBlock message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof lessons.DeleteContentBlock
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {lessons.DeleteContentBlock} DeleteContentBlock
         */
        DeleteContentBlock.fromObject = function fromObject(object) {
            if (object instanceof $root.lessons.DeleteContentBlock)
                return object;
            let message = new $root.lessons.DeleteContentBlock();
            if (object.id != null)
                message.id = String(object.id);
            return message;
        };

        /**
         * Creates a plain object from a DeleteContentBlock message. Also converts values to other types if specified.
         * @function toObject
         * @memberof lessons.DeleteContentBlock
         * @static
         * @param {lessons.DeleteContentBlock} message DeleteContentBlock
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DeleteContentBlock.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.id = "";
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            return object;
        };

        /**
         * Converts this DeleteContentBlock to JSON.
         * @function toJSON
         * @memberof lessons.DeleteContentBlock
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DeleteContentBlock.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for DeleteContentBlock
         * @function getTypeUrl
         * @memberof lessons.DeleteContentBlock
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        DeleteContentBlock.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/lessons.DeleteContentBlock";
        };

        return DeleteContentBlock;
    })();

    lessons.AddLessonAsset = (function() {

        /**
         * Properties of an AddLessonAsset.
         * @memberof lessons
         * @interface IAddLessonAsset
         * @property {string|null} [lessonId] AddLessonAsset lessonId
         * @property {string|null} [fileId] AddLessonAsset fileId
         */

        /**
         * Constructs a new AddLessonAsset.
         * @memberof lessons
         * @classdesc Represents an AddLessonAsset.
         * @implements IAddLessonAsset
         * @constructor
         * @param {lessons.IAddLessonAsset=} [properties] Properties to set
         */
        function AddLessonAsset(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddLessonAsset lessonId.
         * @member {string} lessonId
         * @memberof lessons.AddLessonAsset
         * @instance
         */
        AddLessonAsset.prototype.lessonId = "";

        /**
         * AddLessonAsset fileId.
         * @member {string} fileId
         * @memberof lessons.AddLessonAsset
         * @instance
         */
        AddLessonAsset.prototype.fileId = "";

        /**
         * Creates a new AddLessonAsset instance using the specified properties.
         * @function create
         * @memberof lessons.AddLessonAsset
         * @static
         * @param {lessons.IAddLessonAsset=} [properties] Properties to set
         * @returns {lessons.AddLessonAsset} AddLessonAsset instance
         */
        AddLessonAsset.create = function create(properties) {
            return new AddLessonAsset(properties);
        };

        /**
         * Encodes the specified AddLessonAsset message. Does not implicitly {@link lessons.AddLessonAsset.verify|verify} messages.
         * @function encode
         * @memberof lessons.AddLessonAsset
         * @static
         * @param {lessons.IAddLessonAsset} message AddLessonAsset message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AddLessonAsset.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.lessonId != null && Object.hasOwnProperty.call(message, "lessonId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.lessonId);
            if (message.fileId != null && Object.hasOwnProperty.call(message, "fileId"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.fileId);
            return writer;
        };

        /**
         * Encodes the specified AddLessonAsset message, length delimited. Does not implicitly {@link lessons.AddLessonAsset.verify|verify} messages.
         * @function encodeDelimited
         * @memberof lessons.AddLessonAsset
         * @static
         * @param {lessons.IAddLessonAsset} message AddLessonAsset message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AddLessonAsset.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an AddLessonAsset message from the specified reader or buffer.
         * @function decode
         * @memberof lessons.AddLessonAsset
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {lessons.AddLessonAsset} AddLessonAsset
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AddLessonAsset.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.lessons.AddLessonAsset();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.lessonId = reader.string();
                        break;
                    }
                case 2: {
                        message.fileId = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an AddLessonAsset message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof lessons.AddLessonAsset
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {lessons.AddLessonAsset} AddLessonAsset
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AddLessonAsset.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an AddLessonAsset message.
         * @function verify
         * @memberof lessons.AddLessonAsset
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        AddLessonAsset.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.lessonId != null && message.hasOwnProperty("lessonId"))
                if (!$util.isString(message.lessonId))
                    return "lessonId: string expected";
            if (message.fileId != null && message.hasOwnProperty("fileId"))
                if (!$util.isString(message.fileId))
                    return "fileId: string expected";
            return null;
        };

        /**
         * Creates an AddLessonAsset message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof lessons.AddLessonAsset
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {lessons.AddLessonAsset} AddLessonAsset
         */
        AddLessonAsset.fromObject = function fromObject(object) {
            if (object instanceof $root.lessons.AddLessonAsset)
                return object;
            let message = new $root.lessons.AddLessonAsset();
            if (object.lessonId != null)
                message.lessonId = String(object.lessonId);
            if (object.fileId != null)
                message.fileId = String(object.fileId);
            return message;
        };

        /**
         * Creates a plain object from an AddLessonAsset message. Also converts values to other types if specified.
         * @function toObject
         * @memberof lessons.AddLessonAsset
         * @static
         * @param {lessons.AddLessonAsset} message AddLessonAsset
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddLessonAsset.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.lessonId = "";
                object.fileId = "";
            }
            if (message.lessonId != null && message.hasOwnProperty("lessonId"))
                object.lessonId = message.lessonId;
            if (message.fileId != null && message.hasOwnProperty("fileId"))
                object.fileId = message.fileId;
            return object;
        };

        /**
         * Converts this AddLessonAsset to JSON.
         * @function toJSON
         * @memberof lessons.AddLessonAsset
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddLessonAsset.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for AddLessonAsset
         * @function getTypeUrl
         * @memberof lessons.AddLessonAsset
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        AddLessonAsset.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/lessons.AddLessonAsset";
        };

        return AddLessonAsset;
    })();

    lessons.ListPublishedAnnotations = (function() {

        /**
         * Properties of a ListPublishedAnnotations.
         * @memberof lessons
         * @interface IListPublishedAnnotations
         * @property {common.IPagination|null} [pagination] ListPublishedAnnotations pagination
         * @property {string|null} [searchQuery] ListPublishedAnnotations searchQuery
         */

        /**
         * Constructs a new ListPublishedAnnotations.
         * @memberof lessons
         * @classdesc Represents a ListPublishedAnnotations.
         * @implements IListPublishedAnnotations
         * @constructor
         * @param {lessons.IListPublishedAnnotations=} [properties] Properties to set
         */
        function ListPublishedAnnotations(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListPublishedAnnotations pagination.
         * @member {common.IPagination|null|undefined} pagination
         * @memberof lessons.ListPublishedAnnotations
         * @instance
         */
        ListPublishedAnnotations.prototype.pagination = null;

        /**
         * ListPublishedAnnotations searchQuery.
         * @member {string} searchQuery
         * @memberof lessons.ListPublishedAnnotations
         * @instance
         */
        ListPublishedAnnotations.prototype.searchQuery = "";

        /**
         * Creates a new ListPublishedAnnotations instance using the specified properties.
         * @function create
         * @memberof lessons.ListPublishedAnnotations
         * @static
         * @param {lessons.IListPublishedAnnotations=} [properties] Properties to set
         * @returns {lessons.ListPublishedAnnotations} ListPublishedAnnotations instance
         */
        ListPublishedAnnotations.create = function create(properties) {
            return new ListPublishedAnnotations(properties);
        };

        /**
         * Encodes the specified ListPublishedAnnotations message. Does not implicitly {@link lessons.ListPublishedAnnotations.verify|verify} messages.
         * @function encode
         * @memberof lessons.ListPublishedAnnotations
         * @static
         * @param {lessons.IListPublishedAnnotations} message ListPublishedAnnotations message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListPublishedAnnotations.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pagination != null && Object.hasOwnProperty.call(message, "pagination"))
                $root.common.Pagination.encode(message.pagination, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.searchQuery != null && Object.hasOwnProperty.call(message, "searchQuery"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.searchQuery);
            return writer;
        };

        /**
         * Encodes the specified ListPublishedAnnotations message, length delimited. Does not implicitly {@link lessons.ListPublishedAnnotations.verify|verify} messages.
         * @function encodeDelimited
         * @memberof lessons.ListPublishedAnnotations
         * @static
         * @param {lessons.IListPublishedAnnotations} message ListPublishedAnnotations message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListPublishedAnnotations.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ListPublishedAnnotations message from the specified reader or buffer.
         * @function decode
         * @memberof lessons.ListPublishedAnnotations
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {lessons.ListPublishedAnnotations} ListPublishedAnnotations
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListPublishedAnnotations.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.lessons.ListPublishedAnnotations();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.pagination = $root.common.Pagination.decode(reader, reader.uint32());
                        break;
                    }
                case 2: {
                        message.searchQuery = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ListPublishedAnnotations message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof lessons.ListPublishedAnnotations
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {lessons.ListPublishedAnnotations} ListPublishedAnnotations
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListPublishedAnnotations.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ListPublishedAnnotations message.
         * @function verify
         * @memberof lessons.ListPublishedAnnotations
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ListPublishedAnnotations.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.pagination != null && message.hasOwnProperty("pagination")) {
                let error = $root.common.Pagination.verify(message.pagination);
                if (error)
                    return "pagination." + error;
            }
            if (message.searchQuery != null && message.hasOwnProperty("searchQuery"))
                if (!$util.isString(message.searchQuery))
                    return "searchQuery: string expected";
            return null;
        };

        /**
         * Creates a ListPublishedAnnotations message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof lessons.ListPublishedAnnotations
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {lessons.ListPublishedAnnotations} ListPublishedAnnotations
         */
        ListPublishedAnnotations.fromObject = function fromObject(object) {
            if (object instanceof $root.lessons.ListPublishedAnnotations)
                return object;
            let message = new $root.lessons.ListPublishedAnnotations();
            if (object.pagination != null) {
                if (typeof object.pagination !== "object")
                    throw TypeError(".lessons.ListPublishedAnnotations.pagination: object expected");
                message.pagination = $root.common.Pagination.fromObject(object.pagination);
            }
            if (object.searchQuery != null)
                message.searchQuery = String(object.searchQuery);
            return message;
        };

        /**
         * Creates a plain object from a ListPublishedAnnotations message. Also converts values to other types if specified.
         * @function toObject
         * @memberof lessons.ListPublishedAnnotations
         * @static
         * @param {lessons.ListPublishedAnnotations} message ListPublishedAnnotations
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListPublishedAnnotations.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.pagination = null;
                object.searchQuery = "";
            }
            if (message.pagination != null && message.hasOwnProperty("pagination"))
                object.pagination = $root.common.Pagination.toObject(message.pagination, options);
            if (message.searchQuery != null && message.hasOwnProperty("searchQuery"))
                object.searchQuery = message.searchQuery;
            return object;
        };

        /**
         * Converts this ListPublishedAnnotations to JSON.
         * @function toJSON
         * @memberof lessons.ListPublishedAnnotations
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListPublishedAnnotations.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ListPublishedAnnotations
         * @function getTypeUrl
         * @memberof lessons.ListPublishedAnnotations
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ListPublishedAnnotations.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/lessons.ListPublishedAnnotations";
        };

        return ListPublishedAnnotations;
    })();

    lessons.ListPublishedAnnotationsResponse = (function() {

        /**
         * Properties of a ListPublishedAnnotationsResponse.
         * @memberof lessons
         * @interface IListPublishedAnnotationsResponse
         * @property {common.IPagination|null} [pagination] ListPublishedAnnotationsResponse pagination
         * @property {Array.<lessons.IVideoExample>|null} [annotations] ListPublishedAnnotationsResponse annotations
         */

        /**
         * Constructs a new ListPublishedAnnotationsResponse.
         * @memberof lessons
         * @classdesc Represents a ListPublishedAnnotationsResponse.
         * @implements IListPublishedAnnotationsResponse
         * @constructor
         * @param {lessons.IListPublishedAnnotationsResponse=} [properties] Properties to set
         */
        function ListPublishedAnnotationsResponse(properties) {
            this.annotations = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListPublishedAnnotationsResponse pagination.
         * @member {common.IPagination|null|undefined} pagination
         * @memberof lessons.ListPublishedAnnotationsResponse
         * @instance
         */
        ListPublishedAnnotationsResponse.prototype.pagination = null;

        /**
         * ListPublishedAnnotationsResponse annotations.
         * @member {Array.<lessons.IVideoExample>} annotations
         * @memberof lessons.ListPublishedAnnotationsResponse
         * @instance
         */
        ListPublishedAnnotationsResponse.prototype.annotations = $util.emptyArray;

        /**
         * Creates a new ListPublishedAnnotationsResponse instance using the specified properties.
         * @function create
         * @memberof lessons.ListPublishedAnnotationsResponse
         * @static
         * @param {lessons.IListPublishedAnnotationsResponse=} [properties] Properties to set
         * @returns {lessons.ListPublishedAnnotationsResponse} ListPublishedAnnotationsResponse instance
         */
        ListPublishedAnnotationsResponse.create = function create(properties) {
            return new ListPublishedAnnotationsResponse(properties);
        };

        /**
         * Encodes the specified ListPublishedAnnotationsResponse message. Does not implicitly {@link lessons.ListPublishedAnnotationsResponse.verify|verify} messages.
         * @function encode
         * @memberof lessons.ListPublishedAnnotationsResponse
         * @static
         * @param {lessons.IListPublishedAnnotationsResponse} message ListPublishedAnnotationsResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListPublishedAnnotationsResponse.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pagination != null && Object.hasOwnProperty.call(message, "pagination"))
                $root.common.Pagination.encode(message.pagination, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.annotations != null && message.annotations.length)
                for (let i = 0; i < message.annotations.length; ++i)
                    $root.lessons.VideoExample.encode(message.annotations[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified ListPublishedAnnotationsResponse message, length delimited. Does not implicitly {@link lessons.ListPublishedAnnotationsResponse.verify|verify} messages.
         * @function encodeDelimited
         * @memberof lessons.ListPublishedAnnotationsResponse
         * @static
         * @param {lessons.IListPublishedAnnotationsResponse} message ListPublishedAnnotationsResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListPublishedAnnotationsResponse.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ListPublishedAnnotationsResponse message from the specified reader or buffer.
         * @function decode
         * @memberof lessons.ListPublishedAnnotationsResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {lessons.ListPublishedAnnotationsResponse} ListPublishedAnnotationsResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListPublishedAnnotationsResponse.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.lessons.ListPublishedAnnotationsResponse();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.pagination = $root.common.Pagination.decode(reader, reader.uint32());
                        break;
                    }
                case 2: {
                        if (!(message.annotations && message.annotations.length))
                            message.annotations = [];
                        message.annotations.push($root.lessons.VideoExample.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ListPublishedAnnotationsResponse message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof lessons.ListPublishedAnnotationsResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {lessons.ListPublishedAnnotationsResponse} ListPublishedAnnotationsResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListPublishedAnnotationsResponse.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ListPublishedAnnotationsResponse message.
         * @function verify
         * @memberof lessons.ListPublishedAnnotationsResponse
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ListPublishedAnnotationsResponse.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.pagination != null && message.hasOwnProperty("pagination")) {
                let error = $root.common.Pagination.verify(message.pagination);
                if (error)
                    return "pagination." + error;
            }
            if (message.annotations != null && message.hasOwnProperty("annotations")) {
                if (!Array.isArray(message.annotations))
                    return "annotations: array expected";
                for (let i = 0; i < message.annotations.length; ++i) {
                    let error = $root.lessons.VideoExample.verify(message.annotations[i]);
                    if (error)
                        return "annotations." + error;
                }
            }
            return null;
        };

        /**
         * Creates a ListPublishedAnnotationsResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof lessons.ListPublishedAnnotationsResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {lessons.ListPublishedAnnotationsResponse} ListPublishedAnnotationsResponse
         */
        ListPublishedAnnotationsResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.lessons.ListPublishedAnnotationsResponse)
                return object;
            let message = new $root.lessons.ListPublishedAnnotationsResponse();
            if (object.pagination != null) {
                if (typeof object.pagination !== "object")
                    throw TypeError(".lessons.ListPublishedAnnotationsResponse.pagination: object expected");
                message.pagination = $root.common.Pagination.fromObject(object.pagination);
            }
            if (object.annotations) {
                if (!Array.isArray(object.annotations))
                    throw TypeError(".lessons.ListPublishedAnnotationsResponse.annotations: array expected");
                message.annotations = [];
                for (let i = 0; i < object.annotations.length; ++i) {
                    if (typeof object.annotations[i] !== "object")
                        throw TypeError(".lessons.ListPublishedAnnotationsResponse.annotations: object expected");
                    message.annotations[i] = $root.lessons.VideoExample.fromObject(object.annotations[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a ListPublishedAnnotationsResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof lessons.ListPublishedAnnotationsResponse
         * @static
         * @param {lessons.ListPublishedAnnotationsResponse} message ListPublishedAnnotationsResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListPublishedAnnotationsResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.annotations = [];
            if (options.defaults)
                object.pagination = null;
            if (message.pagination != null && message.hasOwnProperty("pagination"))
                object.pagination = $root.common.Pagination.toObject(message.pagination, options);
            if (message.annotations && message.annotations.length) {
                object.annotations = [];
                for (let j = 0; j < message.annotations.length; ++j)
                    object.annotations[j] = $root.lessons.VideoExample.toObject(message.annotations[j], options);
            }
            return object;
        };

        /**
         * Converts this ListPublishedAnnotationsResponse to JSON.
         * @function toJSON
         * @memberof lessons.ListPublishedAnnotationsResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListPublishedAnnotationsResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ListPublishedAnnotationsResponse
         * @function getTypeUrl
         * @memberof lessons.ListPublishedAnnotationsResponse
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ListPublishedAnnotationsResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/lessons.ListPublishedAnnotationsResponse";
        };

        return ListPublishedAnnotationsResponse;
    })();

    lessons.LessonSummary = (function() {

        /**
         * Properties of a LessonSummary.
         * @memberof lessons
         * @interface ILessonSummary
         * @property {string|null} [id] LessonSummary id
         * @property {string|null} [title] LessonSummary title
         * @property {string|null} [description] LessonSummary description
         * @property {string|null} [thumbnailUrl] LessonSummary thumbnailUrl
         * @property {number|null} [chapterCount] LessonSummary chapterCount
         * @property {number|null} [videoExampleCount] LessonSummary videoExampleCount
         * @property {number|null} [totalDurationSeconds] LessonSummary totalDurationSeconds
         * @property {boolean|null} [published] LessonSummary published
         */

        /**
         * Constructs a new LessonSummary.
         * @memberof lessons
         * @classdesc Represents a LessonSummary.
         * @implements ILessonSummary
         * @constructor
         * @param {lessons.ILessonSummary=} [properties] Properties to set
         */
        function LessonSummary(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * LessonSummary id.
         * @member {string} id
         * @memberof lessons.LessonSummary
         * @instance
         */
        LessonSummary.prototype.id = "";

        /**
         * LessonSummary title.
         * @member {string} title
         * @memberof lessons.LessonSummary
         * @instance
         */
        LessonSummary.prototype.title = "";

        /**
         * LessonSummary description.
         * @member {string} description
         * @memberof lessons.LessonSummary
         * @instance
         */
        LessonSummary.prototype.description = "";

        /**
         * LessonSummary thumbnailUrl.
         * @member {string} thumbnailUrl
         * @memberof lessons.LessonSummary
         * @instance
         */
        LessonSummary.prototype.thumbnailUrl = "";

        /**
         * LessonSummary chapterCount.
         * @member {number} chapterCount
         * @memberof lessons.LessonSummary
         * @instance
         */
        LessonSummary.prototype.chapterCount = 0;

        /**
         * LessonSummary videoExampleCount.
         * @member {number} videoExampleCount
         * @memberof lessons.LessonSummary
         * @instance
         */
        LessonSummary.prototype.videoExampleCount = 0;

        /**
         * LessonSummary totalDurationSeconds.
         * @member {number} totalDurationSeconds
         * @memberof lessons.LessonSummary
         * @instance
         */
        LessonSummary.prototype.totalDurationSeconds = 0;

        /**
         * LessonSummary published.
         * @member {boolean} published
         * @memberof lessons.LessonSummary
         * @instance
         */
        LessonSummary.prototype.published = false;

        /**
         * Creates a new LessonSummary instance using the specified properties.
         * @function create
         * @memberof lessons.LessonSummary
         * @static
         * @param {lessons.ILessonSummary=} [properties] Properties to set
         * @returns {lessons.LessonSummary} LessonSummary instance
         */
        LessonSummary.create = function create(properties) {
            return new LessonSummary(properties);
        };

        /**
         * Encodes the specified LessonSummary message. Does not implicitly {@link lessons.LessonSummary.verify|verify} messages.
         * @function encode
         * @memberof lessons.LessonSummary
         * @static
         * @param {lessons.ILessonSummary} message LessonSummary message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        LessonSummary.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            if (message.title != null && Object.hasOwnProperty.call(message, "title"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.title);
            if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.description);
            if (message.thumbnailUrl != null && Object.hasOwnProperty.call(message, "thumbnailUrl"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.thumbnailUrl);
            if (message.chapterCount != null && Object.hasOwnProperty.call(message, "chapterCount"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.chapterCount);
            if (message.videoExampleCount != null && Object.hasOwnProperty.call(message, "videoExampleCount"))
                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.videoExampleCount);
            if (message.totalDurationSeconds != null && Object.hasOwnProperty.call(message, "totalDurationSeconds"))
                writer.uint32(/* id 7, wireType 0 =*/56).int32(message.totalDurationSeconds);
            if (message.published != null && Object.hasOwnProperty.call(message, "published"))
                writer.uint32(/* id 8, wireType 0 =*/64).bool(message.published);
            return writer;
        };

        /**
         * Encodes the specified LessonSummary message, length delimited. Does not implicitly {@link lessons.LessonSummary.verify|verify} messages.
         * @function encodeDelimited
         * @memberof lessons.LessonSummary
         * @static
         * @param {lessons.ILessonSummary} message LessonSummary message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        LessonSummary.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a LessonSummary message from the specified reader or buffer.
         * @function decode
         * @memberof lessons.LessonSummary
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {lessons.LessonSummary} LessonSummary
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        LessonSummary.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.lessons.LessonSummary();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.id = reader.string();
                        break;
                    }
                case 2: {
                        message.title = reader.string();
                        break;
                    }
                case 3: {
                        message.description = reader.string();
                        break;
                    }
                case 4: {
                        message.thumbnailUrl = reader.string();
                        break;
                    }
                case 5: {
                        message.chapterCount = reader.int32();
                        break;
                    }
                case 6: {
                        message.videoExampleCount = reader.int32();
                        break;
                    }
                case 7: {
                        message.totalDurationSeconds = reader.int32();
                        break;
                    }
                case 8: {
                        message.published = reader.bool();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a LessonSummary message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof lessons.LessonSummary
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {lessons.LessonSummary} LessonSummary
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        LessonSummary.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a LessonSummary message.
         * @function verify
         * @memberof lessons.LessonSummary
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        LessonSummary.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.title != null && message.hasOwnProperty("title"))
                if (!$util.isString(message.title))
                    return "title: string expected";
            if (message.description != null && message.hasOwnProperty("description"))
                if (!$util.isString(message.description))
                    return "description: string expected";
            if (message.thumbnailUrl != null && message.hasOwnProperty("thumbnailUrl"))
                if (!$util.isString(message.thumbnailUrl))
                    return "thumbnailUrl: string expected";
            if (message.chapterCount != null && message.hasOwnProperty("chapterCount"))
                if (!$util.isInteger(message.chapterCount))
                    return "chapterCount: integer expected";
            if (message.videoExampleCount != null && message.hasOwnProperty("videoExampleCount"))
                if (!$util.isInteger(message.videoExampleCount))
                    return "videoExampleCount: integer expected";
            if (message.totalDurationSeconds != null && message.hasOwnProperty("totalDurationSeconds"))
                if (!$util.isInteger(message.totalDurationSeconds))
                    return "totalDurationSeconds: integer expected";
            if (message.published != null && message.hasOwnProperty("published"))
                if (typeof message.published !== "boolean")
                    return "published: boolean expected";
            return null;
        };

        /**
         * Creates a LessonSummary message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof lessons.LessonSummary
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {lessons.LessonSummary} LessonSummary
         */
        LessonSummary.fromObject = function fromObject(object) {
            if (object instanceof $root.lessons.LessonSummary)
                return object;
            let message = new $root.lessons.LessonSummary();
            if (object.id != null)
                message.id = String(object.id);
            if (object.title != null)
                message.title = String(object.title);
            if (object.description != null)
                message.description = String(object.description);
            if (object.thumbnailUrl != null)
                message.thumbnailUrl = String(object.thumbnailUrl);
            if (object.chapterCount != null)
                message.chapterCount = object.chapterCount | 0;
            if (object.videoExampleCount != null)
                message.videoExampleCount = object.videoExampleCount | 0;
            if (object.totalDurationSeconds != null)
                message.totalDurationSeconds = object.totalDurationSeconds | 0;
            if (object.published != null)
                message.published = Boolean(object.published);
            return message;
        };

        /**
         * Creates a plain object from a LessonSummary message. Also converts values to other types if specified.
         * @function toObject
         * @memberof lessons.LessonSummary
         * @static
         * @param {lessons.LessonSummary} message LessonSummary
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        LessonSummary.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.id = "";
                object.title = "";
                object.description = "";
                object.thumbnailUrl = "";
                object.chapterCount = 0;
                object.videoExampleCount = 0;
                object.totalDurationSeconds = 0;
                object.published = false;
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.title != null && message.hasOwnProperty("title"))
                object.title = message.title;
            if (message.description != null && message.hasOwnProperty("description"))
                object.description = message.description;
            if (message.thumbnailUrl != null && message.hasOwnProperty("thumbnailUrl"))
                object.thumbnailUrl = message.thumbnailUrl;
            if (message.chapterCount != null && message.hasOwnProperty("chapterCount"))
                object.chapterCount = message.chapterCount;
            if (message.videoExampleCount != null && message.hasOwnProperty("videoExampleCount"))
                object.videoExampleCount = message.videoExampleCount;
            if (message.totalDurationSeconds != null && message.hasOwnProperty("totalDurationSeconds"))
                object.totalDurationSeconds = message.totalDurationSeconds;
            if (message.published != null && message.hasOwnProperty("published"))
                object.published = message.published;
            return object;
        };

        /**
         * Converts this LessonSummary to JSON.
         * @function toJSON
         * @memberof lessons.LessonSummary
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        LessonSummary.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for LessonSummary
         * @function getTypeUrl
         * @memberof lessons.LessonSummary
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        LessonSummary.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/lessons.LessonSummary";
        };

        return LessonSummary;
    })();

    lessons.Lesson = (function() {

        /**
         * Properties of a Lesson.
         * @memberof lessons
         * @interface ILesson
         * @property {string|null} [id] Lesson id
         * @property {string|null} [title] Lesson title
         * @property {string|null} [description] Lesson description
         * @property {string|null} [thumbnailUrl] Lesson thumbnailUrl
         */

        /**
         * Constructs a new Lesson.
         * @memberof lessons
         * @classdesc Represents a Lesson.
         * @implements ILesson
         * @constructor
         * @param {lessons.ILesson=} [properties] Properties to set
         */
        function Lesson(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Lesson id.
         * @member {string} id
         * @memberof lessons.Lesson
         * @instance
         */
        Lesson.prototype.id = "";

        /**
         * Lesson title.
         * @member {string} title
         * @memberof lessons.Lesson
         * @instance
         */
        Lesson.prototype.title = "";

        /**
         * Lesson description.
         * @member {string} description
         * @memberof lessons.Lesson
         * @instance
         */
        Lesson.prototype.description = "";

        /**
         * Lesson thumbnailUrl.
         * @member {string} thumbnailUrl
         * @memberof lessons.Lesson
         * @instance
         */
        Lesson.prototype.thumbnailUrl = "";

        /**
         * Creates a new Lesson instance using the specified properties.
         * @function create
         * @memberof lessons.Lesson
         * @static
         * @param {lessons.ILesson=} [properties] Properties to set
         * @returns {lessons.Lesson} Lesson instance
         */
        Lesson.create = function create(properties) {
            return new Lesson(properties);
        };

        /**
         * Encodes the specified Lesson message. Does not implicitly {@link lessons.Lesson.verify|verify} messages.
         * @function encode
         * @memberof lessons.Lesson
         * @static
         * @param {lessons.ILesson} message Lesson message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Lesson.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            if (message.title != null && Object.hasOwnProperty.call(message, "title"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.title);
            if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.description);
            if (message.thumbnailUrl != null && Object.hasOwnProperty.call(message, "thumbnailUrl"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.thumbnailUrl);
            return writer;
        };

        /**
         * Encodes the specified Lesson message, length delimited. Does not implicitly {@link lessons.Lesson.verify|verify} messages.
         * @function encodeDelimited
         * @memberof lessons.Lesson
         * @static
         * @param {lessons.ILesson} message Lesson message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Lesson.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Lesson message from the specified reader or buffer.
         * @function decode
         * @memberof lessons.Lesson
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {lessons.Lesson} Lesson
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Lesson.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.lessons.Lesson();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.id = reader.string();
                        break;
                    }
                case 2: {
                        message.title = reader.string();
                        break;
                    }
                case 3: {
                        message.description = reader.string();
                        break;
                    }
                case 4: {
                        message.thumbnailUrl = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Lesson message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof lessons.Lesson
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {lessons.Lesson} Lesson
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Lesson.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Lesson message.
         * @function verify
         * @memberof lessons.Lesson
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Lesson.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.title != null && message.hasOwnProperty("title"))
                if (!$util.isString(message.title))
                    return "title: string expected";
            if (message.description != null && message.hasOwnProperty("description"))
                if (!$util.isString(message.description))
                    return "description: string expected";
            if (message.thumbnailUrl != null && message.hasOwnProperty("thumbnailUrl"))
                if (!$util.isString(message.thumbnailUrl))
                    return "thumbnailUrl: string expected";
            return null;
        };

        /**
         * Creates a Lesson message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof lessons.Lesson
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {lessons.Lesson} Lesson
         */
        Lesson.fromObject = function fromObject(object) {
            if (object instanceof $root.lessons.Lesson)
                return object;
            let message = new $root.lessons.Lesson();
            if (object.id != null)
                message.id = String(object.id);
            if (object.title != null)
                message.title = String(object.title);
            if (object.description != null)
                message.description = String(object.description);
            if (object.thumbnailUrl != null)
                message.thumbnailUrl = String(object.thumbnailUrl);
            return message;
        };

        /**
         * Creates a plain object from a Lesson message. Also converts values to other types if specified.
         * @function toObject
         * @memberof lessons.Lesson
         * @static
         * @param {lessons.Lesson} message Lesson
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Lesson.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.id = "";
                object.title = "";
                object.description = "";
                object.thumbnailUrl = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.title != null && message.hasOwnProperty("title"))
                object.title = message.title;
            if (message.description != null && message.hasOwnProperty("description"))
                object.description = message.description;
            if (message.thumbnailUrl != null && message.hasOwnProperty("thumbnailUrl"))
                object.thumbnailUrl = message.thumbnailUrl;
            return object;
        };

        /**
         * Converts this Lesson to JSON.
         * @function toJSON
         * @memberof lessons.Lesson
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Lesson.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Lesson
         * @function getTypeUrl
         * @memberof lessons.Lesson
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Lesson.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/lessons.Lesson";
        };

        return Lesson;
    })();

    lessons.LessonDetail = (function() {

        /**
         * Properties of a LessonDetail.
         * @memberof lessons
         * @interface ILessonDetail
         * @property {string|null} [id] LessonDetail id
         * @property {string|null} [title] LessonDetail title
         * @property {string|null} [description] LessonDetail description
         * @property {string|null} [thumbnailUrl] LessonDetail thumbnailUrl
         * @property {number|null} [chapterCount] LessonDetail chapterCount
         * @property {number|null} [videoExampleCount] LessonDetail videoExampleCount
         * @property {number|null} [totalDurationSeconds] LessonDetail totalDurationSeconds
         * @property {Array.<lessons.ILessonChapter>|null} [chapters] LessonDetail chapters
         * @property {boolean|null} [published] LessonDetail published
         * @property {string|null} [thumbnailFileId] LessonDetail thumbnailFileId
         * @property {boolean|null} [locked] LessonDetail locked
         */

        /**
         * Constructs a new LessonDetail.
         * @memberof lessons
         * @classdesc Represents a LessonDetail.
         * @implements ILessonDetail
         * @constructor
         * @param {lessons.ILessonDetail=} [properties] Properties to set
         */
        function LessonDetail(properties) {
            this.chapters = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * LessonDetail id.
         * @member {string} id
         * @memberof lessons.LessonDetail
         * @instance
         */
        LessonDetail.prototype.id = "";

        /**
         * LessonDetail title.
         * @member {string} title
         * @memberof lessons.LessonDetail
         * @instance
         */
        LessonDetail.prototype.title = "";

        /**
         * LessonDetail description.
         * @member {string} description
         * @memberof lessons.LessonDetail
         * @instance
         */
        LessonDetail.prototype.description = "";

        /**
         * LessonDetail thumbnailUrl.
         * @member {string} thumbnailUrl
         * @memberof lessons.LessonDetail
         * @instance
         */
        LessonDetail.prototype.thumbnailUrl = "";

        /**
         * LessonDetail chapterCount.
         * @member {number} chapterCount
         * @memberof lessons.LessonDetail
         * @instance
         */
        LessonDetail.prototype.chapterCount = 0;

        /**
         * LessonDetail videoExampleCount.
         * @member {number} videoExampleCount
         * @memberof lessons.LessonDetail
         * @instance
         */
        LessonDetail.prototype.videoExampleCount = 0;

        /**
         * LessonDetail totalDurationSeconds.
         * @member {number} totalDurationSeconds
         * @memberof lessons.LessonDetail
         * @instance
         */
        LessonDetail.prototype.totalDurationSeconds = 0;

        /**
         * LessonDetail chapters.
         * @member {Array.<lessons.ILessonChapter>} chapters
         * @memberof lessons.LessonDetail
         * @instance
         */
        LessonDetail.prototype.chapters = $util.emptyArray;

        /**
         * LessonDetail published.
         * @member {boolean} published
         * @memberof lessons.LessonDetail
         * @instance
         */
        LessonDetail.prototype.published = false;

        /**
         * LessonDetail thumbnailFileId.
         * @member {string} thumbnailFileId
         * @memberof lessons.LessonDetail
         * @instance
         */
        LessonDetail.prototype.thumbnailFileId = "";

        /**
         * LessonDetail locked.
         * @member {boolean} locked
         * @memberof lessons.LessonDetail
         * @instance
         */
        LessonDetail.prototype.locked = false;

        /**
         * Creates a new LessonDetail instance using the specified properties.
         * @function create
         * @memberof lessons.LessonDetail
         * @static
         * @param {lessons.ILessonDetail=} [properties] Properties to set
         * @returns {lessons.LessonDetail} LessonDetail instance
         */
        LessonDetail.create = function create(properties) {
            return new LessonDetail(properties);
        };

        /**
         * Encodes the specified LessonDetail message. Does not implicitly {@link lessons.LessonDetail.verify|verify} messages.
         * @function encode
         * @memberof lessons.LessonDetail
         * @static
         * @param {lessons.ILessonDetail} message LessonDetail message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        LessonDetail.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            if (message.title != null && Object.hasOwnProperty.call(message, "title"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.title);
            if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.description);
            if (message.thumbnailUrl != null && Object.hasOwnProperty.call(message, "thumbnailUrl"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.thumbnailUrl);
            if (message.chapterCount != null && Object.hasOwnProperty.call(message, "chapterCount"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.chapterCount);
            if (message.videoExampleCount != null && Object.hasOwnProperty.call(message, "videoExampleCount"))
                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.videoExampleCount);
            if (message.totalDurationSeconds != null && Object.hasOwnProperty.call(message, "totalDurationSeconds"))
                writer.uint32(/* id 7, wireType 0 =*/56).int32(message.totalDurationSeconds);
            if (message.chapters != null && message.chapters.length)
                for (let i = 0; i < message.chapters.length; ++i)
                    $root.lessons.LessonChapter.encode(message.chapters[i], writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
            if (message.published != null && Object.hasOwnProperty.call(message, "published"))
                writer.uint32(/* id 9, wireType 0 =*/72).bool(message.published);
            if (message.thumbnailFileId != null && Object.hasOwnProperty.call(message, "thumbnailFileId"))
                writer.uint32(/* id 10, wireType 2 =*/82).string(message.thumbnailFileId);
            if (message.locked != null && Object.hasOwnProperty.call(message, "locked"))
                writer.uint32(/* id 11, wireType 0 =*/88).bool(message.locked);
            return writer;
        };

        /**
         * Encodes the specified LessonDetail message, length delimited. Does not implicitly {@link lessons.LessonDetail.verify|verify} messages.
         * @function encodeDelimited
         * @memberof lessons.LessonDetail
         * @static
         * @param {lessons.ILessonDetail} message LessonDetail message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        LessonDetail.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a LessonDetail message from the specified reader or buffer.
         * @function decode
         * @memberof lessons.LessonDetail
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {lessons.LessonDetail} LessonDetail
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        LessonDetail.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.lessons.LessonDetail();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.id = reader.string();
                        break;
                    }
                case 2: {
                        message.title = reader.string();
                        break;
                    }
                case 3: {
                        message.description = reader.string();
                        break;
                    }
                case 4: {
                        message.thumbnailUrl = reader.string();
                        break;
                    }
                case 5: {
                        message.chapterCount = reader.int32();
                        break;
                    }
                case 6: {
                        message.videoExampleCount = reader.int32();
                        break;
                    }
                case 7: {
                        message.totalDurationSeconds = reader.int32();
                        break;
                    }
                case 8: {
                        if (!(message.chapters && message.chapters.length))
                            message.chapters = [];
                        message.chapters.push($root.lessons.LessonChapter.decode(reader, reader.uint32()));
                        break;
                    }
                case 9: {
                        message.published = reader.bool();
                        break;
                    }
                case 10: {
                        message.thumbnailFileId = reader.string();
                        break;
                    }
                case 11: {
                        message.locked = reader.bool();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a LessonDetail message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof lessons.LessonDetail
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {lessons.LessonDetail} LessonDetail
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        LessonDetail.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a LessonDetail message.
         * @function verify
         * @memberof lessons.LessonDetail
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        LessonDetail.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.title != null && message.hasOwnProperty("title"))
                if (!$util.isString(message.title))
                    return "title: string expected";
            if (message.description != null && message.hasOwnProperty("description"))
                if (!$util.isString(message.description))
                    return "description: string expected";
            if (message.thumbnailUrl != null && message.hasOwnProperty("thumbnailUrl"))
                if (!$util.isString(message.thumbnailUrl))
                    return "thumbnailUrl: string expected";
            if (message.chapterCount != null && message.hasOwnProperty("chapterCount"))
                if (!$util.isInteger(message.chapterCount))
                    return "chapterCount: integer expected";
            if (message.videoExampleCount != null && message.hasOwnProperty("videoExampleCount"))
                if (!$util.isInteger(message.videoExampleCount))
                    return "videoExampleCount: integer expected";
            if (message.totalDurationSeconds != null && message.hasOwnProperty("totalDurationSeconds"))
                if (!$util.isInteger(message.totalDurationSeconds))
                    return "totalDurationSeconds: integer expected";
            if (message.chapters != null && message.hasOwnProperty("chapters")) {
                if (!Array.isArray(message.chapters))
                    return "chapters: array expected";
                for (let i = 0; i < message.chapters.length; ++i) {
                    let error = $root.lessons.LessonChapter.verify(message.chapters[i]);
                    if (error)
                        return "chapters." + error;
                }
            }
            if (message.published != null && message.hasOwnProperty("published"))
                if (typeof message.published !== "boolean")
                    return "published: boolean expected";
            if (message.thumbnailFileId != null && message.hasOwnProperty("thumbnailFileId"))
                if (!$util.isString(message.thumbnailFileId))
                    return "thumbnailFileId: string expected";
            if (message.locked != null && message.hasOwnProperty("locked"))
                if (typeof message.locked !== "boolean")
                    return "locked: boolean expected";
            return null;
        };

        /**
         * Creates a LessonDetail message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof lessons.LessonDetail
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {lessons.LessonDetail} LessonDetail
         */
        LessonDetail.fromObject = function fromObject(object) {
            if (object instanceof $root.lessons.LessonDetail)
                return object;
            let message = new $root.lessons.LessonDetail();
            if (object.id != null)
                message.id = String(object.id);
            if (object.title != null)
                message.title = String(object.title);
            if (object.description != null)
                message.description = String(object.description);
            if (object.thumbnailUrl != null)
                message.thumbnailUrl = String(object.thumbnailUrl);
            if (object.chapterCount != null)
                message.chapterCount = object.chapterCount | 0;
            if (object.videoExampleCount != null)
                message.videoExampleCount = object.videoExampleCount | 0;
            if (object.totalDurationSeconds != null)
                message.totalDurationSeconds = object.totalDurationSeconds | 0;
            if (object.chapters) {
                if (!Array.isArray(object.chapters))
                    throw TypeError(".lessons.LessonDetail.chapters: array expected");
                message.chapters = [];
                for (let i = 0; i < object.chapters.length; ++i) {
                    if (typeof object.chapters[i] !== "object")
                        throw TypeError(".lessons.LessonDetail.chapters: object expected");
                    message.chapters[i] = $root.lessons.LessonChapter.fromObject(object.chapters[i]);
                }
            }
            if (object.published != null)
                message.published = Boolean(object.published);
            if (object.thumbnailFileId != null)
                message.thumbnailFileId = String(object.thumbnailFileId);
            if (object.locked != null)
                message.locked = Boolean(object.locked);
            return message;
        };

        /**
         * Creates a plain object from a LessonDetail message. Also converts values to other types if specified.
         * @function toObject
         * @memberof lessons.LessonDetail
         * @static
         * @param {lessons.LessonDetail} message LessonDetail
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        LessonDetail.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.chapters = [];
            if (options.defaults) {
                object.id = "";
                object.title = "";
                object.description = "";
                object.thumbnailUrl = "";
                object.chapterCount = 0;
                object.videoExampleCount = 0;
                object.totalDurationSeconds = 0;
                object.published = false;
                object.thumbnailFileId = "";
                object.locked = false;
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.title != null && message.hasOwnProperty("title"))
                object.title = message.title;
            if (message.description != null && message.hasOwnProperty("description"))
                object.description = message.description;
            if (message.thumbnailUrl != null && message.hasOwnProperty("thumbnailUrl"))
                object.thumbnailUrl = message.thumbnailUrl;
            if (message.chapterCount != null && message.hasOwnProperty("chapterCount"))
                object.chapterCount = message.chapterCount;
            if (message.videoExampleCount != null && message.hasOwnProperty("videoExampleCount"))
                object.videoExampleCount = message.videoExampleCount;
            if (message.totalDurationSeconds != null && message.hasOwnProperty("totalDurationSeconds"))
                object.totalDurationSeconds = message.totalDurationSeconds;
            if (message.chapters && message.chapters.length) {
                object.chapters = [];
                for (let j = 0; j < message.chapters.length; ++j)
                    object.chapters[j] = $root.lessons.LessonChapter.toObject(message.chapters[j], options);
            }
            if (message.published != null && message.hasOwnProperty("published"))
                object.published = message.published;
            if (message.thumbnailFileId != null && message.hasOwnProperty("thumbnailFileId"))
                object.thumbnailFileId = message.thumbnailFileId;
            if (message.locked != null && message.hasOwnProperty("locked"))
                object.locked = message.locked;
            return object;
        };

        /**
         * Converts this LessonDetail to JSON.
         * @function toJSON
         * @memberof lessons.LessonDetail
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        LessonDetail.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for LessonDetail
         * @function getTypeUrl
         * @memberof lessons.LessonDetail
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        LessonDetail.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/lessons.LessonDetail";
        };

        return LessonDetail;
    })();

    lessons.LessonChapter = (function() {

        /**
         * Properties of a LessonChapter.
         * @memberof lessons
         * @interface ILessonChapter
         * @property {string|null} [id] LessonChapter id
         * @property {number|null} [order] LessonChapter order
         * @property {string|null} [title] LessonChapter title
         * @property {Array.<lessons.IContentBlock>|null} [contentBlocks] LessonChapter contentBlocks
         */

        /**
         * Constructs a new LessonChapter.
         * @memberof lessons
         * @classdesc Represents a LessonChapter.
         * @implements ILessonChapter
         * @constructor
         * @param {lessons.ILessonChapter=} [properties] Properties to set
         */
        function LessonChapter(properties) {
            this.contentBlocks = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * LessonChapter id.
         * @member {string} id
         * @memberof lessons.LessonChapter
         * @instance
         */
        LessonChapter.prototype.id = "";

        /**
         * LessonChapter order.
         * @member {number} order
         * @memberof lessons.LessonChapter
         * @instance
         */
        LessonChapter.prototype.order = 0;

        /**
         * LessonChapter title.
         * @member {string} title
         * @memberof lessons.LessonChapter
         * @instance
         */
        LessonChapter.prototype.title = "";

        /**
         * LessonChapter contentBlocks.
         * @member {Array.<lessons.IContentBlock>} contentBlocks
         * @memberof lessons.LessonChapter
         * @instance
         */
        LessonChapter.prototype.contentBlocks = $util.emptyArray;

        /**
         * Creates a new LessonChapter instance using the specified properties.
         * @function create
         * @memberof lessons.LessonChapter
         * @static
         * @param {lessons.ILessonChapter=} [properties] Properties to set
         * @returns {lessons.LessonChapter} LessonChapter instance
         */
        LessonChapter.create = function create(properties) {
            return new LessonChapter(properties);
        };

        /**
         * Encodes the specified LessonChapter message. Does not implicitly {@link lessons.LessonChapter.verify|verify} messages.
         * @function encode
         * @memberof lessons.LessonChapter
         * @static
         * @param {lessons.ILessonChapter} message LessonChapter message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        LessonChapter.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            if (message.order != null && Object.hasOwnProperty.call(message, "order"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.order);
            if (message.title != null && Object.hasOwnProperty.call(message, "title"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.title);
            if (message.contentBlocks != null && message.contentBlocks.length)
                for (let i = 0; i < message.contentBlocks.length; ++i)
                    $root.lessons.ContentBlock.encode(message.contentBlocks[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified LessonChapter message, length delimited. Does not implicitly {@link lessons.LessonChapter.verify|verify} messages.
         * @function encodeDelimited
         * @memberof lessons.LessonChapter
         * @static
         * @param {lessons.ILessonChapter} message LessonChapter message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        LessonChapter.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a LessonChapter message from the specified reader or buffer.
         * @function decode
         * @memberof lessons.LessonChapter
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {lessons.LessonChapter} LessonChapter
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        LessonChapter.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.lessons.LessonChapter();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.id = reader.string();
                        break;
                    }
                case 2: {
                        message.order = reader.int32();
                        break;
                    }
                case 3: {
                        message.title = reader.string();
                        break;
                    }
                case 4: {
                        if (!(message.contentBlocks && message.contentBlocks.length))
                            message.contentBlocks = [];
                        message.contentBlocks.push($root.lessons.ContentBlock.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a LessonChapter message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof lessons.LessonChapter
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {lessons.LessonChapter} LessonChapter
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        LessonChapter.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a LessonChapter message.
         * @function verify
         * @memberof lessons.LessonChapter
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        LessonChapter.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.order != null && message.hasOwnProperty("order"))
                if (!$util.isInteger(message.order))
                    return "order: integer expected";
            if (message.title != null && message.hasOwnProperty("title"))
                if (!$util.isString(message.title))
                    return "title: string expected";
            if (message.contentBlocks != null && message.hasOwnProperty("contentBlocks")) {
                if (!Array.isArray(message.contentBlocks))
                    return "contentBlocks: array expected";
                for (let i = 0; i < message.contentBlocks.length; ++i) {
                    let error = $root.lessons.ContentBlock.verify(message.contentBlocks[i]);
                    if (error)
                        return "contentBlocks." + error;
                }
            }
            return null;
        };

        /**
         * Creates a LessonChapter message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof lessons.LessonChapter
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {lessons.LessonChapter} LessonChapter
         */
        LessonChapter.fromObject = function fromObject(object) {
            if (object instanceof $root.lessons.LessonChapter)
                return object;
            let message = new $root.lessons.LessonChapter();
            if (object.id != null)
                message.id = String(object.id);
            if (object.order != null)
                message.order = object.order | 0;
            if (object.title != null)
                message.title = String(object.title);
            if (object.contentBlocks) {
                if (!Array.isArray(object.contentBlocks))
                    throw TypeError(".lessons.LessonChapter.contentBlocks: array expected");
                message.contentBlocks = [];
                for (let i = 0; i < object.contentBlocks.length; ++i) {
                    if (typeof object.contentBlocks[i] !== "object")
                        throw TypeError(".lessons.LessonChapter.contentBlocks: object expected");
                    message.contentBlocks[i] = $root.lessons.ContentBlock.fromObject(object.contentBlocks[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a LessonChapter message. Also converts values to other types if specified.
         * @function toObject
         * @memberof lessons.LessonChapter
         * @static
         * @param {lessons.LessonChapter} message LessonChapter
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        LessonChapter.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.contentBlocks = [];
            if (options.defaults) {
                object.id = "";
                object.order = 0;
                object.title = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.order != null && message.hasOwnProperty("order"))
                object.order = message.order;
            if (message.title != null && message.hasOwnProperty("title"))
                object.title = message.title;
            if (message.contentBlocks && message.contentBlocks.length) {
                object.contentBlocks = [];
                for (let j = 0; j < message.contentBlocks.length; ++j)
                    object.contentBlocks[j] = $root.lessons.ContentBlock.toObject(message.contentBlocks[j], options);
            }
            return object;
        };

        /**
         * Converts this LessonChapter to JSON.
         * @function toJSON
         * @memberof lessons.LessonChapter
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        LessonChapter.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for LessonChapter
         * @function getTypeUrl
         * @memberof lessons.LessonChapter
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        LessonChapter.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/lessons.LessonChapter";
        };

        return LessonChapter;
    })();

    lessons.ContentBlock = (function() {

        /**
         * Properties of a ContentBlock.
         * @memberof lessons
         * @interface IContentBlock
         * @property {string|null} [id] ContentBlock id
         * @property {number|null} [order] ContentBlock order
         * @property {lessons.ContentBlockType|null} [blockType] ContentBlock blockType
         * @property {string|null} [richText] ContentBlock richText
         * @property {lessons.TextBlockStyle|null} [textStyle] ContentBlock textStyle
         * @property {lessons.IVideoExample|null} [videoExample] ContentBlock videoExample
         */

        /**
         * Constructs a new ContentBlock.
         * @memberof lessons
         * @classdesc Represents a ContentBlock.
         * @implements IContentBlock
         * @constructor
         * @param {lessons.IContentBlock=} [properties] Properties to set
         */
        function ContentBlock(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ContentBlock id.
         * @member {string} id
         * @memberof lessons.ContentBlock
         * @instance
         */
        ContentBlock.prototype.id = "";

        /**
         * ContentBlock order.
         * @member {number} order
         * @memberof lessons.ContentBlock
         * @instance
         */
        ContentBlock.prototype.order = 0;

        /**
         * ContentBlock blockType.
         * @member {lessons.ContentBlockType} blockType
         * @memberof lessons.ContentBlock
         * @instance
         */
        ContentBlock.prototype.blockType = 0;

        /**
         * ContentBlock richText.
         * @member {string} richText
         * @memberof lessons.ContentBlock
         * @instance
         */
        ContentBlock.prototype.richText = "";

        /**
         * ContentBlock textStyle.
         * @member {lessons.TextBlockStyle} textStyle
         * @memberof lessons.ContentBlock
         * @instance
         */
        ContentBlock.prototype.textStyle = 0;

        /**
         * ContentBlock videoExample.
         * @member {lessons.IVideoExample|null|undefined} videoExample
         * @memberof lessons.ContentBlock
         * @instance
         */
        ContentBlock.prototype.videoExample = null;

        /**
         * Creates a new ContentBlock instance using the specified properties.
         * @function create
         * @memberof lessons.ContentBlock
         * @static
         * @param {lessons.IContentBlock=} [properties] Properties to set
         * @returns {lessons.ContentBlock} ContentBlock instance
         */
        ContentBlock.create = function create(properties) {
            return new ContentBlock(properties);
        };

        /**
         * Encodes the specified ContentBlock message. Does not implicitly {@link lessons.ContentBlock.verify|verify} messages.
         * @function encode
         * @memberof lessons.ContentBlock
         * @static
         * @param {lessons.IContentBlock} message ContentBlock message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContentBlock.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            if (message.order != null && Object.hasOwnProperty.call(message, "order"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.order);
            if (message.blockType != null && Object.hasOwnProperty.call(message, "blockType"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.blockType);
            if (message.richText != null && Object.hasOwnProperty.call(message, "richText"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.richText);
            if (message.textStyle != null && Object.hasOwnProperty.call(message, "textStyle"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.textStyle);
            if (message.videoExample != null && Object.hasOwnProperty.call(message, "videoExample"))
                $root.lessons.VideoExample.encode(message.videoExample, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified ContentBlock message, length delimited. Does not implicitly {@link lessons.ContentBlock.verify|verify} messages.
         * @function encodeDelimited
         * @memberof lessons.ContentBlock
         * @static
         * @param {lessons.IContentBlock} message ContentBlock message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ContentBlock.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ContentBlock message from the specified reader or buffer.
         * @function decode
         * @memberof lessons.ContentBlock
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {lessons.ContentBlock} ContentBlock
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContentBlock.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.lessons.ContentBlock();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.id = reader.string();
                        break;
                    }
                case 2: {
                        message.order = reader.int32();
                        break;
                    }
                case 3: {
                        message.blockType = reader.int32();
                        break;
                    }
                case 4: {
                        message.richText = reader.string();
                        break;
                    }
                case 5: {
                        message.textStyle = reader.int32();
                        break;
                    }
                case 6: {
                        message.videoExample = $root.lessons.VideoExample.decode(reader, reader.uint32());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ContentBlock message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof lessons.ContentBlock
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {lessons.ContentBlock} ContentBlock
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ContentBlock.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ContentBlock message.
         * @function verify
         * @memberof lessons.ContentBlock
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ContentBlock.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.order != null && message.hasOwnProperty("order"))
                if (!$util.isInteger(message.order))
                    return "order: integer expected";
            if (message.blockType != null && message.hasOwnProperty("blockType"))
                switch (message.blockType) {
                default:
                    return "blockType: enum value expected";
                case 0:
                case 1:
                    break;
                }
            if (message.richText != null && message.hasOwnProperty("richText"))
                if (!$util.isString(message.richText))
                    return "richText: string expected";
            if (message.textStyle != null && message.hasOwnProperty("textStyle"))
                switch (message.textStyle) {
                default:
                    return "textStyle: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                    break;
                }
            if (message.videoExample != null && message.hasOwnProperty("videoExample")) {
                let error = $root.lessons.VideoExample.verify(message.videoExample);
                if (error)
                    return "videoExample." + error;
            }
            return null;
        };

        /**
         * Creates a ContentBlock message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof lessons.ContentBlock
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {lessons.ContentBlock} ContentBlock
         */
        ContentBlock.fromObject = function fromObject(object) {
            if (object instanceof $root.lessons.ContentBlock)
                return object;
            let message = new $root.lessons.ContentBlock();
            if (object.id != null)
                message.id = String(object.id);
            if (object.order != null)
                message.order = object.order | 0;
            switch (object.blockType) {
            default:
                if (typeof object.blockType === "number") {
                    message.blockType = object.blockType;
                    break;
                }
                break;
            case "CONTENT_BLOCK_TEXT":
            case 0:
                message.blockType = 0;
                break;
            case "CONTENT_BLOCK_ANNOTATION":
            case 1:
                message.blockType = 1;
                break;
            }
            if (object.richText != null)
                message.richText = String(object.richText);
            switch (object.textStyle) {
            default:
                if (typeof object.textStyle === "number") {
                    message.textStyle = object.textStyle;
                    break;
                }
                break;
            case "TEXT_STYLE_NORMAL":
            case 0:
                message.textStyle = 0;
                break;
            case "TEXT_STYLE_GOOD_EMPHASIS":
            case 1:
                message.textStyle = 1;
                break;
            case "TEXT_STYLE_BAD_EMPHASIS":
            case 2:
                message.textStyle = 2;
                break;
            case "TEXT_STYLE_EMPHASIS":
            case 3:
                message.textStyle = 3;
                break;
            case "TEXT_STYLE_THEORY":
            case 4:
                message.textStyle = 4;
                break;
            }
            if (object.videoExample != null) {
                if (typeof object.videoExample !== "object")
                    throw TypeError(".lessons.ContentBlock.videoExample: object expected");
                message.videoExample = $root.lessons.VideoExample.fromObject(object.videoExample);
            }
            return message;
        };

        /**
         * Creates a plain object from a ContentBlock message. Also converts values to other types if specified.
         * @function toObject
         * @memberof lessons.ContentBlock
         * @static
         * @param {lessons.ContentBlock} message ContentBlock
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ContentBlock.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.id = "";
                object.order = 0;
                object.blockType = options.enums === String ? "CONTENT_BLOCK_TEXT" : 0;
                object.richText = "";
                object.textStyle = options.enums === String ? "TEXT_STYLE_NORMAL" : 0;
                object.videoExample = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.order != null && message.hasOwnProperty("order"))
                object.order = message.order;
            if (message.blockType != null && message.hasOwnProperty("blockType"))
                object.blockType = options.enums === String ? $root.lessons.ContentBlockType[message.blockType] === undefined ? message.blockType : $root.lessons.ContentBlockType[message.blockType] : message.blockType;
            if (message.richText != null && message.hasOwnProperty("richText"))
                object.richText = message.richText;
            if (message.textStyle != null && message.hasOwnProperty("textStyle"))
                object.textStyle = options.enums === String ? $root.lessons.TextBlockStyle[message.textStyle] === undefined ? message.textStyle : $root.lessons.TextBlockStyle[message.textStyle] : message.textStyle;
            if (message.videoExample != null && message.hasOwnProperty("videoExample"))
                object.videoExample = $root.lessons.VideoExample.toObject(message.videoExample, options);
            return object;
        };

        /**
         * Converts this ContentBlock to JSON.
         * @function toJSON
         * @memberof lessons.ContentBlock
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ContentBlock.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ContentBlock
         * @function getTypeUrl
         * @memberof lessons.ContentBlock
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ContentBlock.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/lessons.ContentBlock";
        };

        return ContentBlock;
    })();

    lessons.LessonChapterSection = (function() {

        /**
         * Properties of a LessonChapterSection.
         * @memberof lessons
         * @interface ILessonChapterSection
         * @property {string|null} [id] LessonChapterSection id
         * @property {number|null} [order] LessonChapterSection order
         * @property {string|null} [richText] LessonChapterSection richText
         * @property {lessons.IVideoExample|null} [videoExample] LessonChapterSection videoExample
         */

        /**
         * Constructs a new LessonChapterSection.
         * @memberof lessons
         * @classdesc Represents a LessonChapterSection.
         * @implements ILessonChapterSection
         * @constructor
         * @param {lessons.ILessonChapterSection=} [properties] Properties to set
         */
        function LessonChapterSection(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * LessonChapterSection id.
         * @member {string} id
         * @memberof lessons.LessonChapterSection
         * @instance
         */
        LessonChapterSection.prototype.id = "";

        /**
         * LessonChapterSection order.
         * @member {number} order
         * @memberof lessons.LessonChapterSection
         * @instance
         */
        LessonChapterSection.prototype.order = 0;

        /**
         * LessonChapterSection richText.
         * @member {string} richText
         * @memberof lessons.LessonChapterSection
         * @instance
         */
        LessonChapterSection.prototype.richText = "";

        /**
         * LessonChapterSection videoExample.
         * @member {lessons.IVideoExample|null|undefined} videoExample
         * @memberof lessons.LessonChapterSection
         * @instance
         */
        LessonChapterSection.prototype.videoExample = null;

        /**
         * Creates a new LessonChapterSection instance using the specified properties.
         * @function create
         * @memberof lessons.LessonChapterSection
         * @static
         * @param {lessons.ILessonChapterSection=} [properties] Properties to set
         * @returns {lessons.LessonChapterSection} LessonChapterSection instance
         */
        LessonChapterSection.create = function create(properties) {
            return new LessonChapterSection(properties);
        };

        /**
         * Encodes the specified LessonChapterSection message. Does not implicitly {@link lessons.LessonChapterSection.verify|verify} messages.
         * @function encode
         * @memberof lessons.LessonChapterSection
         * @static
         * @param {lessons.ILessonChapterSection} message LessonChapterSection message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        LessonChapterSection.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            if (message.order != null && Object.hasOwnProperty.call(message, "order"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.order);
            if (message.richText != null && Object.hasOwnProperty.call(message, "richText"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.richText);
            if (message.videoExample != null && Object.hasOwnProperty.call(message, "videoExample"))
                $root.lessons.VideoExample.encode(message.videoExample, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified LessonChapterSection message, length delimited. Does not implicitly {@link lessons.LessonChapterSection.verify|verify} messages.
         * @function encodeDelimited
         * @memberof lessons.LessonChapterSection
         * @static
         * @param {lessons.ILessonChapterSection} message LessonChapterSection message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        LessonChapterSection.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a LessonChapterSection message from the specified reader or buffer.
         * @function decode
         * @memberof lessons.LessonChapterSection
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {lessons.LessonChapterSection} LessonChapterSection
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        LessonChapterSection.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.lessons.LessonChapterSection();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.id = reader.string();
                        break;
                    }
                case 2: {
                        message.order = reader.int32();
                        break;
                    }
                case 3: {
                        message.richText = reader.string();
                        break;
                    }
                case 4: {
                        message.videoExample = $root.lessons.VideoExample.decode(reader, reader.uint32());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a LessonChapterSection message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof lessons.LessonChapterSection
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {lessons.LessonChapterSection} LessonChapterSection
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        LessonChapterSection.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a LessonChapterSection message.
         * @function verify
         * @memberof lessons.LessonChapterSection
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        LessonChapterSection.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.order != null && message.hasOwnProperty("order"))
                if (!$util.isInteger(message.order))
                    return "order: integer expected";
            if (message.richText != null && message.hasOwnProperty("richText"))
                if (!$util.isString(message.richText))
                    return "richText: string expected";
            if (message.videoExample != null && message.hasOwnProperty("videoExample")) {
                let error = $root.lessons.VideoExample.verify(message.videoExample);
                if (error)
                    return "videoExample." + error;
            }
            return null;
        };

        /**
         * Creates a LessonChapterSection message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof lessons.LessonChapterSection
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {lessons.LessonChapterSection} LessonChapterSection
         */
        LessonChapterSection.fromObject = function fromObject(object) {
            if (object instanceof $root.lessons.LessonChapterSection)
                return object;
            let message = new $root.lessons.LessonChapterSection();
            if (object.id != null)
                message.id = String(object.id);
            if (object.order != null)
                message.order = object.order | 0;
            if (object.richText != null)
                message.richText = String(object.richText);
            if (object.videoExample != null) {
                if (typeof object.videoExample !== "object")
                    throw TypeError(".lessons.LessonChapterSection.videoExample: object expected");
                message.videoExample = $root.lessons.VideoExample.fromObject(object.videoExample);
            }
            return message;
        };

        /**
         * Creates a plain object from a LessonChapterSection message. Also converts values to other types if specified.
         * @function toObject
         * @memberof lessons.LessonChapterSection
         * @static
         * @param {lessons.LessonChapterSection} message LessonChapterSection
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        LessonChapterSection.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.id = "";
                object.order = 0;
                object.richText = "";
                object.videoExample = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.order != null && message.hasOwnProperty("order"))
                object.order = message.order;
            if (message.richText != null && message.hasOwnProperty("richText"))
                object.richText = message.richText;
            if (message.videoExample != null && message.hasOwnProperty("videoExample"))
                object.videoExample = $root.lessons.VideoExample.toObject(message.videoExample, options);
            return object;
        };

        /**
         * Converts this LessonChapterSection to JSON.
         * @function toJSON
         * @memberof lessons.LessonChapterSection
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        LessonChapterSection.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for LessonChapterSection
         * @function getTypeUrl
         * @memberof lessons.LessonChapterSection
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        LessonChapterSection.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/lessons.LessonChapterSection";
        };

        return LessonChapterSection;
    })();

    lessons.VideoExample = (function() {

        /**
         * Properties of a VideoExample.
         * @memberof lessons
         * @interface IVideoExample
         * @property {recording.IRecordingAnnotation|null} [annotation] VideoExample annotation
         * @property {string|null} [recordingId] VideoExample recordingId
         * @property {string|null} [recordingName] VideoExample recordingName
         * @property {string|null} [videoUrl] VideoExample videoUrl
         * @property {Array.<recordings.IRecordingParticipant>|null} [participants] VideoExample participants
         * @property {number|null} [recordingDurationMs] VideoExample recordingDurationMs
         */

        /**
         * Constructs a new VideoExample.
         * @memberof lessons
         * @classdesc Represents a VideoExample.
         * @implements IVideoExample
         * @constructor
         * @param {lessons.IVideoExample=} [properties] Properties to set
         */
        function VideoExample(properties) {
            this.participants = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * VideoExample annotation.
         * @member {recording.IRecordingAnnotation|null|undefined} annotation
         * @memberof lessons.VideoExample
         * @instance
         */
        VideoExample.prototype.annotation = null;

        /**
         * VideoExample recordingId.
         * @member {string} recordingId
         * @memberof lessons.VideoExample
         * @instance
         */
        VideoExample.prototype.recordingId = "";

        /**
         * VideoExample recordingName.
         * @member {string} recordingName
         * @memberof lessons.VideoExample
         * @instance
         */
        VideoExample.prototype.recordingName = "";

        /**
         * VideoExample videoUrl.
         * @member {string} videoUrl
         * @memberof lessons.VideoExample
         * @instance
         */
        VideoExample.prototype.videoUrl = "";

        /**
         * VideoExample participants.
         * @member {Array.<recordings.IRecordingParticipant>} participants
         * @memberof lessons.VideoExample
         * @instance
         */
        VideoExample.prototype.participants = $util.emptyArray;

        /**
         * VideoExample recordingDurationMs.
         * @member {number} recordingDurationMs
         * @memberof lessons.VideoExample
         * @instance
         */
        VideoExample.prototype.recordingDurationMs = 0;

        /**
         * Creates a new VideoExample instance using the specified properties.
         * @function create
         * @memberof lessons.VideoExample
         * @static
         * @param {lessons.IVideoExample=} [properties] Properties to set
         * @returns {lessons.VideoExample} VideoExample instance
         */
        VideoExample.create = function create(properties) {
            return new VideoExample(properties);
        };

        /**
         * Encodes the specified VideoExample message. Does not implicitly {@link lessons.VideoExample.verify|verify} messages.
         * @function encode
         * @memberof lessons.VideoExample
         * @static
         * @param {lessons.IVideoExample} message VideoExample message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        VideoExample.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.annotation != null && Object.hasOwnProperty.call(message, "annotation"))
                $root.recording.RecordingAnnotation.encode(message.annotation, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.recordingId != null && Object.hasOwnProperty.call(message, "recordingId"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.recordingId);
            if (message.recordingName != null && Object.hasOwnProperty.call(message, "recordingName"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.recordingName);
            if (message.videoUrl != null && Object.hasOwnProperty.call(message, "videoUrl"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.videoUrl);
            if (message.participants != null && message.participants.length)
                for (let i = 0; i < message.participants.length; ++i)
                    $root.recordings.RecordingParticipant.encode(message.participants[i], writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
            if (message.recordingDurationMs != null && Object.hasOwnProperty.call(message, "recordingDurationMs"))
                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.recordingDurationMs);
            return writer;
        };

        /**
         * Encodes the specified VideoExample message, length delimited. Does not implicitly {@link lessons.VideoExample.verify|verify} messages.
         * @function encodeDelimited
         * @memberof lessons.VideoExample
         * @static
         * @param {lessons.IVideoExample} message VideoExample message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        VideoExample.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a VideoExample message from the specified reader or buffer.
         * @function decode
         * @memberof lessons.VideoExample
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {lessons.VideoExample} VideoExample
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        VideoExample.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.lessons.VideoExample();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.annotation = $root.recording.RecordingAnnotation.decode(reader, reader.uint32());
                        break;
                    }
                case 2: {
                        message.recordingId = reader.string();
                        break;
                    }
                case 3: {
                        message.recordingName = reader.string();
                        break;
                    }
                case 4: {
                        message.videoUrl = reader.string();
                        break;
                    }
                case 5: {
                        if (!(message.participants && message.participants.length))
                            message.participants = [];
                        message.participants.push($root.recordings.RecordingParticipant.decode(reader, reader.uint32()));
                        break;
                    }
                case 6: {
                        message.recordingDurationMs = reader.int32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a VideoExample message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof lessons.VideoExample
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {lessons.VideoExample} VideoExample
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        VideoExample.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a VideoExample message.
         * @function verify
         * @memberof lessons.VideoExample
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        VideoExample.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.annotation != null && message.hasOwnProperty("annotation")) {
                let error = $root.recording.RecordingAnnotation.verify(message.annotation);
                if (error)
                    return "annotation." + error;
            }
            if (message.recordingId != null && message.hasOwnProperty("recordingId"))
                if (!$util.isString(message.recordingId))
                    return "recordingId: string expected";
            if (message.recordingName != null && message.hasOwnProperty("recordingName"))
                if (!$util.isString(message.recordingName))
                    return "recordingName: string expected";
            if (message.videoUrl != null && message.hasOwnProperty("videoUrl"))
                if (!$util.isString(message.videoUrl))
                    return "videoUrl: string expected";
            if (message.participants != null && message.hasOwnProperty("participants")) {
                if (!Array.isArray(message.participants))
                    return "participants: array expected";
                for (let i = 0; i < message.participants.length; ++i) {
                    let error = $root.recordings.RecordingParticipant.verify(message.participants[i]);
                    if (error)
                        return "participants." + error;
                }
            }
            if (message.recordingDurationMs != null && message.hasOwnProperty("recordingDurationMs"))
                if (!$util.isInteger(message.recordingDurationMs))
                    return "recordingDurationMs: integer expected";
            return null;
        };

        /**
         * Creates a VideoExample message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof lessons.VideoExample
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {lessons.VideoExample} VideoExample
         */
        VideoExample.fromObject = function fromObject(object) {
            if (object instanceof $root.lessons.VideoExample)
                return object;
            let message = new $root.lessons.VideoExample();
            if (object.annotation != null) {
                if (typeof object.annotation !== "object")
                    throw TypeError(".lessons.VideoExample.annotation: object expected");
                message.annotation = $root.recording.RecordingAnnotation.fromObject(object.annotation);
            }
            if (object.recordingId != null)
                message.recordingId = String(object.recordingId);
            if (object.recordingName != null)
                message.recordingName = String(object.recordingName);
            if (object.videoUrl != null)
                message.videoUrl = String(object.videoUrl);
            if (object.participants) {
                if (!Array.isArray(object.participants))
                    throw TypeError(".lessons.VideoExample.participants: array expected");
                message.participants = [];
                for (let i = 0; i < object.participants.length; ++i) {
                    if (typeof object.participants[i] !== "object")
                        throw TypeError(".lessons.VideoExample.participants: object expected");
                    message.participants[i] = $root.recordings.RecordingParticipant.fromObject(object.participants[i]);
                }
            }
            if (object.recordingDurationMs != null)
                message.recordingDurationMs = object.recordingDurationMs | 0;
            return message;
        };

        /**
         * Creates a plain object from a VideoExample message. Also converts values to other types if specified.
         * @function toObject
         * @memberof lessons.VideoExample
         * @static
         * @param {lessons.VideoExample} message VideoExample
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        VideoExample.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.participants = [];
            if (options.defaults) {
                object.annotation = null;
                object.recordingId = "";
                object.recordingName = "";
                object.videoUrl = "";
                object.recordingDurationMs = 0;
            }
            if (message.annotation != null && message.hasOwnProperty("annotation"))
                object.annotation = $root.recording.RecordingAnnotation.toObject(message.annotation, options);
            if (message.recordingId != null && message.hasOwnProperty("recordingId"))
                object.recordingId = message.recordingId;
            if (message.recordingName != null && message.hasOwnProperty("recordingName"))
                object.recordingName = message.recordingName;
            if (message.videoUrl != null && message.hasOwnProperty("videoUrl"))
                object.videoUrl = message.videoUrl;
            if (message.participants && message.participants.length) {
                object.participants = [];
                for (let j = 0; j < message.participants.length; ++j)
                    object.participants[j] = $root.recordings.RecordingParticipant.toObject(message.participants[j], options);
            }
            if (message.recordingDurationMs != null && message.hasOwnProperty("recordingDurationMs"))
                object.recordingDurationMs = message.recordingDurationMs;
            return object;
        };

        /**
         * Converts this VideoExample to JSON.
         * @function toJSON
         * @memberof lessons.VideoExample
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        VideoExample.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for VideoExample
         * @function getTypeUrl
         * @memberof lessons.VideoExample
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        VideoExample.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/lessons.VideoExample";
        };

        return VideoExample;
    })();

    return lessons;
})();

export const recording = $root.recording = (() => {

    /**
     * Namespace recording.
     * @exports recording
     * @namespace
     */
    const recording = {};

    /**
     * AnnotationType enum.
     * @name recording.AnnotationType
     * @enum {number}
     * @property {number} AT_NONE=0 AT_NONE value
     * @property {number} AT_GOOD_PRACTICE=1 AT_GOOD_PRACTICE value
     * @property {number} AT_COMMON_MISTAKE=2 AT_COMMON_MISTAKE value
     */
    recording.AnnotationType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "AT_NONE"] = 0;
        values[valuesById[1] = "AT_GOOD_PRACTICE"] = 1;
        values[valuesById[2] = "AT_COMMON_MISTAKE"] = 2;
        return values;
    })();

    recording.GetRecording = (function() {

        /**
         * Properties of a GetRecording.
         * @memberof recording
         * @interface IGetRecording
         * @property {string|null} [id] GetRecording id
         */

        /**
         * Constructs a new GetRecording.
         * @memberof recording
         * @classdesc Represents a GetRecording.
         * @implements IGetRecording
         * @constructor
         * @param {recording.IGetRecording=} [properties] Properties to set
         */
        function GetRecording(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetRecording id.
         * @member {string} id
         * @memberof recording.GetRecording
         * @instance
         */
        GetRecording.prototype.id = "";

        /**
         * Creates a new GetRecording instance using the specified properties.
         * @function create
         * @memberof recording.GetRecording
         * @static
         * @param {recording.IGetRecording=} [properties] Properties to set
         * @returns {recording.GetRecording} GetRecording instance
         */
        GetRecording.create = function create(properties) {
            return new GetRecording(properties);
        };

        /**
         * Encodes the specified GetRecording message. Does not implicitly {@link recording.GetRecording.verify|verify} messages.
         * @function encode
         * @memberof recording.GetRecording
         * @static
         * @param {recording.IGetRecording} message GetRecording message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetRecording.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            return writer;
        };

        /**
         * Encodes the specified GetRecording message, length delimited. Does not implicitly {@link recording.GetRecording.verify|verify} messages.
         * @function encodeDelimited
         * @memberof recording.GetRecording
         * @static
         * @param {recording.IGetRecording} message GetRecording message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetRecording.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetRecording message from the specified reader or buffer.
         * @function decode
         * @memberof recording.GetRecording
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {recording.GetRecording} GetRecording
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetRecording.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.recording.GetRecording();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.id = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetRecording message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof recording.GetRecording
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {recording.GetRecording} GetRecording
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetRecording.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetRecording message.
         * @function verify
         * @memberof recording.GetRecording
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetRecording.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            return null;
        };

        /**
         * Creates a GetRecording message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof recording.GetRecording
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {recording.GetRecording} GetRecording
         */
        GetRecording.fromObject = function fromObject(object) {
            if (object instanceof $root.recording.GetRecording)
                return object;
            let message = new $root.recording.GetRecording();
            if (object.id != null)
                message.id = String(object.id);
            return message;
        };

        /**
         * Creates a plain object from a GetRecording message. Also converts values to other types if specified.
         * @function toObject
         * @memberof recording.GetRecording
         * @static
         * @param {recording.GetRecording} message GetRecording
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetRecording.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.id = "";
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            return object;
        };

        /**
         * Converts this GetRecording to JSON.
         * @function toJSON
         * @memberof recording.GetRecording
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetRecording.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GetRecording
         * @function getTypeUrl
         * @memberof recording.GetRecording
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GetRecording.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/recording.GetRecording";
        };

        return GetRecording;
    })();

    recording.GetRecordingResponse = (function() {

        /**
         * Properties of a GetRecordingResponse.
         * @memberof recording
         * @interface IGetRecordingResponse
         * @property {recordings.IRecording|null} [recording] GetRecordingResponse recording
         * @property {string|null} [videoUrl] GetRecordingResponse videoUrl
         * @property {Array.<recording.IRecordingAnnotation>|null} [annotations] GetRecordingResponse annotations
         */

        /**
         * Constructs a new GetRecordingResponse.
         * @memberof recording
         * @classdesc Represents a GetRecordingResponse.
         * @implements IGetRecordingResponse
         * @constructor
         * @param {recording.IGetRecordingResponse=} [properties] Properties to set
         */
        function GetRecordingResponse(properties) {
            this.annotations = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetRecordingResponse recording.
         * @member {recordings.IRecording|null|undefined} recording
         * @memberof recording.GetRecordingResponse
         * @instance
         */
        GetRecordingResponse.prototype.recording = null;

        /**
         * GetRecordingResponse videoUrl.
         * @member {string} videoUrl
         * @memberof recording.GetRecordingResponse
         * @instance
         */
        GetRecordingResponse.prototype.videoUrl = "";

        /**
         * GetRecordingResponse annotations.
         * @member {Array.<recording.IRecordingAnnotation>} annotations
         * @memberof recording.GetRecordingResponse
         * @instance
         */
        GetRecordingResponse.prototype.annotations = $util.emptyArray;

        /**
         * Creates a new GetRecordingResponse instance using the specified properties.
         * @function create
         * @memberof recording.GetRecordingResponse
         * @static
         * @param {recording.IGetRecordingResponse=} [properties] Properties to set
         * @returns {recording.GetRecordingResponse} GetRecordingResponse instance
         */
        GetRecordingResponse.create = function create(properties) {
            return new GetRecordingResponse(properties);
        };

        /**
         * Encodes the specified GetRecordingResponse message. Does not implicitly {@link recording.GetRecordingResponse.verify|verify} messages.
         * @function encode
         * @memberof recording.GetRecordingResponse
         * @static
         * @param {recording.IGetRecordingResponse} message GetRecordingResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetRecordingResponse.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.recording != null && Object.hasOwnProperty.call(message, "recording"))
                $root.recordings.Recording.encode(message.recording, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.videoUrl != null && Object.hasOwnProperty.call(message, "videoUrl"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.videoUrl);
            if (message.annotations != null && message.annotations.length)
                for (let i = 0; i < message.annotations.length; ++i)
                    $root.recording.RecordingAnnotation.encode(message.annotations[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified GetRecordingResponse message, length delimited. Does not implicitly {@link recording.GetRecordingResponse.verify|verify} messages.
         * @function encodeDelimited
         * @memberof recording.GetRecordingResponse
         * @static
         * @param {recording.IGetRecordingResponse} message GetRecordingResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetRecordingResponse.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetRecordingResponse message from the specified reader or buffer.
         * @function decode
         * @memberof recording.GetRecordingResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {recording.GetRecordingResponse} GetRecordingResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetRecordingResponse.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.recording.GetRecordingResponse();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.recording = $root.recordings.Recording.decode(reader, reader.uint32());
                        break;
                    }
                case 2: {
                        message.videoUrl = reader.string();
                        break;
                    }
                case 3: {
                        if (!(message.annotations && message.annotations.length))
                            message.annotations = [];
                        message.annotations.push($root.recording.RecordingAnnotation.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetRecordingResponse message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof recording.GetRecordingResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {recording.GetRecordingResponse} GetRecordingResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetRecordingResponse.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetRecordingResponse message.
         * @function verify
         * @memberof recording.GetRecordingResponse
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetRecordingResponse.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.recording != null && message.hasOwnProperty("recording")) {
                let error = $root.recordings.Recording.verify(message.recording);
                if (error)
                    return "recording." + error;
            }
            if (message.videoUrl != null && message.hasOwnProperty("videoUrl"))
                if (!$util.isString(message.videoUrl))
                    return "videoUrl: string expected";
            if (message.annotations != null && message.hasOwnProperty("annotations")) {
                if (!Array.isArray(message.annotations))
                    return "annotations: array expected";
                for (let i = 0; i < message.annotations.length; ++i) {
                    let error = $root.recording.RecordingAnnotation.verify(message.annotations[i]);
                    if (error)
                        return "annotations." + error;
                }
            }
            return null;
        };

        /**
         * Creates a GetRecordingResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof recording.GetRecordingResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {recording.GetRecordingResponse} GetRecordingResponse
         */
        GetRecordingResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.recording.GetRecordingResponse)
                return object;
            let message = new $root.recording.GetRecordingResponse();
            if (object.recording != null) {
                if (typeof object.recording !== "object")
                    throw TypeError(".recording.GetRecordingResponse.recording: object expected");
                message.recording = $root.recordings.Recording.fromObject(object.recording);
            }
            if (object.videoUrl != null)
                message.videoUrl = String(object.videoUrl);
            if (object.annotations) {
                if (!Array.isArray(object.annotations))
                    throw TypeError(".recording.GetRecordingResponse.annotations: array expected");
                message.annotations = [];
                for (let i = 0; i < object.annotations.length; ++i) {
                    if (typeof object.annotations[i] !== "object")
                        throw TypeError(".recording.GetRecordingResponse.annotations: object expected");
                    message.annotations[i] = $root.recording.RecordingAnnotation.fromObject(object.annotations[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a GetRecordingResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof recording.GetRecordingResponse
         * @static
         * @param {recording.GetRecordingResponse} message GetRecordingResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetRecordingResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.annotations = [];
            if (options.defaults) {
                object.recording = null;
                object.videoUrl = "";
            }
            if (message.recording != null && message.hasOwnProperty("recording"))
                object.recording = $root.recordings.Recording.toObject(message.recording, options);
            if (message.videoUrl != null && message.hasOwnProperty("videoUrl"))
                object.videoUrl = message.videoUrl;
            if (message.annotations && message.annotations.length) {
                object.annotations = [];
                for (let j = 0; j < message.annotations.length; ++j)
                    object.annotations[j] = $root.recording.RecordingAnnotation.toObject(message.annotations[j], options);
            }
            return object;
        };

        /**
         * Converts this GetRecordingResponse to JSON.
         * @function toJSON
         * @memberof recording.GetRecordingResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetRecordingResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GetRecordingResponse
         * @function getTypeUrl
         * @memberof recording.GetRecordingResponse
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GetRecordingResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/recording.GetRecordingResponse";
        };

        return GetRecordingResponse;
    })();

    recording.RecordingAnnotation = (function() {

        /**
         * Properties of a RecordingAnnotation.
         * @memberof recording
         * @interface IRecordingAnnotation
         * @property {number|null} [startMs] RecordingAnnotation startMs
         * @property {number|null} [endMs] RecordingAnnotation endMs
         * @property {string|null} [label] RecordingAnnotation label
         * @property {string|null} [description] RecordingAnnotation description
         * @property {boolean|null} [published] RecordingAnnotation published
         * @property {string|null} [id] RecordingAnnotation id
         * @property {recording.AnnotationType|null} [annotationType] RecordingAnnotation annotationType
         */

        /**
         * Constructs a new RecordingAnnotation.
         * @memberof recording
         * @classdesc Represents a RecordingAnnotation.
         * @implements IRecordingAnnotation
         * @constructor
         * @param {recording.IRecordingAnnotation=} [properties] Properties to set
         */
        function RecordingAnnotation(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RecordingAnnotation startMs.
         * @member {number} startMs
         * @memberof recording.RecordingAnnotation
         * @instance
         */
        RecordingAnnotation.prototype.startMs = 0;

        /**
         * RecordingAnnotation endMs.
         * @member {number} endMs
         * @memberof recording.RecordingAnnotation
         * @instance
         */
        RecordingAnnotation.prototype.endMs = 0;

        /**
         * RecordingAnnotation label.
         * @member {string} label
         * @memberof recording.RecordingAnnotation
         * @instance
         */
        RecordingAnnotation.prototype.label = "";

        /**
         * RecordingAnnotation description.
         * @member {string} description
         * @memberof recording.RecordingAnnotation
         * @instance
         */
        RecordingAnnotation.prototype.description = "";

        /**
         * RecordingAnnotation published.
         * @member {boolean} published
         * @memberof recording.RecordingAnnotation
         * @instance
         */
        RecordingAnnotation.prototype.published = false;

        /**
         * RecordingAnnotation id.
         * @member {string} id
         * @memberof recording.RecordingAnnotation
         * @instance
         */
        RecordingAnnotation.prototype.id = "";

        /**
         * RecordingAnnotation annotationType.
         * @member {recording.AnnotationType} annotationType
         * @memberof recording.RecordingAnnotation
         * @instance
         */
        RecordingAnnotation.prototype.annotationType = 0;

        /**
         * Creates a new RecordingAnnotation instance using the specified properties.
         * @function create
         * @memberof recording.RecordingAnnotation
         * @static
         * @param {recording.IRecordingAnnotation=} [properties] Properties to set
         * @returns {recording.RecordingAnnotation} RecordingAnnotation instance
         */
        RecordingAnnotation.create = function create(properties) {
            return new RecordingAnnotation(properties);
        };

        /**
         * Encodes the specified RecordingAnnotation message. Does not implicitly {@link recording.RecordingAnnotation.verify|verify} messages.
         * @function encode
         * @memberof recording.RecordingAnnotation
         * @static
         * @param {recording.IRecordingAnnotation} message RecordingAnnotation message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RecordingAnnotation.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.startMs != null && Object.hasOwnProperty.call(message, "startMs"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.startMs);
            if (message.endMs != null && Object.hasOwnProperty.call(message, "endMs"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.endMs);
            if (message.label != null && Object.hasOwnProperty.call(message, "label"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.label);
            if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.description);
            if (message.published != null && Object.hasOwnProperty.call(message, "published"))
                writer.uint32(/* id 5, wireType 0 =*/40).bool(message.published);
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.id);
            if (message.annotationType != null && Object.hasOwnProperty.call(message, "annotationType"))
                writer.uint32(/* id 7, wireType 0 =*/56).int32(message.annotationType);
            return writer;
        };

        /**
         * Encodes the specified RecordingAnnotation message, length delimited. Does not implicitly {@link recording.RecordingAnnotation.verify|verify} messages.
         * @function encodeDelimited
         * @memberof recording.RecordingAnnotation
         * @static
         * @param {recording.IRecordingAnnotation} message RecordingAnnotation message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RecordingAnnotation.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RecordingAnnotation message from the specified reader or buffer.
         * @function decode
         * @memberof recording.RecordingAnnotation
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {recording.RecordingAnnotation} RecordingAnnotation
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RecordingAnnotation.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.recording.RecordingAnnotation();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.startMs = reader.int32();
                        break;
                    }
                case 2: {
                        message.endMs = reader.int32();
                        break;
                    }
                case 3: {
                        message.label = reader.string();
                        break;
                    }
                case 4: {
                        message.description = reader.string();
                        break;
                    }
                case 5: {
                        message.published = reader.bool();
                        break;
                    }
                case 6: {
                        message.id = reader.string();
                        break;
                    }
                case 7: {
                        message.annotationType = reader.int32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RecordingAnnotation message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof recording.RecordingAnnotation
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {recording.RecordingAnnotation} RecordingAnnotation
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RecordingAnnotation.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RecordingAnnotation message.
         * @function verify
         * @memberof recording.RecordingAnnotation
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RecordingAnnotation.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.startMs != null && message.hasOwnProperty("startMs"))
                if (!$util.isInteger(message.startMs))
                    return "startMs: integer expected";
            if (message.endMs != null && message.hasOwnProperty("endMs"))
                if (!$util.isInteger(message.endMs))
                    return "endMs: integer expected";
            if (message.label != null && message.hasOwnProperty("label"))
                if (!$util.isString(message.label))
                    return "label: string expected";
            if (message.description != null && message.hasOwnProperty("description"))
                if (!$util.isString(message.description))
                    return "description: string expected";
            if (message.published != null && message.hasOwnProperty("published"))
                if (typeof message.published !== "boolean")
                    return "published: boolean expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.annotationType != null && message.hasOwnProperty("annotationType"))
                switch (message.annotationType) {
                default:
                    return "annotationType: enum value expected";
                case 0:
                case 1:
                case 2:
                    break;
                }
            return null;
        };

        /**
         * Creates a RecordingAnnotation message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof recording.RecordingAnnotation
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {recording.RecordingAnnotation} RecordingAnnotation
         */
        RecordingAnnotation.fromObject = function fromObject(object) {
            if (object instanceof $root.recording.RecordingAnnotation)
                return object;
            let message = new $root.recording.RecordingAnnotation();
            if (object.startMs != null)
                message.startMs = object.startMs | 0;
            if (object.endMs != null)
                message.endMs = object.endMs | 0;
            if (object.label != null)
                message.label = String(object.label);
            if (object.description != null)
                message.description = String(object.description);
            if (object.published != null)
                message.published = Boolean(object.published);
            if (object.id != null)
                message.id = String(object.id);
            switch (object.annotationType) {
            default:
                if (typeof object.annotationType === "number") {
                    message.annotationType = object.annotationType;
                    break;
                }
                break;
            case "AT_NONE":
            case 0:
                message.annotationType = 0;
                break;
            case "AT_GOOD_PRACTICE":
            case 1:
                message.annotationType = 1;
                break;
            case "AT_COMMON_MISTAKE":
            case 2:
                message.annotationType = 2;
                break;
            }
            return message;
        };

        /**
         * Creates a plain object from a RecordingAnnotation message. Also converts values to other types if specified.
         * @function toObject
         * @memberof recording.RecordingAnnotation
         * @static
         * @param {recording.RecordingAnnotation} message RecordingAnnotation
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RecordingAnnotation.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.startMs = 0;
                object.endMs = 0;
                object.label = "";
                object.description = "";
                object.published = false;
                object.id = "";
                object.annotationType = options.enums === String ? "AT_NONE" : 0;
            }
            if (message.startMs != null && message.hasOwnProperty("startMs"))
                object.startMs = message.startMs;
            if (message.endMs != null && message.hasOwnProperty("endMs"))
                object.endMs = message.endMs;
            if (message.label != null && message.hasOwnProperty("label"))
                object.label = message.label;
            if (message.description != null && message.hasOwnProperty("description"))
                object.description = message.description;
            if (message.published != null && message.hasOwnProperty("published"))
                object.published = message.published;
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.annotationType != null && message.hasOwnProperty("annotationType"))
                object.annotationType = options.enums === String ? $root.recording.AnnotationType[message.annotationType] === undefined ? message.annotationType : $root.recording.AnnotationType[message.annotationType] : message.annotationType;
            return object;
        };

        /**
         * Converts this RecordingAnnotation to JSON.
         * @function toJSON
         * @memberof recording.RecordingAnnotation
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RecordingAnnotation.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for RecordingAnnotation
         * @function getTypeUrl
         * @memberof recording.RecordingAnnotation
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        RecordingAnnotation.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/recording.RecordingAnnotation";
        };

        return RecordingAnnotation;
    })();

    recording.SaveRecordingAnnotation = (function() {

        /**
         * Properties of a SaveRecordingAnnotation.
         * @memberof recording
         * @interface ISaveRecordingAnnotation
         * @property {string|null} [recordingId] SaveRecordingAnnotation recordingId
         * @property {recording.IRecordingAnnotation|null} [annotation] SaveRecordingAnnotation annotation
         */

        /**
         * Constructs a new SaveRecordingAnnotation.
         * @memberof recording
         * @classdesc Represents a SaveRecordingAnnotation.
         * @implements ISaveRecordingAnnotation
         * @constructor
         * @param {recording.ISaveRecordingAnnotation=} [properties] Properties to set
         */
        function SaveRecordingAnnotation(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SaveRecordingAnnotation recordingId.
         * @member {string} recordingId
         * @memberof recording.SaveRecordingAnnotation
         * @instance
         */
        SaveRecordingAnnotation.prototype.recordingId = "";

        /**
         * SaveRecordingAnnotation annotation.
         * @member {recording.IRecordingAnnotation|null|undefined} annotation
         * @memberof recording.SaveRecordingAnnotation
         * @instance
         */
        SaveRecordingAnnotation.prototype.annotation = null;

        /**
         * Creates a new SaveRecordingAnnotation instance using the specified properties.
         * @function create
         * @memberof recording.SaveRecordingAnnotation
         * @static
         * @param {recording.ISaveRecordingAnnotation=} [properties] Properties to set
         * @returns {recording.SaveRecordingAnnotation} SaveRecordingAnnotation instance
         */
        SaveRecordingAnnotation.create = function create(properties) {
            return new SaveRecordingAnnotation(properties);
        };

        /**
         * Encodes the specified SaveRecordingAnnotation message. Does not implicitly {@link recording.SaveRecordingAnnotation.verify|verify} messages.
         * @function encode
         * @memberof recording.SaveRecordingAnnotation
         * @static
         * @param {recording.ISaveRecordingAnnotation} message SaveRecordingAnnotation message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SaveRecordingAnnotation.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.recordingId != null && Object.hasOwnProperty.call(message, "recordingId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.recordingId);
            if (message.annotation != null && Object.hasOwnProperty.call(message, "annotation"))
                $root.recording.RecordingAnnotation.encode(message.annotation, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified SaveRecordingAnnotation message, length delimited. Does not implicitly {@link recording.SaveRecordingAnnotation.verify|verify} messages.
         * @function encodeDelimited
         * @memberof recording.SaveRecordingAnnotation
         * @static
         * @param {recording.ISaveRecordingAnnotation} message SaveRecordingAnnotation message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SaveRecordingAnnotation.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SaveRecordingAnnotation message from the specified reader or buffer.
         * @function decode
         * @memberof recording.SaveRecordingAnnotation
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {recording.SaveRecordingAnnotation} SaveRecordingAnnotation
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SaveRecordingAnnotation.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.recording.SaveRecordingAnnotation();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.recordingId = reader.string();
                        break;
                    }
                case 2: {
                        message.annotation = $root.recording.RecordingAnnotation.decode(reader, reader.uint32());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SaveRecordingAnnotation message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof recording.SaveRecordingAnnotation
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {recording.SaveRecordingAnnotation} SaveRecordingAnnotation
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SaveRecordingAnnotation.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SaveRecordingAnnotation message.
         * @function verify
         * @memberof recording.SaveRecordingAnnotation
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SaveRecordingAnnotation.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.recordingId != null && message.hasOwnProperty("recordingId"))
                if (!$util.isString(message.recordingId))
                    return "recordingId: string expected";
            if (message.annotation != null && message.hasOwnProperty("annotation")) {
                let error = $root.recording.RecordingAnnotation.verify(message.annotation);
                if (error)
                    return "annotation." + error;
            }
            return null;
        };

        /**
         * Creates a SaveRecordingAnnotation message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof recording.SaveRecordingAnnotation
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {recording.SaveRecordingAnnotation} SaveRecordingAnnotation
         */
        SaveRecordingAnnotation.fromObject = function fromObject(object) {
            if (object instanceof $root.recording.SaveRecordingAnnotation)
                return object;
            let message = new $root.recording.SaveRecordingAnnotation();
            if (object.recordingId != null)
                message.recordingId = String(object.recordingId);
            if (object.annotation != null) {
                if (typeof object.annotation !== "object")
                    throw TypeError(".recording.SaveRecordingAnnotation.annotation: object expected");
                message.annotation = $root.recording.RecordingAnnotation.fromObject(object.annotation);
            }
            return message;
        };

        /**
         * Creates a plain object from a SaveRecordingAnnotation message. Also converts values to other types if specified.
         * @function toObject
         * @memberof recording.SaveRecordingAnnotation
         * @static
         * @param {recording.SaveRecordingAnnotation} message SaveRecordingAnnotation
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SaveRecordingAnnotation.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.recordingId = "";
                object.annotation = null;
            }
            if (message.recordingId != null && message.hasOwnProperty("recordingId"))
                object.recordingId = message.recordingId;
            if (message.annotation != null && message.hasOwnProperty("annotation"))
                object.annotation = $root.recording.RecordingAnnotation.toObject(message.annotation, options);
            return object;
        };

        /**
         * Converts this SaveRecordingAnnotation to JSON.
         * @function toJSON
         * @memberof recording.SaveRecordingAnnotation
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SaveRecordingAnnotation.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for SaveRecordingAnnotation
         * @function getTypeUrl
         * @memberof recording.SaveRecordingAnnotation
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        SaveRecordingAnnotation.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/recording.SaveRecordingAnnotation";
        };

        return SaveRecordingAnnotation;
    })();

    recording.SaveRecordingAnnotationResponse = (function() {

        /**
         * Properties of a SaveRecordingAnnotationResponse.
         * @memberof recording
         * @interface ISaveRecordingAnnotationResponse
         * @property {recording.IRecordingAnnotation|null} [annotation] SaveRecordingAnnotationResponse annotation
         */

        /**
         * Constructs a new SaveRecordingAnnotationResponse.
         * @memberof recording
         * @classdesc Represents a SaveRecordingAnnotationResponse.
         * @implements ISaveRecordingAnnotationResponse
         * @constructor
         * @param {recording.ISaveRecordingAnnotationResponse=} [properties] Properties to set
         */
        function SaveRecordingAnnotationResponse(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SaveRecordingAnnotationResponse annotation.
         * @member {recording.IRecordingAnnotation|null|undefined} annotation
         * @memberof recording.SaveRecordingAnnotationResponse
         * @instance
         */
        SaveRecordingAnnotationResponse.prototype.annotation = null;

        /**
         * Creates a new SaveRecordingAnnotationResponse instance using the specified properties.
         * @function create
         * @memberof recording.SaveRecordingAnnotationResponse
         * @static
         * @param {recording.ISaveRecordingAnnotationResponse=} [properties] Properties to set
         * @returns {recording.SaveRecordingAnnotationResponse} SaveRecordingAnnotationResponse instance
         */
        SaveRecordingAnnotationResponse.create = function create(properties) {
            return new SaveRecordingAnnotationResponse(properties);
        };

        /**
         * Encodes the specified SaveRecordingAnnotationResponse message. Does not implicitly {@link recording.SaveRecordingAnnotationResponse.verify|verify} messages.
         * @function encode
         * @memberof recording.SaveRecordingAnnotationResponse
         * @static
         * @param {recording.ISaveRecordingAnnotationResponse} message SaveRecordingAnnotationResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SaveRecordingAnnotationResponse.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.annotation != null && Object.hasOwnProperty.call(message, "annotation"))
                $root.recording.RecordingAnnotation.encode(message.annotation, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified SaveRecordingAnnotationResponse message, length delimited. Does not implicitly {@link recording.SaveRecordingAnnotationResponse.verify|verify} messages.
         * @function encodeDelimited
         * @memberof recording.SaveRecordingAnnotationResponse
         * @static
         * @param {recording.ISaveRecordingAnnotationResponse} message SaveRecordingAnnotationResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SaveRecordingAnnotationResponse.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SaveRecordingAnnotationResponse message from the specified reader or buffer.
         * @function decode
         * @memberof recording.SaveRecordingAnnotationResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {recording.SaveRecordingAnnotationResponse} SaveRecordingAnnotationResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SaveRecordingAnnotationResponse.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.recording.SaveRecordingAnnotationResponse();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.annotation = $root.recording.RecordingAnnotation.decode(reader, reader.uint32());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SaveRecordingAnnotationResponse message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof recording.SaveRecordingAnnotationResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {recording.SaveRecordingAnnotationResponse} SaveRecordingAnnotationResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SaveRecordingAnnotationResponse.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SaveRecordingAnnotationResponse message.
         * @function verify
         * @memberof recording.SaveRecordingAnnotationResponse
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SaveRecordingAnnotationResponse.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.annotation != null && message.hasOwnProperty("annotation")) {
                let error = $root.recording.RecordingAnnotation.verify(message.annotation);
                if (error)
                    return "annotation." + error;
            }
            return null;
        };

        /**
         * Creates a SaveRecordingAnnotationResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof recording.SaveRecordingAnnotationResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {recording.SaveRecordingAnnotationResponse} SaveRecordingAnnotationResponse
         */
        SaveRecordingAnnotationResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.recording.SaveRecordingAnnotationResponse)
                return object;
            let message = new $root.recording.SaveRecordingAnnotationResponse();
            if (object.annotation != null) {
                if (typeof object.annotation !== "object")
                    throw TypeError(".recording.SaveRecordingAnnotationResponse.annotation: object expected");
                message.annotation = $root.recording.RecordingAnnotation.fromObject(object.annotation);
            }
            return message;
        };

        /**
         * Creates a plain object from a SaveRecordingAnnotationResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof recording.SaveRecordingAnnotationResponse
         * @static
         * @param {recording.SaveRecordingAnnotationResponse} message SaveRecordingAnnotationResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SaveRecordingAnnotationResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.annotation = null;
            if (message.annotation != null && message.hasOwnProperty("annotation"))
                object.annotation = $root.recording.RecordingAnnotation.toObject(message.annotation, options);
            return object;
        };

        /**
         * Converts this SaveRecordingAnnotationResponse to JSON.
         * @function toJSON
         * @memberof recording.SaveRecordingAnnotationResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SaveRecordingAnnotationResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for SaveRecordingAnnotationResponse
         * @function getTypeUrl
         * @memberof recording.SaveRecordingAnnotationResponse
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        SaveRecordingAnnotationResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/recording.SaveRecordingAnnotationResponse";
        };

        return SaveRecordingAnnotationResponse;
    })();

    recording.DeleteRecordingAnnotation = (function() {

        /**
         * Properties of a DeleteRecordingAnnotation.
         * @memberof recording
         * @interface IDeleteRecordingAnnotation
         * @property {string|null} [recordingId] DeleteRecordingAnnotation recordingId
         * @property {string|null} [annotationId] DeleteRecordingAnnotation annotationId
         */

        /**
         * Constructs a new DeleteRecordingAnnotation.
         * @memberof recording
         * @classdesc Represents a DeleteRecordingAnnotation.
         * @implements IDeleteRecordingAnnotation
         * @constructor
         * @param {recording.IDeleteRecordingAnnotation=} [properties] Properties to set
         */
        function DeleteRecordingAnnotation(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * DeleteRecordingAnnotation recordingId.
         * @member {string} recordingId
         * @memberof recording.DeleteRecordingAnnotation
         * @instance
         */
        DeleteRecordingAnnotation.prototype.recordingId = "";

        /**
         * DeleteRecordingAnnotation annotationId.
         * @member {string} annotationId
         * @memberof recording.DeleteRecordingAnnotation
         * @instance
         */
        DeleteRecordingAnnotation.prototype.annotationId = "";

        /**
         * Creates a new DeleteRecordingAnnotation instance using the specified properties.
         * @function create
         * @memberof recording.DeleteRecordingAnnotation
         * @static
         * @param {recording.IDeleteRecordingAnnotation=} [properties] Properties to set
         * @returns {recording.DeleteRecordingAnnotation} DeleteRecordingAnnotation instance
         */
        DeleteRecordingAnnotation.create = function create(properties) {
            return new DeleteRecordingAnnotation(properties);
        };

        /**
         * Encodes the specified DeleteRecordingAnnotation message. Does not implicitly {@link recording.DeleteRecordingAnnotation.verify|verify} messages.
         * @function encode
         * @memberof recording.DeleteRecordingAnnotation
         * @static
         * @param {recording.IDeleteRecordingAnnotation} message DeleteRecordingAnnotation message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DeleteRecordingAnnotation.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.recordingId != null && Object.hasOwnProperty.call(message, "recordingId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.recordingId);
            if (message.annotationId != null && Object.hasOwnProperty.call(message, "annotationId"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.annotationId);
            return writer;
        };

        /**
         * Encodes the specified DeleteRecordingAnnotation message, length delimited. Does not implicitly {@link recording.DeleteRecordingAnnotation.verify|verify} messages.
         * @function encodeDelimited
         * @memberof recording.DeleteRecordingAnnotation
         * @static
         * @param {recording.IDeleteRecordingAnnotation} message DeleteRecordingAnnotation message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DeleteRecordingAnnotation.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a DeleteRecordingAnnotation message from the specified reader or buffer.
         * @function decode
         * @memberof recording.DeleteRecordingAnnotation
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {recording.DeleteRecordingAnnotation} DeleteRecordingAnnotation
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DeleteRecordingAnnotation.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.recording.DeleteRecordingAnnotation();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.recordingId = reader.string();
                        break;
                    }
                case 2: {
                        message.annotationId = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a DeleteRecordingAnnotation message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof recording.DeleteRecordingAnnotation
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {recording.DeleteRecordingAnnotation} DeleteRecordingAnnotation
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DeleteRecordingAnnotation.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a DeleteRecordingAnnotation message.
         * @function verify
         * @memberof recording.DeleteRecordingAnnotation
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        DeleteRecordingAnnotation.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.recordingId != null && message.hasOwnProperty("recordingId"))
                if (!$util.isString(message.recordingId))
                    return "recordingId: string expected";
            if (message.annotationId != null && message.hasOwnProperty("annotationId"))
                if (!$util.isString(message.annotationId))
                    return "annotationId: string expected";
            return null;
        };

        /**
         * Creates a DeleteRecordingAnnotation message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof recording.DeleteRecordingAnnotation
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {recording.DeleteRecordingAnnotation} DeleteRecordingAnnotation
         */
        DeleteRecordingAnnotation.fromObject = function fromObject(object) {
            if (object instanceof $root.recording.DeleteRecordingAnnotation)
                return object;
            let message = new $root.recording.DeleteRecordingAnnotation();
            if (object.recordingId != null)
                message.recordingId = String(object.recordingId);
            if (object.annotationId != null)
                message.annotationId = String(object.annotationId);
            return message;
        };

        /**
         * Creates a plain object from a DeleteRecordingAnnotation message. Also converts values to other types if specified.
         * @function toObject
         * @memberof recording.DeleteRecordingAnnotation
         * @static
         * @param {recording.DeleteRecordingAnnotation} message DeleteRecordingAnnotation
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DeleteRecordingAnnotation.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.recordingId = "";
                object.annotationId = "";
            }
            if (message.recordingId != null && message.hasOwnProperty("recordingId"))
                object.recordingId = message.recordingId;
            if (message.annotationId != null && message.hasOwnProperty("annotationId"))
                object.annotationId = message.annotationId;
            return object;
        };

        /**
         * Converts this DeleteRecordingAnnotation to JSON.
         * @function toJSON
         * @memberof recording.DeleteRecordingAnnotation
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DeleteRecordingAnnotation.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for DeleteRecordingAnnotation
         * @function getTypeUrl
         * @memberof recording.DeleteRecordingAnnotation
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        DeleteRecordingAnnotation.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/recording.DeleteRecordingAnnotation";
        };

        return DeleteRecordingAnnotation;
    })();

    recording.UpdateRecording = (function() {

        /**
         * Properties of an UpdateRecording.
         * @memberof recording
         * @interface IUpdateRecording
         * @property {recordings.IRecording|null} [recording] UpdateRecording recording
         */

        /**
         * Constructs a new UpdateRecording.
         * @memberof recording
         * @classdesc Represents an UpdateRecording.
         * @implements IUpdateRecording
         * @constructor
         * @param {recording.IUpdateRecording=} [properties] Properties to set
         */
        function UpdateRecording(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateRecording recording.
         * @member {recordings.IRecording|null|undefined} recording
         * @memberof recording.UpdateRecording
         * @instance
         */
        UpdateRecording.prototype.recording = null;

        /**
         * Creates a new UpdateRecording instance using the specified properties.
         * @function create
         * @memberof recording.UpdateRecording
         * @static
         * @param {recording.IUpdateRecording=} [properties] Properties to set
         * @returns {recording.UpdateRecording} UpdateRecording instance
         */
        UpdateRecording.create = function create(properties) {
            return new UpdateRecording(properties);
        };

        /**
         * Encodes the specified UpdateRecording message. Does not implicitly {@link recording.UpdateRecording.verify|verify} messages.
         * @function encode
         * @memberof recording.UpdateRecording
         * @static
         * @param {recording.IUpdateRecording} message UpdateRecording message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateRecording.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.recording != null && Object.hasOwnProperty.call(message, "recording"))
                $root.recordings.Recording.encode(message.recording, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified UpdateRecording message, length delimited. Does not implicitly {@link recording.UpdateRecording.verify|verify} messages.
         * @function encodeDelimited
         * @memberof recording.UpdateRecording
         * @static
         * @param {recording.IUpdateRecording} message UpdateRecording message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateRecording.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an UpdateRecording message from the specified reader or buffer.
         * @function decode
         * @memberof recording.UpdateRecording
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {recording.UpdateRecording} UpdateRecording
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateRecording.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.recording.UpdateRecording();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.recording = $root.recordings.Recording.decode(reader, reader.uint32());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an UpdateRecording message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof recording.UpdateRecording
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {recording.UpdateRecording} UpdateRecording
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateRecording.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an UpdateRecording message.
         * @function verify
         * @memberof recording.UpdateRecording
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UpdateRecording.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.recording != null && message.hasOwnProperty("recording")) {
                let error = $root.recordings.Recording.verify(message.recording);
                if (error)
                    return "recording." + error;
            }
            return null;
        };

        /**
         * Creates an UpdateRecording message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof recording.UpdateRecording
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {recording.UpdateRecording} UpdateRecording
         */
        UpdateRecording.fromObject = function fromObject(object) {
            if (object instanceof $root.recording.UpdateRecording)
                return object;
            let message = new $root.recording.UpdateRecording();
            if (object.recording != null) {
                if (typeof object.recording !== "object")
                    throw TypeError(".recording.UpdateRecording.recording: object expected");
                message.recording = $root.recordings.Recording.fromObject(object.recording);
            }
            return message;
        };

        /**
         * Creates a plain object from an UpdateRecording message. Also converts values to other types if specified.
         * @function toObject
         * @memberof recording.UpdateRecording
         * @static
         * @param {recording.UpdateRecording} message UpdateRecording
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateRecording.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.recording = null;
            if (message.recording != null && message.hasOwnProperty("recording"))
                object.recording = $root.recordings.Recording.toObject(message.recording, options);
            return object;
        };

        /**
         * Converts this UpdateRecording to JSON.
         * @function toJSON
         * @memberof recording.UpdateRecording
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateRecording.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for UpdateRecording
         * @function getTypeUrl
         * @memberof recording.UpdateRecording
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        UpdateRecording.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/recording.UpdateRecording";
        };

        return UpdateRecording;
    })();

    recording.CreateRecording = (function() {

        /**
         * Properties of a CreateRecording.
         * @memberof recording
         * @interface ICreateRecording
         * @property {string|null} [videoFileId] CreateRecording videoFileId
         * @property {string|null} [title] CreateRecording title
         * @property {string|null} [description] CreateRecording description
         * @property {Array.<recordings.IRecordingParticipant>|null} [participants] CreateRecording participants
         * @property {number|null} [durationMs] CreateRecording durationMs
         */

        /**
         * Constructs a new CreateRecording.
         * @memberof recording
         * @classdesc Represents a CreateRecording.
         * @implements ICreateRecording
         * @constructor
         * @param {recording.ICreateRecording=} [properties] Properties to set
         */
        function CreateRecording(properties) {
            this.participants = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CreateRecording videoFileId.
         * @member {string} videoFileId
         * @memberof recording.CreateRecording
         * @instance
         */
        CreateRecording.prototype.videoFileId = "";

        /**
         * CreateRecording title.
         * @member {string} title
         * @memberof recording.CreateRecording
         * @instance
         */
        CreateRecording.prototype.title = "";

        /**
         * CreateRecording description.
         * @member {string} description
         * @memberof recording.CreateRecording
         * @instance
         */
        CreateRecording.prototype.description = "";

        /**
         * CreateRecording participants.
         * @member {Array.<recordings.IRecordingParticipant>} participants
         * @memberof recording.CreateRecording
         * @instance
         */
        CreateRecording.prototype.participants = $util.emptyArray;

        /**
         * CreateRecording durationMs.
         * @member {number} durationMs
         * @memberof recording.CreateRecording
         * @instance
         */
        CreateRecording.prototype.durationMs = 0;

        /**
         * Creates a new CreateRecording instance using the specified properties.
         * @function create
         * @memberof recording.CreateRecording
         * @static
         * @param {recording.ICreateRecording=} [properties] Properties to set
         * @returns {recording.CreateRecording} CreateRecording instance
         */
        CreateRecording.create = function create(properties) {
            return new CreateRecording(properties);
        };

        /**
         * Encodes the specified CreateRecording message. Does not implicitly {@link recording.CreateRecording.verify|verify} messages.
         * @function encode
         * @memberof recording.CreateRecording
         * @static
         * @param {recording.ICreateRecording} message CreateRecording message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateRecording.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.videoFileId != null && Object.hasOwnProperty.call(message, "videoFileId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.videoFileId);
            if (message.title != null && Object.hasOwnProperty.call(message, "title"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.title);
            if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.description);
            if (message.participants != null && message.participants.length)
                for (let i = 0; i < message.participants.length; ++i)
                    $root.recordings.RecordingParticipant.encode(message.participants[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
            if (message.durationMs != null && Object.hasOwnProperty.call(message, "durationMs"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.durationMs);
            return writer;
        };

        /**
         * Encodes the specified CreateRecording message, length delimited. Does not implicitly {@link recording.CreateRecording.verify|verify} messages.
         * @function encodeDelimited
         * @memberof recording.CreateRecording
         * @static
         * @param {recording.ICreateRecording} message CreateRecording message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateRecording.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CreateRecording message from the specified reader or buffer.
         * @function decode
         * @memberof recording.CreateRecording
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {recording.CreateRecording} CreateRecording
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateRecording.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.recording.CreateRecording();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.videoFileId = reader.string();
                        break;
                    }
                case 2: {
                        message.title = reader.string();
                        break;
                    }
                case 3: {
                        message.description = reader.string();
                        break;
                    }
                case 4: {
                        if (!(message.participants && message.participants.length))
                            message.participants = [];
                        message.participants.push($root.recordings.RecordingParticipant.decode(reader, reader.uint32()));
                        break;
                    }
                case 5: {
                        message.durationMs = reader.int32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CreateRecording message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof recording.CreateRecording
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {recording.CreateRecording} CreateRecording
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateRecording.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CreateRecording message.
         * @function verify
         * @memberof recording.CreateRecording
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CreateRecording.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.videoFileId != null && message.hasOwnProperty("videoFileId"))
                if (!$util.isString(message.videoFileId))
                    return "videoFileId: string expected";
            if (message.title != null && message.hasOwnProperty("title"))
                if (!$util.isString(message.title))
                    return "title: string expected";
            if (message.description != null && message.hasOwnProperty("description"))
                if (!$util.isString(message.description))
                    return "description: string expected";
            if (message.participants != null && message.hasOwnProperty("participants")) {
                if (!Array.isArray(message.participants))
                    return "participants: array expected";
                for (let i = 0; i < message.participants.length; ++i) {
                    let error = $root.recordings.RecordingParticipant.verify(message.participants[i]);
                    if (error)
                        return "participants." + error;
                }
            }
            if (message.durationMs != null && message.hasOwnProperty("durationMs"))
                if (!$util.isInteger(message.durationMs))
                    return "durationMs: integer expected";
            return null;
        };

        /**
         * Creates a CreateRecording message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof recording.CreateRecording
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {recording.CreateRecording} CreateRecording
         */
        CreateRecording.fromObject = function fromObject(object) {
            if (object instanceof $root.recording.CreateRecording)
                return object;
            let message = new $root.recording.CreateRecording();
            if (object.videoFileId != null)
                message.videoFileId = String(object.videoFileId);
            if (object.title != null)
                message.title = String(object.title);
            if (object.description != null)
                message.description = String(object.description);
            if (object.participants) {
                if (!Array.isArray(object.participants))
                    throw TypeError(".recording.CreateRecording.participants: array expected");
                message.participants = [];
                for (let i = 0; i < object.participants.length; ++i) {
                    if (typeof object.participants[i] !== "object")
                        throw TypeError(".recording.CreateRecording.participants: object expected");
                    message.participants[i] = $root.recordings.RecordingParticipant.fromObject(object.participants[i]);
                }
            }
            if (object.durationMs != null)
                message.durationMs = object.durationMs | 0;
            return message;
        };

        /**
         * Creates a plain object from a CreateRecording message. Also converts values to other types if specified.
         * @function toObject
         * @memberof recording.CreateRecording
         * @static
         * @param {recording.CreateRecording} message CreateRecording
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CreateRecording.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.participants = [];
            if (options.defaults) {
                object.videoFileId = "";
                object.title = "";
                object.description = "";
                object.durationMs = 0;
            }
            if (message.videoFileId != null && message.hasOwnProperty("videoFileId"))
                object.videoFileId = message.videoFileId;
            if (message.title != null && message.hasOwnProperty("title"))
                object.title = message.title;
            if (message.description != null && message.hasOwnProperty("description"))
                object.description = message.description;
            if (message.participants && message.participants.length) {
                object.participants = [];
                for (let j = 0; j < message.participants.length; ++j)
                    object.participants[j] = $root.recordings.RecordingParticipant.toObject(message.participants[j], options);
            }
            if (message.durationMs != null && message.hasOwnProperty("durationMs"))
                object.durationMs = message.durationMs;
            return object;
        };

        /**
         * Converts this CreateRecording to JSON.
         * @function toJSON
         * @memberof recording.CreateRecording
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CreateRecording.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for CreateRecording
         * @function getTypeUrl
         * @memberof recording.CreateRecording
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        CreateRecording.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/recording.CreateRecording";
        };

        return CreateRecording;
    })();

    recording.CreateRecordingResponse = (function() {

        /**
         * Properties of a CreateRecordingResponse.
         * @memberof recording
         * @interface ICreateRecordingResponse
         * @property {string|null} [recordingId] CreateRecordingResponse recordingId
         */

        /**
         * Constructs a new CreateRecordingResponse.
         * @memberof recording
         * @classdesc Represents a CreateRecordingResponse.
         * @implements ICreateRecordingResponse
         * @constructor
         * @param {recording.ICreateRecordingResponse=} [properties] Properties to set
         */
        function CreateRecordingResponse(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CreateRecordingResponse recordingId.
         * @member {string} recordingId
         * @memberof recording.CreateRecordingResponse
         * @instance
         */
        CreateRecordingResponse.prototype.recordingId = "";

        /**
         * Creates a new CreateRecordingResponse instance using the specified properties.
         * @function create
         * @memberof recording.CreateRecordingResponse
         * @static
         * @param {recording.ICreateRecordingResponse=} [properties] Properties to set
         * @returns {recording.CreateRecordingResponse} CreateRecordingResponse instance
         */
        CreateRecordingResponse.create = function create(properties) {
            return new CreateRecordingResponse(properties);
        };

        /**
         * Encodes the specified CreateRecordingResponse message. Does not implicitly {@link recording.CreateRecordingResponse.verify|verify} messages.
         * @function encode
         * @memberof recording.CreateRecordingResponse
         * @static
         * @param {recording.ICreateRecordingResponse} message CreateRecordingResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateRecordingResponse.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.recordingId != null && Object.hasOwnProperty.call(message, "recordingId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.recordingId);
            return writer;
        };

        /**
         * Encodes the specified CreateRecordingResponse message, length delimited. Does not implicitly {@link recording.CreateRecordingResponse.verify|verify} messages.
         * @function encodeDelimited
         * @memberof recording.CreateRecordingResponse
         * @static
         * @param {recording.ICreateRecordingResponse} message CreateRecordingResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateRecordingResponse.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CreateRecordingResponse message from the specified reader or buffer.
         * @function decode
         * @memberof recording.CreateRecordingResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {recording.CreateRecordingResponse} CreateRecordingResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateRecordingResponse.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.recording.CreateRecordingResponse();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.recordingId = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CreateRecordingResponse message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof recording.CreateRecordingResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {recording.CreateRecordingResponse} CreateRecordingResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateRecordingResponse.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CreateRecordingResponse message.
         * @function verify
         * @memberof recording.CreateRecordingResponse
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CreateRecordingResponse.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.recordingId != null && message.hasOwnProperty("recordingId"))
                if (!$util.isString(message.recordingId))
                    return "recordingId: string expected";
            return null;
        };

        /**
         * Creates a CreateRecordingResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof recording.CreateRecordingResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {recording.CreateRecordingResponse} CreateRecordingResponse
         */
        CreateRecordingResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.recording.CreateRecordingResponse)
                return object;
            let message = new $root.recording.CreateRecordingResponse();
            if (object.recordingId != null)
                message.recordingId = String(object.recordingId);
            return message;
        };

        /**
         * Creates a plain object from a CreateRecordingResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof recording.CreateRecordingResponse
         * @static
         * @param {recording.CreateRecordingResponse} message CreateRecordingResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CreateRecordingResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.recordingId = "";
            if (message.recordingId != null && message.hasOwnProperty("recordingId"))
                object.recordingId = message.recordingId;
            return object;
        };

        /**
         * Converts this CreateRecordingResponse to JSON.
         * @function toJSON
         * @memberof recording.CreateRecordingResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CreateRecordingResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for CreateRecordingResponse
         * @function getTypeUrl
         * @memberof recording.CreateRecordingResponse
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        CreateRecordingResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/recording.CreateRecordingResponse";
        };

        return CreateRecordingResponse;
    })();

    recording.DeleteRecording = (function() {

        /**
         * Properties of a DeleteRecording.
         * @memberof recording
         * @interface IDeleteRecording
         * @property {string|null} [id] DeleteRecording id
         */

        /**
         * Constructs a new DeleteRecording.
         * @memberof recording
         * @classdesc Represents a DeleteRecording.
         * @implements IDeleteRecording
         * @constructor
         * @param {recording.IDeleteRecording=} [properties] Properties to set
         */
        function DeleteRecording(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * DeleteRecording id.
         * @member {string} id
         * @memberof recording.DeleteRecording
         * @instance
         */
        DeleteRecording.prototype.id = "";

        /**
         * Creates a new DeleteRecording instance using the specified properties.
         * @function create
         * @memberof recording.DeleteRecording
         * @static
         * @param {recording.IDeleteRecording=} [properties] Properties to set
         * @returns {recording.DeleteRecording} DeleteRecording instance
         */
        DeleteRecording.create = function create(properties) {
            return new DeleteRecording(properties);
        };

        /**
         * Encodes the specified DeleteRecording message. Does not implicitly {@link recording.DeleteRecording.verify|verify} messages.
         * @function encode
         * @memberof recording.DeleteRecording
         * @static
         * @param {recording.IDeleteRecording} message DeleteRecording message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DeleteRecording.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            return writer;
        };

        /**
         * Encodes the specified DeleteRecording message, length delimited. Does not implicitly {@link recording.DeleteRecording.verify|verify} messages.
         * @function encodeDelimited
         * @memberof recording.DeleteRecording
         * @static
         * @param {recording.IDeleteRecording} message DeleteRecording message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DeleteRecording.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a DeleteRecording message from the specified reader or buffer.
         * @function decode
         * @memberof recording.DeleteRecording
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {recording.DeleteRecording} DeleteRecording
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DeleteRecording.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.recording.DeleteRecording();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.id = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a DeleteRecording message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof recording.DeleteRecording
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {recording.DeleteRecording} DeleteRecording
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DeleteRecording.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a DeleteRecording message.
         * @function verify
         * @memberof recording.DeleteRecording
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        DeleteRecording.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            return null;
        };

        /**
         * Creates a DeleteRecording message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof recording.DeleteRecording
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {recording.DeleteRecording} DeleteRecording
         */
        DeleteRecording.fromObject = function fromObject(object) {
            if (object instanceof $root.recording.DeleteRecording)
                return object;
            let message = new $root.recording.DeleteRecording();
            if (object.id != null)
                message.id = String(object.id);
            return message;
        };

        /**
         * Creates a plain object from a DeleteRecording message. Also converts values to other types if specified.
         * @function toObject
         * @memberof recording.DeleteRecording
         * @static
         * @param {recording.DeleteRecording} message DeleteRecording
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DeleteRecording.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.id = "";
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            return object;
        };

        /**
         * Converts this DeleteRecording to JSON.
         * @function toJSON
         * @memberof recording.DeleteRecording
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DeleteRecording.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for DeleteRecording
         * @function getTypeUrl
         * @memberof recording.DeleteRecording
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        DeleteRecording.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/recording.DeleteRecording";
        };

        return DeleteRecording;
    })();

    return recording;
})();

export const recordings = $root.recordings = (() => {

    /**
     * Namespace recordings.
     * @exports recordings
     * @namespace
     */
    const recordings = {};

    recordings.ListRecordings = (function() {

        /**
         * Properties of a ListRecordings.
         * @memberof recordings
         * @interface IListRecordings
         * @property {common.IPagination|null} [pagination] ListRecordings pagination
         * @property {recordings.RecordingListScope|null} [scope] ListRecordings scope
         */

        /**
         * Constructs a new ListRecordings.
         * @memberof recordings
         * @classdesc Represents a ListRecordings.
         * @implements IListRecordings
         * @constructor
         * @param {recordings.IListRecordings=} [properties] Properties to set
         */
        function ListRecordings(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListRecordings pagination.
         * @member {common.IPagination|null|undefined} pagination
         * @memberof recordings.ListRecordings
         * @instance
         */
        ListRecordings.prototype.pagination = null;

        /**
         * ListRecordings scope.
         * @member {recordings.RecordingListScope} scope
         * @memberof recordings.ListRecordings
         * @instance
         */
        ListRecordings.prototype.scope = 0;

        /**
         * Creates a new ListRecordings instance using the specified properties.
         * @function create
         * @memberof recordings.ListRecordings
         * @static
         * @param {recordings.IListRecordings=} [properties] Properties to set
         * @returns {recordings.ListRecordings} ListRecordings instance
         */
        ListRecordings.create = function create(properties) {
            return new ListRecordings(properties);
        };

        /**
         * Encodes the specified ListRecordings message. Does not implicitly {@link recordings.ListRecordings.verify|verify} messages.
         * @function encode
         * @memberof recordings.ListRecordings
         * @static
         * @param {recordings.IListRecordings} message ListRecordings message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListRecordings.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pagination != null && Object.hasOwnProperty.call(message, "pagination"))
                $root.common.Pagination.encode(message.pagination, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.scope != null && Object.hasOwnProperty.call(message, "scope"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.scope);
            return writer;
        };

        /**
         * Encodes the specified ListRecordings message, length delimited. Does not implicitly {@link recordings.ListRecordings.verify|verify} messages.
         * @function encodeDelimited
         * @memberof recordings.ListRecordings
         * @static
         * @param {recordings.IListRecordings} message ListRecordings message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListRecordings.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ListRecordings message from the specified reader or buffer.
         * @function decode
         * @memberof recordings.ListRecordings
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {recordings.ListRecordings} ListRecordings
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListRecordings.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.recordings.ListRecordings();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.pagination = $root.common.Pagination.decode(reader, reader.uint32());
                        break;
                    }
                case 2: {
                        message.scope = reader.int32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ListRecordings message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof recordings.ListRecordings
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {recordings.ListRecordings} ListRecordings
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListRecordings.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ListRecordings message.
         * @function verify
         * @memberof recordings.ListRecordings
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ListRecordings.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.pagination != null && message.hasOwnProperty("pagination")) {
                let error = $root.common.Pagination.verify(message.pagination);
                if (error)
                    return "pagination." + error;
            }
            if (message.scope != null && message.hasOwnProperty("scope"))
                switch (message.scope) {
                default:
                    return "scope: enum value expected";
                case 0:
                case 1:
                case 2:
                    break;
                }
            return null;
        };

        /**
         * Creates a ListRecordings message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof recordings.ListRecordings
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {recordings.ListRecordings} ListRecordings
         */
        ListRecordings.fromObject = function fromObject(object) {
            if (object instanceof $root.recordings.ListRecordings)
                return object;
            let message = new $root.recordings.ListRecordings();
            if (object.pagination != null) {
                if (typeof object.pagination !== "object")
                    throw TypeError(".recordings.ListRecordings.pagination: object expected");
                message.pagination = $root.common.Pagination.fromObject(object.pagination);
            }
            switch (object.scope) {
            default:
                if (typeof object.scope === "number") {
                    message.scope = object.scope;
                    break;
                }
                break;
            case "rls_unknown":
            case 0:
                message.scope = 0;
                break;
            case "rls_my":
            case 1:
                message.scope = 1;
                break;
            case "rls_organization":
            case 2:
                message.scope = 2;
                break;
            }
            return message;
        };

        /**
         * Creates a plain object from a ListRecordings message. Also converts values to other types if specified.
         * @function toObject
         * @memberof recordings.ListRecordings
         * @static
         * @param {recordings.ListRecordings} message ListRecordings
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListRecordings.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.pagination = null;
                object.scope = options.enums === String ? "rls_unknown" : 0;
            }
            if (message.pagination != null && message.hasOwnProperty("pagination"))
                object.pagination = $root.common.Pagination.toObject(message.pagination, options);
            if (message.scope != null && message.hasOwnProperty("scope"))
                object.scope = options.enums === String ? $root.recordings.RecordingListScope[message.scope] === undefined ? message.scope : $root.recordings.RecordingListScope[message.scope] : message.scope;
            return object;
        };

        /**
         * Converts this ListRecordings to JSON.
         * @function toJSON
         * @memberof recordings.ListRecordings
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListRecordings.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ListRecordings
         * @function getTypeUrl
         * @memberof recordings.ListRecordings
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ListRecordings.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/recordings.ListRecordings";
        };

        return ListRecordings;
    })();

    recordings.ListRecordingsResponse = (function() {

        /**
         * Properties of a ListRecordingsResponse.
         * @memberof recordings
         * @interface IListRecordingsResponse
         * @property {common.IPagination|null} [pagination] ListRecordingsResponse pagination
         * @property {Array.<recordings.IRecording>|null} [recordings] ListRecordingsResponse recordings
         */

        /**
         * Constructs a new ListRecordingsResponse.
         * @memberof recordings
         * @classdesc Represents a ListRecordingsResponse.
         * @implements IListRecordingsResponse
         * @constructor
         * @param {recordings.IListRecordingsResponse=} [properties] Properties to set
         */
        function ListRecordingsResponse(properties) {
            this.recordings = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ListRecordingsResponse pagination.
         * @member {common.IPagination|null|undefined} pagination
         * @memberof recordings.ListRecordingsResponse
         * @instance
         */
        ListRecordingsResponse.prototype.pagination = null;

        /**
         * ListRecordingsResponse recordings.
         * @member {Array.<recordings.IRecording>} recordings
         * @memberof recordings.ListRecordingsResponse
         * @instance
         */
        ListRecordingsResponse.prototype.recordings = $util.emptyArray;

        /**
         * Creates a new ListRecordingsResponse instance using the specified properties.
         * @function create
         * @memberof recordings.ListRecordingsResponse
         * @static
         * @param {recordings.IListRecordingsResponse=} [properties] Properties to set
         * @returns {recordings.ListRecordingsResponse} ListRecordingsResponse instance
         */
        ListRecordingsResponse.create = function create(properties) {
            return new ListRecordingsResponse(properties);
        };

        /**
         * Encodes the specified ListRecordingsResponse message. Does not implicitly {@link recordings.ListRecordingsResponse.verify|verify} messages.
         * @function encode
         * @memberof recordings.ListRecordingsResponse
         * @static
         * @param {recordings.IListRecordingsResponse} message ListRecordingsResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListRecordingsResponse.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.pagination != null && Object.hasOwnProperty.call(message, "pagination"))
                $root.common.Pagination.encode(message.pagination, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.recordings != null && message.recordings.length)
                for (let i = 0; i < message.recordings.length; ++i)
                    $root.recordings.Recording.encode(message.recordings[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified ListRecordingsResponse message, length delimited. Does not implicitly {@link recordings.ListRecordingsResponse.verify|verify} messages.
         * @function encodeDelimited
         * @memberof recordings.ListRecordingsResponse
         * @static
         * @param {recordings.IListRecordingsResponse} message ListRecordingsResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ListRecordingsResponse.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ListRecordingsResponse message from the specified reader or buffer.
         * @function decode
         * @memberof recordings.ListRecordingsResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {recordings.ListRecordingsResponse} ListRecordingsResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListRecordingsResponse.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.recordings.ListRecordingsResponse();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.pagination = $root.common.Pagination.decode(reader, reader.uint32());
                        break;
                    }
                case 2: {
                        if (!(message.recordings && message.recordings.length))
                            message.recordings = [];
                        message.recordings.push($root.recordings.Recording.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ListRecordingsResponse message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof recordings.ListRecordingsResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {recordings.ListRecordingsResponse} ListRecordingsResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ListRecordingsResponse.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ListRecordingsResponse message.
         * @function verify
         * @memberof recordings.ListRecordingsResponse
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ListRecordingsResponse.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.pagination != null && message.hasOwnProperty("pagination")) {
                let error = $root.common.Pagination.verify(message.pagination);
                if (error)
                    return "pagination." + error;
            }
            if (message.recordings != null && message.hasOwnProperty("recordings")) {
                if (!Array.isArray(message.recordings))
                    return "recordings: array expected";
                for (let i = 0; i < message.recordings.length; ++i) {
                    let error = $root.recordings.Recording.verify(message.recordings[i]);
                    if (error)
                        return "recordings." + error;
                }
            }
            return null;
        };

        /**
         * Creates a ListRecordingsResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof recordings.ListRecordingsResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {recordings.ListRecordingsResponse} ListRecordingsResponse
         */
        ListRecordingsResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.recordings.ListRecordingsResponse)
                return object;
            let message = new $root.recordings.ListRecordingsResponse();
            if (object.pagination != null) {
                if (typeof object.pagination !== "object")
                    throw TypeError(".recordings.ListRecordingsResponse.pagination: object expected");
                message.pagination = $root.common.Pagination.fromObject(object.pagination);
            }
            if (object.recordings) {
                if (!Array.isArray(object.recordings))
                    throw TypeError(".recordings.ListRecordingsResponse.recordings: array expected");
                message.recordings = [];
                for (let i = 0; i < object.recordings.length; ++i) {
                    if (typeof object.recordings[i] !== "object")
                        throw TypeError(".recordings.ListRecordingsResponse.recordings: object expected");
                    message.recordings[i] = $root.recordings.Recording.fromObject(object.recordings[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a ListRecordingsResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof recordings.ListRecordingsResponse
         * @static
         * @param {recordings.ListRecordingsResponse} message ListRecordingsResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ListRecordingsResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.recordings = [];
            if (options.defaults)
                object.pagination = null;
            if (message.pagination != null && message.hasOwnProperty("pagination"))
                object.pagination = $root.common.Pagination.toObject(message.pagination, options);
            if (message.recordings && message.recordings.length) {
                object.recordings = [];
                for (let j = 0; j < message.recordings.length; ++j)
                    object.recordings[j] = $root.recordings.Recording.toObject(message.recordings[j], options);
            }
            return object;
        };

        /**
         * Converts this ListRecordingsResponse to JSON.
         * @function toJSON
         * @memberof recordings.ListRecordingsResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ListRecordingsResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ListRecordingsResponse
         * @function getTypeUrl
         * @memberof recordings.ListRecordingsResponse
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ListRecordingsResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/recordings.ListRecordingsResponse";
        };

        return ListRecordingsResponse;
    })();

    recordings.Recording = (function() {

        /**
         * Properties of a Recording.
         * @memberof recordings
         * @interface IRecording
         * @property {string|null} [id] Recording id
         * @property {string|null} [title] Recording title
         * @property {common.IDate|null} [dateCreated] Recording dateCreated
         * @property {string|null} [thumbnailUrl] Recording thumbnailUrl
         * @property {string|null} [duration] Recording duration
         * @property {string|null} [description] Recording description
         * @property {Array.<recordings.IRecordingParticipant>|null} [participants] Recording participants
         * @property {boolean|null} [isOwner] Recording isOwner
         */

        /**
         * Constructs a new Recording.
         * @memberof recordings
         * @classdesc Represents a Recording.
         * @implements IRecording
         * @constructor
         * @param {recordings.IRecording=} [properties] Properties to set
         */
        function Recording(properties) {
            this.participants = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Recording id.
         * @member {string} id
         * @memberof recordings.Recording
         * @instance
         */
        Recording.prototype.id = "";

        /**
         * Recording title.
         * @member {string} title
         * @memberof recordings.Recording
         * @instance
         */
        Recording.prototype.title = "";

        /**
         * Recording dateCreated.
         * @member {common.IDate|null|undefined} dateCreated
         * @memberof recordings.Recording
         * @instance
         */
        Recording.prototype.dateCreated = null;

        /**
         * Recording thumbnailUrl.
         * @member {string} thumbnailUrl
         * @memberof recordings.Recording
         * @instance
         */
        Recording.prototype.thumbnailUrl = "";

        /**
         * Recording duration.
         * @member {string} duration
         * @memberof recordings.Recording
         * @instance
         */
        Recording.prototype.duration = "";

        /**
         * Recording description.
         * @member {string} description
         * @memberof recordings.Recording
         * @instance
         */
        Recording.prototype.description = "";

        /**
         * Recording participants.
         * @member {Array.<recordings.IRecordingParticipant>} participants
         * @memberof recordings.Recording
         * @instance
         */
        Recording.prototype.participants = $util.emptyArray;

        /**
         * Recording isOwner.
         * @member {boolean} isOwner
         * @memberof recordings.Recording
         * @instance
         */
        Recording.prototype.isOwner = false;

        /**
         * Creates a new Recording instance using the specified properties.
         * @function create
         * @memberof recordings.Recording
         * @static
         * @param {recordings.IRecording=} [properties] Properties to set
         * @returns {recordings.Recording} Recording instance
         */
        Recording.create = function create(properties) {
            return new Recording(properties);
        };

        /**
         * Encodes the specified Recording message. Does not implicitly {@link recordings.Recording.verify|verify} messages.
         * @function encode
         * @memberof recordings.Recording
         * @static
         * @param {recordings.IRecording} message Recording message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Recording.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            if (message.title != null && Object.hasOwnProperty.call(message, "title"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.title);
            if (message.dateCreated != null && Object.hasOwnProperty.call(message, "dateCreated"))
                $root.common.Date.encode(message.dateCreated, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            if (message.thumbnailUrl != null && Object.hasOwnProperty.call(message, "thumbnailUrl"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.thumbnailUrl);
            if (message.duration != null && Object.hasOwnProperty.call(message, "duration"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.duration);
            if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.description);
            if (message.participants != null && message.participants.length)
                for (let i = 0; i < message.participants.length; ++i)
                    $root.recordings.RecordingParticipant.encode(message.participants[i], writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
            if (message.isOwner != null && Object.hasOwnProperty.call(message, "isOwner"))
                writer.uint32(/* id 8, wireType 0 =*/64).bool(message.isOwner);
            return writer;
        };

        /**
         * Encodes the specified Recording message, length delimited. Does not implicitly {@link recordings.Recording.verify|verify} messages.
         * @function encodeDelimited
         * @memberof recordings.Recording
         * @static
         * @param {recordings.IRecording} message Recording message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Recording.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Recording message from the specified reader or buffer.
         * @function decode
         * @memberof recordings.Recording
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {recordings.Recording} Recording
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Recording.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.recordings.Recording();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.id = reader.string();
                        break;
                    }
                case 2: {
                        message.title = reader.string();
                        break;
                    }
                case 3: {
                        message.dateCreated = $root.common.Date.decode(reader, reader.uint32());
                        break;
                    }
                case 4: {
                        message.thumbnailUrl = reader.string();
                        break;
                    }
                case 5: {
                        message.duration = reader.string();
                        break;
                    }
                case 6: {
                        message.description = reader.string();
                        break;
                    }
                case 7: {
                        if (!(message.participants && message.participants.length))
                            message.participants = [];
                        message.participants.push($root.recordings.RecordingParticipant.decode(reader, reader.uint32()));
                        break;
                    }
                case 8: {
                        message.isOwner = reader.bool();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Recording message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof recordings.Recording
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {recordings.Recording} Recording
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Recording.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Recording message.
         * @function verify
         * @memberof recordings.Recording
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Recording.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.title != null && message.hasOwnProperty("title"))
                if (!$util.isString(message.title))
                    return "title: string expected";
            if (message.dateCreated != null && message.hasOwnProperty("dateCreated")) {
                let error = $root.common.Date.verify(message.dateCreated);
                if (error)
                    return "dateCreated." + error;
            }
            if (message.thumbnailUrl != null && message.hasOwnProperty("thumbnailUrl"))
                if (!$util.isString(message.thumbnailUrl))
                    return "thumbnailUrl: string expected";
            if (message.duration != null && message.hasOwnProperty("duration"))
                if (!$util.isString(message.duration))
                    return "duration: string expected";
            if (message.description != null && message.hasOwnProperty("description"))
                if (!$util.isString(message.description))
                    return "description: string expected";
            if (message.participants != null && message.hasOwnProperty("participants")) {
                if (!Array.isArray(message.participants))
                    return "participants: array expected";
                for (let i = 0; i < message.participants.length; ++i) {
                    let error = $root.recordings.RecordingParticipant.verify(message.participants[i]);
                    if (error)
                        return "participants." + error;
                }
            }
            if (message.isOwner != null && message.hasOwnProperty("isOwner"))
                if (typeof message.isOwner !== "boolean")
                    return "isOwner: boolean expected";
            return null;
        };

        /**
         * Creates a Recording message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof recordings.Recording
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {recordings.Recording} Recording
         */
        Recording.fromObject = function fromObject(object) {
            if (object instanceof $root.recordings.Recording)
                return object;
            let message = new $root.recordings.Recording();
            if (object.id != null)
                message.id = String(object.id);
            if (object.title != null)
                message.title = String(object.title);
            if (object.dateCreated != null) {
                if (typeof object.dateCreated !== "object")
                    throw TypeError(".recordings.Recording.dateCreated: object expected");
                message.dateCreated = $root.common.Date.fromObject(object.dateCreated);
            }
            if (object.thumbnailUrl != null)
                message.thumbnailUrl = String(object.thumbnailUrl);
            if (object.duration != null)
                message.duration = String(object.duration);
            if (object.description != null)
                message.description = String(object.description);
            if (object.participants) {
                if (!Array.isArray(object.participants))
                    throw TypeError(".recordings.Recording.participants: array expected");
                message.participants = [];
                for (let i = 0; i < object.participants.length; ++i) {
                    if (typeof object.participants[i] !== "object")
                        throw TypeError(".recordings.Recording.participants: object expected");
                    message.participants[i] = $root.recordings.RecordingParticipant.fromObject(object.participants[i]);
                }
            }
            if (object.isOwner != null)
                message.isOwner = Boolean(object.isOwner);
            return message;
        };

        /**
         * Creates a plain object from a Recording message. Also converts values to other types if specified.
         * @function toObject
         * @memberof recordings.Recording
         * @static
         * @param {recordings.Recording} message Recording
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Recording.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.participants = [];
            if (options.defaults) {
                object.id = "";
                object.title = "";
                object.dateCreated = null;
                object.thumbnailUrl = "";
                object.duration = "";
                object.description = "";
                object.isOwner = false;
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.title != null && message.hasOwnProperty("title"))
                object.title = message.title;
            if (message.dateCreated != null && message.hasOwnProperty("dateCreated"))
                object.dateCreated = $root.common.Date.toObject(message.dateCreated, options);
            if (message.thumbnailUrl != null && message.hasOwnProperty("thumbnailUrl"))
                object.thumbnailUrl = message.thumbnailUrl;
            if (message.duration != null && message.hasOwnProperty("duration"))
                object.duration = message.duration;
            if (message.description != null && message.hasOwnProperty("description"))
                object.description = message.description;
            if (message.participants && message.participants.length) {
                object.participants = [];
                for (let j = 0; j < message.participants.length; ++j)
                    object.participants[j] = $root.recordings.RecordingParticipant.toObject(message.participants[j], options);
            }
            if (message.isOwner != null && message.hasOwnProperty("isOwner"))
                object.isOwner = message.isOwner;
            return object;
        };

        /**
         * Converts this Recording to JSON.
         * @function toJSON
         * @memberof recordings.Recording
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Recording.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Recording
         * @function getTypeUrl
         * @memberof recordings.Recording
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Recording.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/recordings.Recording";
        };

        return Recording;
    })();

    recordings.RecordingParticipant = (function() {

        /**
         * Properties of a RecordingParticipant.
         * @memberof recordings
         * @interface IRecordingParticipant
         * @property {string|null} [id] RecordingParticipant id
         * @property {string|null} [name] RecordingParticipant name
         * @property {recordings.RecordingParticipantRole|null} [role] RecordingParticipant role
         */

        /**
         * Constructs a new RecordingParticipant.
         * @memberof recordings
         * @classdesc Represents a RecordingParticipant.
         * @implements IRecordingParticipant
         * @constructor
         * @param {recordings.IRecordingParticipant=} [properties] Properties to set
         */
        function RecordingParticipant(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RecordingParticipant id.
         * @member {string} id
         * @memberof recordings.RecordingParticipant
         * @instance
         */
        RecordingParticipant.prototype.id = "";

        /**
         * RecordingParticipant name.
         * @member {string} name
         * @memberof recordings.RecordingParticipant
         * @instance
         */
        RecordingParticipant.prototype.name = "";

        /**
         * RecordingParticipant role.
         * @member {recordings.RecordingParticipantRole} role
         * @memberof recordings.RecordingParticipant
         * @instance
         */
        RecordingParticipant.prototype.role = 0;

        /**
         * Creates a new RecordingParticipant instance using the specified properties.
         * @function create
         * @memberof recordings.RecordingParticipant
         * @static
         * @param {recordings.IRecordingParticipant=} [properties] Properties to set
         * @returns {recordings.RecordingParticipant} RecordingParticipant instance
         */
        RecordingParticipant.create = function create(properties) {
            return new RecordingParticipant(properties);
        };

        /**
         * Encodes the specified RecordingParticipant message. Does not implicitly {@link recordings.RecordingParticipant.verify|verify} messages.
         * @function encode
         * @memberof recordings.RecordingParticipant
         * @static
         * @param {recordings.IRecordingParticipant} message RecordingParticipant message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RecordingParticipant.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
            if (message.role != null && Object.hasOwnProperty.call(message, "role"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.role);
            return writer;
        };

        /**
         * Encodes the specified RecordingParticipant message, length delimited. Does not implicitly {@link recordings.RecordingParticipant.verify|verify} messages.
         * @function encodeDelimited
         * @memberof recordings.RecordingParticipant
         * @static
         * @param {recordings.IRecordingParticipant} message RecordingParticipant message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RecordingParticipant.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RecordingParticipant message from the specified reader or buffer.
         * @function decode
         * @memberof recordings.RecordingParticipant
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {recordings.RecordingParticipant} RecordingParticipant
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RecordingParticipant.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.recordings.RecordingParticipant();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.id = reader.string();
                        break;
                    }
                case 2: {
                        message.name = reader.string();
                        break;
                    }
                case 3: {
                        message.role = reader.int32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RecordingParticipant message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof recordings.RecordingParticipant
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {recordings.RecordingParticipant} RecordingParticipant
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RecordingParticipant.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RecordingParticipant message.
         * @function verify
         * @memberof recordings.RecordingParticipant
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RecordingParticipant.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            if (message.role != null && message.hasOwnProperty("role"))
                switch (message.role) {
                default:
                    return "role: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                    break;
                }
            return null;
        };

        /**
         * Creates a RecordingParticipant message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof recordings.RecordingParticipant
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {recordings.RecordingParticipant} RecordingParticipant
         */
        RecordingParticipant.fromObject = function fromObject(object) {
            if (object instanceof $root.recordings.RecordingParticipant)
                return object;
            let message = new $root.recordings.RecordingParticipant();
            if (object.id != null)
                message.id = String(object.id);
            if (object.name != null)
                message.name = String(object.name);
            switch (object.role) {
            default:
                if (typeof object.role === "number") {
                    message.role = object.role;
                    break;
                }
                break;
            case "rpr_other":
            case 0:
                message.role = 0;
                break;
            case "rpr_instructor":
            case 1:
                message.role = 1;
                break;
            case "rpr_student":
            case 2:
                message.role = 2;
                break;
            case "rpr_supervisor":
            case 3:
                message.role = 3;
                break;
            }
            return message;
        };

        /**
         * Creates a plain object from a RecordingParticipant message. Also converts values to other types if specified.
         * @function toObject
         * @memberof recordings.RecordingParticipant
         * @static
         * @param {recordings.RecordingParticipant} message RecordingParticipant
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RecordingParticipant.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.id = "";
                object.name = "";
                object.role = options.enums === String ? "rpr_other" : 0;
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.role != null && message.hasOwnProperty("role"))
                object.role = options.enums === String ? $root.recordings.RecordingParticipantRole[message.role] === undefined ? message.role : $root.recordings.RecordingParticipantRole[message.role] : message.role;
            return object;
        };

        /**
         * Converts this RecordingParticipant to JSON.
         * @function toJSON
         * @memberof recordings.RecordingParticipant
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RecordingParticipant.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for RecordingParticipant
         * @function getTypeUrl
         * @memberof recordings.RecordingParticipant
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        RecordingParticipant.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/recordings.RecordingParticipant";
        };

        return RecordingParticipant;
    })();

    /**
     * RecordingParticipantRole enum.
     * @name recordings.RecordingParticipantRole
     * @enum {number}
     * @property {number} rpr_other=0 rpr_other value
     * @property {number} rpr_instructor=1 rpr_instructor value
     * @property {number} rpr_student=2 rpr_student value
     * @property {number} rpr_supervisor=3 rpr_supervisor value
     */
    recordings.RecordingParticipantRole = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "rpr_other"] = 0;
        values[valuesById[1] = "rpr_instructor"] = 1;
        values[valuesById[2] = "rpr_student"] = 2;
        values[valuesById[3] = "rpr_supervisor"] = 3;
        return values;
    })();

    /**
     * RecordingListScope enum.
     * @name recordings.RecordingListScope
     * @enum {number}
     * @property {number} rls_unknown=0 rls_unknown value
     * @property {number} rls_my=1 rls_my value
     * @property {number} rls_organization=2 rls_organization value
     */
    recordings.RecordingListScope = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "rls_unknown"] = 0;
        values[valuesById[1] = "rls_my"] = 1;
        values[valuesById[2] = "rls_organization"] = 2;
        return values;
    })();

    return recordings;
})();

export const metka_platform = $root.metka_platform = (() => {

    /**
     * Namespace metka_platform.
     * @exports metka_platform
     * @namespace
     */
    const metka_platform = {};

    return metka_platform;
})();

export const authentication = $root.authentication = (() => {

    /**
     * Namespace authentication.
     * @exports authentication
     * @namespace
     */
    const authentication = {};

    authentication.LoginToken = (function() {

        /**
         * Properties of a LoginToken.
         * @memberof authentication
         * @interface ILoginToken
         * @property {string|null} [token] LoginToken token
         * @property {string|null} [refresh] LoginToken refresh
         */

        /**
         * Constructs a new LoginToken.
         * @memberof authentication
         * @classdesc Represents a LoginToken.
         * @implements ILoginToken
         * @constructor
         * @param {authentication.ILoginToken=} [properties] Properties to set
         */
        function LoginToken(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * LoginToken token.
         * @member {string} token
         * @memberof authentication.LoginToken
         * @instance
         */
        LoginToken.prototype.token = "";

        /**
         * LoginToken refresh.
         * @member {string} refresh
         * @memberof authentication.LoginToken
         * @instance
         */
        LoginToken.prototype.refresh = "";

        /**
         * Creates a new LoginToken instance using the specified properties.
         * @function create
         * @memberof authentication.LoginToken
         * @static
         * @param {authentication.ILoginToken=} [properties] Properties to set
         * @returns {authentication.LoginToken} LoginToken instance
         */
        LoginToken.create = function create(properties) {
            return new LoginToken(properties);
        };

        /**
         * Encodes the specified LoginToken message. Does not implicitly {@link authentication.LoginToken.verify|verify} messages.
         * @function encode
         * @memberof authentication.LoginToken
         * @static
         * @param {authentication.ILoginToken} message LoginToken message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        LoginToken.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.token != null && Object.hasOwnProperty.call(message, "token"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.token);
            if (message.refresh != null && Object.hasOwnProperty.call(message, "refresh"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.refresh);
            return writer;
        };

        /**
         * Encodes the specified LoginToken message, length delimited. Does not implicitly {@link authentication.LoginToken.verify|verify} messages.
         * @function encodeDelimited
         * @memberof authentication.LoginToken
         * @static
         * @param {authentication.ILoginToken} message LoginToken message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        LoginToken.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a LoginToken message from the specified reader or buffer.
         * @function decode
         * @memberof authentication.LoginToken
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {authentication.LoginToken} LoginToken
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        LoginToken.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.authentication.LoginToken();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.token = reader.string();
                        break;
                    }
                case 2: {
                        message.refresh = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a LoginToken message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof authentication.LoginToken
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {authentication.LoginToken} LoginToken
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        LoginToken.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a LoginToken message.
         * @function verify
         * @memberof authentication.LoginToken
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        LoginToken.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.token != null && message.hasOwnProperty("token"))
                if (!$util.isString(message.token))
                    return "token: string expected";
            if (message.refresh != null && message.hasOwnProperty("refresh"))
                if (!$util.isString(message.refresh))
                    return "refresh: string expected";
            return null;
        };

        /**
         * Creates a LoginToken message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof authentication.LoginToken
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {authentication.LoginToken} LoginToken
         */
        LoginToken.fromObject = function fromObject(object) {
            if (object instanceof $root.authentication.LoginToken)
                return object;
            let message = new $root.authentication.LoginToken();
            if (object.token != null)
                message.token = String(object.token);
            if (object.refresh != null)
                message.refresh = String(object.refresh);
            return message;
        };

        /**
         * Creates a plain object from a LoginToken message. Also converts values to other types if specified.
         * @function toObject
         * @memberof authentication.LoginToken
         * @static
         * @param {authentication.LoginToken} message LoginToken
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        LoginToken.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.token = "";
                object.refresh = "";
            }
            if (message.token != null && message.hasOwnProperty("token"))
                object.token = message.token;
            if (message.refresh != null && message.hasOwnProperty("refresh"))
                object.refresh = message.refresh;
            return object;
        };

        /**
         * Converts this LoginToken to JSON.
         * @function toJSON
         * @memberof authentication.LoginToken
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        LoginToken.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for LoginToken
         * @function getTypeUrl
         * @memberof authentication.LoginToken
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        LoginToken.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/authentication.LoginToken";
        };

        return LoginToken;
    })();

    authentication.LoginError = (function() {

        /**
         * Properties of a LoginError.
         * @memberof authentication
         * @interface ILoginError
         * @property {string|null} [errorText] LoginError errorText
         * @property {string|null} [errorCode] LoginError errorCode
         */

        /**
         * Constructs a new LoginError.
         * @memberof authentication
         * @classdesc Represents a LoginError.
         * @implements ILoginError
         * @constructor
         * @param {authentication.ILoginError=} [properties] Properties to set
         */
        function LoginError(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * LoginError errorText.
         * @member {string} errorText
         * @memberof authentication.LoginError
         * @instance
         */
        LoginError.prototype.errorText = "";

        /**
         * LoginError errorCode.
         * @member {string} errorCode
         * @memberof authentication.LoginError
         * @instance
         */
        LoginError.prototype.errorCode = "";

        /**
         * Creates a new LoginError instance using the specified properties.
         * @function create
         * @memberof authentication.LoginError
         * @static
         * @param {authentication.ILoginError=} [properties] Properties to set
         * @returns {authentication.LoginError} LoginError instance
         */
        LoginError.create = function create(properties) {
            return new LoginError(properties);
        };

        /**
         * Encodes the specified LoginError message. Does not implicitly {@link authentication.LoginError.verify|verify} messages.
         * @function encode
         * @memberof authentication.LoginError
         * @static
         * @param {authentication.ILoginError} message LoginError message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        LoginError.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.errorText != null && Object.hasOwnProperty.call(message, "errorText"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.errorText);
            if (message.errorCode != null && Object.hasOwnProperty.call(message, "errorCode"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.errorCode);
            return writer;
        };

        /**
         * Encodes the specified LoginError message, length delimited. Does not implicitly {@link authentication.LoginError.verify|verify} messages.
         * @function encodeDelimited
         * @memberof authentication.LoginError
         * @static
         * @param {authentication.ILoginError} message LoginError message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        LoginError.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a LoginError message from the specified reader or buffer.
         * @function decode
         * @memberof authentication.LoginError
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {authentication.LoginError} LoginError
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        LoginError.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.authentication.LoginError();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.errorText = reader.string();
                        break;
                    }
                case 2: {
                        message.errorCode = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a LoginError message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof authentication.LoginError
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {authentication.LoginError} LoginError
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        LoginError.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a LoginError message.
         * @function verify
         * @memberof authentication.LoginError
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        LoginError.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.errorText != null && message.hasOwnProperty("errorText"))
                if (!$util.isString(message.errorText))
                    return "errorText: string expected";
            if (message.errorCode != null && message.hasOwnProperty("errorCode"))
                if (!$util.isString(message.errorCode))
                    return "errorCode: string expected";
            return null;
        };

        /**
         * Creates a LoginError message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof authentication.LoginError
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {authentication.LoginError} LoginError
         */
        LoginError.fromObject = function fromObject(object) {
            if (object instanceof $root.authentication.LoginError)
                return object;
            let message = new $root.authentication.LoginError();
            if (object.errorText != null)
                message.errorText = String(object.errorText);
            if (object.errorCode != null)
                message.errorCode = String(object.errorCode);
            return message;
        };

        /**
         * Creates a plain object from a LoginError message. Also converts values to other types if specified.
         * @function toObject
         * @memberof authentication.LoginError
         * @static
         * @param {authentication.LoginError} message LoginError
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        LoginError.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.errorText = "";
                object.errorCode = "";
            }
            if (message.errorText != null && message.hasOwnProperty("errorText"))
                object.errorText = message.errorText;
            if (message.errorCode != null && message.hasOwnProperty("errorCode"))
                object.errorCode = message.errorCode;
            return object;
        };

        /**
         * Converts this LoginError to JSON.
         * @function toJSON
         * @memberof authentication.LoginError
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        LoginError.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for LoginError
         * @function getTypeUrl
         * @memberof authentication.LoginError
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        LoginError.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/authentication.LoginError";
        };

        return LoginError;
    })();

    authentication.Login = (function() {

        /**
         * Properties of a Login.
         * @memberof authentication
         * @interface ILogin
         * @property {string|null} [username] Login username
         * @property {string|null} [password] Login password
         */

        /**
         * Constructs a new Login.
         * @memberof authentication
         * @classdesc Represents a Login.
         * @implements ILogin
         * @constructor
         * @param {authentication.ILogin=} [properties] Properties to set
         */
        function Login(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Login username.
         * @member {string} username
         * @memberof authentication.Login
         * @instance
         */
        Login.prototype.username = "";

        /**
         * Login password.
         * @member {string} password
         * @memberof authentication.Login
         * @instance
         */
        Login.prototype.password = "";

        /**
         * Creates a new Login instance using the specified properties.
         * @function create
         * @memberof authentication.Login
         * @static
         * @param {authentication.ILogin=} [properties] Properties to set
         * @returns {authentication.Login} Login instance
         */
        Login.create = function create(properties) {
            return new Login(properties);
        };

        /**
         * Encodes the specified Login message. Does not implicitly {@link authentication.Login.verify|verify} messages.
         * @function encode
         * @memberof authentication.Login
         * @static
         * @param {authentication.ILogin} message Login message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Login.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.username != null && Object.hasOwnProperty.call(message, "username"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.username);
            if (message.password != null && Object.hasOwnProperty.call(message, "password"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.password);
            return writer;
        };

        /**
         * Encodes the specified Login message, length delimited. Does not implicitly {@link authentication.Login.verify|verify} messages.
         * @function encodeDelimited
         * @memberof authentication.Login
         * @static
         * @param {authentication.ILogin} message Login message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Login.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Login message from the specified reader or buffer.
         * @function decode
         * @memberof authentication.Login
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {authentication.Login} Login
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Login.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.authentication.Login();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.username = reader.string();
                        break;
                    }
                case 2: {
                        message.password = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Login message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof authentication.Login
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {authentication.Login} Login
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Login.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Login message.
         * @function verify
         * @memberof authentication.Login
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Login.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.username != null && message.hasOwnProperty("username"))
                if (!$util.isString(message.username))
                    return "username: string expected";
            if (message.password != null && message.hasOwnProperty("password"))
                if (!$util.isString(message.password))
                    return "password: string expected";
            return null;
        };

        /**
         * Creates a Login message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof authentication.Login
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {authentication.Login} Login
         */
        Login.fromObject = function fromObject(object) {
            if (object instanceof $root.authentication.Login)
                return object;
            let message = new $root.authentication.Login();
            if (object.username != null)
                message.username = String(object.username);
            if (object.password != null)
                message.password = String(object.password);
            return message;
        };

        /**
         * Creates a plain object from a Login message. Also converts values to other types if specified.
         * @function toObject
         * @memberof authentication.Login
         * @static
         * @param {authentication.Login} message Login
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Login.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.username = "";
                object.password = "";
            }
            if (message.username != null && message.hasOwnProperty("username"))
                object.username = message.username;
            if (message.password != null && message.hasOwnProperty("password"))
                object.password = message.password;
            return object;
        };

        /**
         * Converts this Login to JSON.
         * @function toJSON
         * @memberof authentication.Login
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Login.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Login
         * @function getTypeUrl
         * @memberof authentication.Login
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Login.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/authentication.Login";
        };

        return Login;
    })();

    authentication.RefreshToken = (function() {

        /**
         * Properties of a RefreshToken.
         * @memberof authentication
         * @interface IRefreshToken
         * @property {string|null} [refreshToken] RefreshToken refreshToken
         */

        /**
         * Constructs a new RefreshToken.
         * @memberof authentication
         * @classdesc Represents a RefreshToken.
         * @implements IRefreshToken
         * @constructor
         * @param {authentication.IRefreshToken=} [properties] Properties to set
         */
        function RefreshToken(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RefreshToken refreshToken.
         * @member {string} refreshToken
         * @memberof authentication.RefreshToken
         * @instance
         */
        RefreshToken.prototype.refreshToken = "";

        /**
         * Creates a new RefreshToken instance using the specified properties.
         * @function create
         * @memberof authentication.RefreshToken
         * @static
         * @param {authentication.IRefreshToken=} [properties] Properties to set
         * @returns {authentication.RefreshToken} RefreshToken instance
         */
        RefreshToken.create = function create(properties) {
            return new RefreshToken(properties);
        };

        /**
         * Encodes the specified RefreshToken message. Does not implicitly {@link authentication.RefreshToken.verify|verify} messages.
         * @function encode
         * @memberof authentication.RefreshToken
         * @static
         * @param {authentication.IRefreshToken} message RefreshToken message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RefreshToken.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.refreshToken != null && Object.hasOwnProperty.call(message, "refreshToken"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.refreshToken);
            return writer;
        };

        /**
         * Encodes the specified RefreshToken message, length delimited. Does not implicitly {@link authentication.RefreshToken.verify|verify} messages.
         * @function encodeDelimited
         * @memberof authentication.RefreshToken
         * @static
         * @param {authentication.IRefreshToken} message RefreshToken message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RefreshToken.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RefreshToken message from the specified reader or buffer.
         * @function decode
         * @memberof authentication.RefreshToken
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {authentication.RefreshToken} RefreshToken
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RefreshToken.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.authentication.RefreshToken();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.refreshToken = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RefreshToken message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof authentication.RefreshToken
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {authentication.RefreshToken} RefreshToken
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RefreshToken.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RefreshToken message.
         * @function verify
         * @memberof authentication.RefreshToken
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RefreshToken.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.refreshToken != null && message.hasOwnProperty("refreshToken"))
                if (!$util.isString(message.refreshToken))
                    return "refreshToken: string expected";
            return null;
        };

        /**
         * Creates a RefreshToken message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof authentication.RefreshToken
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {authentication.RefreshToken} RefreshToken
         */
        RefreshToken.fromObject = function fromObject(object) {
            if (object instanceof $root.authentication.RefreshToken)
                return object;
            let message = new $root.authentication.RefreshToken();
            if (object.refreshToken != null)
                message.refreshToken = String(object.refreshToken);
            return message;
        };

        /**
         * Creates a plain object from a RefreshToken message. Also converts values to other types if specified.
         * @function toObject
         * @memberof authentication.RefreshToken
         * @static
         * @param {authentication.RefreshToken} message RefreshToken
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RefreshToken.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.refreshToken = "";
            if (message.refreshToken != null && message.hasOwnProperty("refreshToken"))
                object.refreshToken = message.refreshToken;
            return object;
        };

        /**
         * Converts this RefreshToken to JSON.
         * @function toJSON
         * @memberof authentication.RefreshToken
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RefreshToken.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for RefreshToken
         * @function getTypeUrl
         * @memberof authentication.RefreshToken
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        RefreshToken.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/authentication.RefreshToken";
        };

        return RefreshToken;
    })();

    authentication.VerifyToken = (function() {

        /**
         * Properties of a VerifyToken.
         * @memberof authentication
         * @interface IVerifyToken
         */

        /**
         * Constructs a new VerifyToken.
         * @memberof authentication
         * @classdesc Represents a VerifyToken.
         * @implements IVerifyToken
         * @constructor
         * @param {authentication.IVerifyToken=} [properties] Properties to set
         */
        function VerifyToken(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new VerifyToken instance using the specified properties.
         * @function create
         * @memberof authentication.VerifyToken
         * @static
         * @param {authentication.IVerifyToken=} [properties] Properties to set
         * @returns {authentication.VerifyToken} VerifyToken instance
         */
        VerifyToken.create = function create(properties) {
            return new VerifyToken(properties);
        };

        /**
         * Encodes the specified VerifyToken message. Does not implicitly {@link authentication.VerifyToken.verify|verify} messages.
         * @function encode
         * @memberof authentication.VerifyToken
         * @static
         * @param {authentication.IVerifyToken} message VerifyToken message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        VerifyToken.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified VerifyToken message, length delimited. Does not implicitly {@link authentication.VerifyToken.verify|verify} messages.
         * @function encodeDelimited
         * @memberof authentication.VerifyToken
         * @static
         * @param {authentication.IVerifyToken} message VerifyToken message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        VerifyToken.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a VerifyToken message from the specified reader or buffer.
         * @function decode
         * @memberof authentication.VerifyToken
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {authentication.VerifyToken} VerifyToken
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        VerifyToken.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.authentication.VerifyToken();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a VerifyToken message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof authentication.VerifyToken
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {authentication.VerifyToken} VerifyToken
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        VerifyToken.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a VerifyToken message.
         * @function verify
         * @memberof authentication.VerifyToken
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        VerifyToken.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a VerifyToken message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof authentication.VerifyToken
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {authentication.VerifyToken} VerifyToken
         */
        VerifyToken.fromObject = function fromObject(object) {
            if (object instanceof $root.authentication.VerifyToken)
                return object;
            return new $root.authentication.VerifyToken();
        };

        /**
         * Creates a plain object from a VerifyToken message. Also converts values to other types if specified.
         * @function toObject
         * @memberof authentication.VerifyToken
         * @static
         * @param {authentication.VerifyToken} message VerifyToken
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        VerifyToken.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this VerifyToken to JSON.
         * @function toJSON
         * @memberof authentication.VerifyToken
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        VerifyToken.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for VerifyToken
         * @function getTypeUrl
         * @memberof authentication.VerifyToken
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        VerifyToken.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/authentication.VerifyToken";
        };

        return VerifyToken;
    })();

    authentication.TokenInvalid = (function() {

        /**
         * Properties of a TokenInvalid.
         * @memberof authentication
         * @interface ITokenInvalid
         */

        /**
         * Constructs a new TokenInvalid.
         * @memberof authentication
         * @classdesc Represents a TokenInvalid.
         * @implements ITokenInvalid
         * @constructor
         * @param {authentication.ITokenInvalid=} [properties] Properties to set
         */
        function TokenInvalid(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new TokenInvalid instance using the specified properties.
         * @function create
         * @memberof authentication.TokenInvalid
         * @static
         * @param {authentication.ITokenInvalid=} [properties] Properties to set
         * @returns {authentication.TokenInvalid} TokenInvalid instance
         */
        TokenInvalid.create = function create(properties) {
            return new TokenInvalid(properties);
        };

        /**
         * Encodes the specified TokenInvalid message. Does not implicitly {@link authentication.TokenInvalid.verify|verify} messages.
         * @function encode
         * @memberof authentication.TokenInvalid
         * @static
         * @param {authentication.ITokenInvalid} message TokenInvalid message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TokenInvalid.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified TokenInvalid message, length delimited. Does not implicitly {@link authentication.TokenInvalid.verify|verify} messages.
         * @function encodeDelimited
         * @memberof authentication.TokenInvalid
         * @static
         * @param {authentication.ITokenInvalid} message TokenInvalid message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TokenInvalid.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a TokenInvalid message from the specified reader or buffer.
         * @function decode
         * @memberof authentication.TokenInvalid
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {authentication.TokenInvalid} TokenInvalid
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TokenInvalid.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.authentication.TokenInvalid();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a TokenInvalid message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof authentication.TokenInvalid
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {authentication.TokenInvalid} TokenInvalid
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TokenInvalid.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a TokenInvalid message.
         * @function verify
         * @memberof authentication.TokenInvalid
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        TokenInvalid.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a TokenInvalid message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof authentication.TokenInvalid
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {authentication.TokenInvalid} TokenInvalid
         */
        TokenInvalid.fromObject = function fromObject(object) {
            if (object instanceof $root.authentication.TokenInvalid)
                return object;
            return new $root.authentication.TokenInvalid();
        };

        /**
         * Creates a plain object from a TokenInvalid message. Also converts values to other types if specified.
         * @function toObject
         * @memberof authentication.TokenInvalid
         * @static
         * @param {authentication.TokenInvalid} message TokenInvalid
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        TokenInvalid.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this TokenInvalid to JSON.
         * @function toJSON
         * @memberof authentication.TokenInvalid
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        TokenInvalid.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for TokenInvalid
         * @function getTypeUrl
         * @memberof authentication.TokenInvalid
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        TokenInvalid.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/authentication.TokenInvalid";
        };

        return TokenInvalid;
    })();

    authentication.RefreshTokenInvalid = (function() {

        /**
         * Properties of a RefreshTokenInvalid.
         * @memberof authentication
         * @interface IRefreshTokenInvalid
         */

        /**
         * Constructs a new RefreshTokenInvalid.
         * @memberof authentication
         * @classdesc Represents a RefreshTokenInvalid.
         * @implements IRefreshTokenInvalid
         * @constructor
         * @param {authentication.IRefreshTokenInvalid=} [properties] Properties to set
         */
        function RefreshTokenInvalid(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new RefreshTokenInvalid instance using the specified properties.
         * @function create
         * @memberof authentication.RefreshTokenInvalid
         * @static
         * @param {authentication.IRefreshTokenInvalid=} [properties] Properties to set
         * @returns {authentication.RefreshTokenInvalid} RefreshTokenInvalid instance
         */
        RefreshTokenInvalid.create = function create(properties) {
            return new RefreshTokenInvalid(properties);
        };

        /**
         * Encodes the specified RefreshTokenInvalid message. Does not implicitly {@link authentication.RefreshTokenInvalid.verify|verify} messages.
         * @function encode
         * @memberof authentication.RefreshTokenInvalid
         * @static
         * @param {authentication.IRefreshTokenInvalid} message RefreshTokenInvalid message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RefreshTokenInvalid.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified RefreshTokenInvalid message, length delimited. Does not implicitly {@link authentication.RefreshTokenInvalid.verify|verify} messages.
         * @function encodeDelimited
         * @memberof authentication.RefreshTokenInvalid
         * @static
         * @param {authentication.IRefreshTokenInvalid} message RefreshTokenInvalid message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RefreshTokenInvalid.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RefreshTokenInvalid message from the specified reader or buffer.
         * @function decode
         * @memberof authentication.RefreshTokenInvalid
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {authentication.RefreshTokenInvalid} RefreshTokenInvalid
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RefreshTokenInvalid.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.authentication.RefreshTokenInvalid();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RefreshTokenInvalid message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof authentication.RefreshTokenInvalid
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {authentication.RefreshTokenInvalid} RefreshTokenInvalid
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RefreshTokenInvalid.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RefreshTokenInvalid message.
         * @function verify
         * @memberof authentication.RefreshTokenInvalid
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RefreshTokenInvalid.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a RefreshTokenInvalid message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof authentication.RefreshTokenInvalid
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {authentication.RefreshTokenInvalid} RefreshTokenInvalid
         */
        RefreshTokenInvalid.fromObject = function fromObject(object) {
            if (object instanceof $root.authentication.RefreshTokenInvalid)
                return object;
            return new $root.authentication.RefreshTokenInvalid();
        };

        /**
         * Creates a plain object from a RefreshTokenInvalid message. Also converts values to other types if specified.
         * @function toObject
         * @memberof authentication.RefreshTokenInvalid
         * @static
         * @param {authentication.RefreshTokenInvalid} message RefreshTokenInvalid
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RefreshTokenInvalid.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this RefreshTokenInvalid to JSON.
         * @function toJSON
         * @memberof authentication.RefreshTokenInvalid
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RefreshTokenInvalid.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for RefreshTokenInvalid
         * @function getTypeUrl
         * @memberof authentication.RefreshTokenInvalid
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        RefreshTokenInvalid.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/authentication.RefreshTokenInvalid";
        };

        return RefreshTokenInvalid;
    })();

    return authentication;
})();

export const sfiles = $root.sfiles = (() => {

    /**
     * Namespace sfiles.
     * @exports sfiles
     * @namespace
     */
    const sfiles = {};

    sfiles.UploadStartSlot = (function() {

        /**
         * Properties of an UploadStartSlot.
         * @memberof sfiles
         * @interface IUploadStartSlot
         * @property {string|null} [key] UploadStartSlot key
         * @property {string|null} [localKey] UploadStartSlot localKey
         */

        /**
         * Constructs a new UploadStartSlot.
         * @memberof sfiles
         * @classdesc Represents an UploadStartSlot.
         * @implements IUploadStartSlot
         * @constructor
         * @param {sfiles.IUploadStartSlot=} [properties] Properties to set
         */
        function UploadStartSlot(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UploadStartSlot key.
         * @member {string} key
         * @memberof sfiles.UploadStartSlot
         * @instance
         */
        UploadStartSlot.prototype.key = "";

        /**
         * UploadStartSlot localKey.
         * @member {string} localKey
         * @memberof sfiles.UploadStartSlot
         * @instance
         */
        UploadStartSlot.prototype.localKey = "";

        /**
         * Creates a new UploadStartSlot instance using the specified properties.
         * @function create
         * @memberof sfiles.UploadStartSlot
         * @static
         * @param {sfiles.IUploadStartSlot=} [properties] Properties to set
         * @returns {sfiles.UploadStartSlot} UploadStartSlot instance
         */
        UploadStartSlot.create = function create(properties) {
            return new UploadStartSlot(properties);
        };

        /**
         * Encodes the specified UploadStartSlot message. Does not implicitly {@link sfiles.UploadStartSlot.verify|verify} messages.
         * @function encode
         * @memberof sfiles.UploadStartSlot
         * @static
         * @param {sfiles.IUploadStartSlot} message UploadStartSlot message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UploadStartSlot.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.key != null && Object.hasOwnProperty.call(message, "key"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.key);
            if (message.localKey != null && Object.hasOwnProperty.call(message, "localKey"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.localKey);
            return writer;
        };

        /**
         * Encodes the specified UploadStartSlot message, length delimited. Does not implicitly {@link sfiles.UploadStartSlot.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sfiles.UploadStartSlot
         * @static
         * @param {sfiles.IUploadStartSlot} message UploadStartSlot message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UploadStartSlot.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an UploadStartSlot message from the specified reader or buffer.
         * @function decode
         * @memberof sfiles.UploadStartSlot
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sfiles.UploadStartSlot} UploadStartSlot
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UploadStartSlot.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sfiles.UploadStartSlot();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.key = reader.string();
                        break;
                    }
                case 2: {
                        message.localKey = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an UploadStartSlot message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sfiles.UploadStartSlot
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sfiles.UploadStartSlot} UploadStartSlot
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UploadStartSlot.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an UploadStartSlot message.
         * @function verify
         * @memberof sfiles.UploadStartSlot
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UploadStartSlot.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.key != null && message.hasOwnProperty("key"))
                if (!$util.isString(message.key))
                    return "key: string expected";
            if (message.localKey != null && message.hasOwnProperty("localKey"))
                if (!$util.isString(message.localKey))
                    return "localKey: string expected";
            return null;
        };

        /**
         * Creates an UploadStartSlot message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sfiles.UploadStartSlot
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sfiles.UploadStartSlot} UploadStartSlot
         */
        UploadStartSlot.fromObject = function fromObject(object) {
            if (object instanceof $root.sfiles.UploadStartSlot)
                return object;
            let message = new $root.sfiles.UploadStartSlot();
            if (object.key != null)
                message.key = String(object.key);
            if (object.localKey != null)
                message.localKey = String(object.localKey);
            return message;
        };

        /**
         * Creates a plain object from an UploadStartSlot message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sfiles.UploadStartSlot
         * @static
         * @param {sfiles.UploadStartSlot} message UploadStartSlot
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UploadStartSlot.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.key = "";
                object.localKey = "";
            }
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.localKey != null && message.hasOwnProperty("localKey"))
                object.localKey = message.localKey;
            return object;
        };

        /**
         * Converts this UploadStartSlot to JSON.
         * @function toJSON
         * @memberof sfiles.UploadStartSlot
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UploadStartSlot.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for UploadStartSlot
         * @function getTypeUrl
         * @memberof sfiles.UploadStartSlot
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        UploadStartSlot.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/sfiles.UploadStartSlot";
        };

        return UploadStartSlot;
    })();

    sfiles.UploadProgress = (function() {

        /**
         * Properties of an UploadProgress.
         * @memberof sfiles
         * @interface IUploadProgress
         * @property {number|Long|null} [nBytes] UploadProgress nBytes
         * @property {string|null} [key] UploadProgress key
         * @property {string|null} [localKey] UploadProgress localKey
         */

        /**
         * Constructs a new UploadProgress.
         * @memberof sfiles
         * @classdesc Represents an UploadProgress.
         * @implements IUploadProgress
         * @constructor
         * @param {sfiles.IUploadProgress=} [properties] Properties to set
         */
        function UploadProgress(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UploadProgress nBytes.
         * @member {number|Long} nBytes
         * @memberof sfiles.UploadProgress
         * @instance
         */
        UploadProgress.prototype.nBytes = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * UploadProgress key.
         * @member {string} key
         * @memberof sfiles.UploadProgress
         * @instance
         */
        UploadProgress.prototype.key = "";

        /**
         * UploadProgress localKey.
         * @member {string} localKey
         * @memberof sfiles.UploadProgress
         * @instance
         */
        UploadProgress.prototype.localKey = "";

        /**
         * Creates a new UploadProgress instance using the specified properties.
         * @function create
         * @memberof sfiles.UploadProgress
         * @static
         * @param {sfiles.IUploadProgress=} [properties] Properties to set
         * @returns {sfiles.UploadProgress} UploadProgress instance
         */
        UploadProgress.create = function create(properties) {
            return new UploadProgress(properties);
        };

        /**
         * Encodes the specified UploadProgress message. Does not implicitly {@link sfiles.UploadProgress.verify|verify} messages.
         * @function encode
         * @memberof sfiles.UploadProgress
         * @static
         * @param {sfiles.IUploadProgress} message UploadProgress message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UploadProgress.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.nBytes != null && Object.hasOwnProperty.call(message, "nBytes"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.nBytes);
            if (message.key != null && Object.hasOwnProperty.call(message, "key"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.key);
            if (message.localKey != null && Object.hasOwnProperty.call(message, "localKey"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.localKey);
            return writer;
        };

        /**
         * Encodes the specified UploadProgress message, length delimited. Does not implicitly {@link sfiles.UploadProgress.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sfiles.UploadProgress
         * @static
         * @param {sfiles.IUploadProgress} message UploadProgress message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UploadProgress.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an UploadProgress message from the specified reader or buffer.
         * @function decode
         * @memberof sfiles.UploadProgress
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sfiles.UploadProgress} UploadProgress
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UploadProgress.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sfiles.UploadProgress();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.nBytes = reader.int64();
                        break;
                    }
                case 2: {
                        message.key = reader.string();
                        break;
                    }
                case 3: {
                        message.localKey = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an UploadProgress message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sfiles.UploadProgress
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sfiles.UploadProgress} UploadProgress
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UploadProgress.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an UploadProgress message.
         * @function verify
         * @memberof sfiles.UploadProgress
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UploadProgress.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.nBytes != null && message.hasOwnProperty("nBytes"))
                if (!$util.isInteger(message.nBytes) && !(message.nBytes && $util.isInteger(message.nBytes.low) && $util.isInteger(message.nBytes.high)))
                    return "nBytes: integer|Long expected";
            if (message.key != null && message.hasOwnProperty("key"))
                if (!$util.isString(message.key))
                    return "key: string expected";
            if (message.localKey != null && message.hasOwnProperty("localKey"))
                if (!$util.isString(message.localKey))
                    return "localKey: string expected";
            return null;
        };

        /**
         * Creates an UploadProgress message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sfiles.UploadProgress
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sfiles.UploadProgress} UploadProgress
         */
        UploadProgress.fromObject = function fromObject(object) {
            if (object instanceof $root.sfiles.UploadProgress)
                return object;
            let message = new $root.sfiles.UploadProgress();
            if (object.nBytes != null)
                if ($util.Long)
                    (message.nBytes = $util.Long.fromValue(object.nBytes)).unsigned = false;
                else if (typeof object.nBytes === "string")
                    message.nBytes = parseInt(object.nBytes, 10);
                else if (typeof object.nBytes === "number")
                    message.nBytes = object.nBytes;
                else if (typeof object.nBytes === "object")
                    message.nBytes = new $util.LongBits(object.nBytes.low >>> 0, object.nBytes.high >>> 0).toNumber();
            if (object.key != null)
                message.key = String(object.key);
            if (object.localKey != null)
                message.localKey = String(object.localKey);
            return message;
        };

        /**
         * Creates a plain object from an UploadProgress message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sfiles.UploadProgress
         * @static
         * @param {sfiles.UploadProgress} message UploadProgress
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UploadProgress.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.nBytes = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.nBytes = options.longs === String ? "0" : 0;
                object.key = "";
                object.localKey = "";
            }
            if (message.nBytes != null && message.hasOwnProperty("nBytes"))
                if (typeof message.nBytes === "number")
                    object.nBytes = options.longs === String ? String(message.nBytes) : message.nBytes;
                else
                    object.nBytes = options.longs === String ? $util.Long.prototype.toString.call(message.nBytes) : options.longs === Number ? new $util.LongBits(message.nBytes.low >>> 0, message.nBytes.high >>> 0).toNumber() : message.nBytes;
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.localKey != null && message.hasOwnProperty("localKey"))
                object.localKey = message.localKey;
            return object;
        };

        /**
         * Converts this UploadProgress to JSON.
         * @function toJSON
         * @memberof sfiles.UploadProgress
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UploadProgress.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for UploadProgress
         * @function getTypeUrl
         * @memberof sfiles.UploadProgress
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        UploadProgress.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/sfiles.UploadProgress";
        };

        return UploadProgress;
    })();

    sfiles.UploadDone = (function() {

        /**
         * Properties of an UploadDone.
         * @memberof sfiles
         * @interface IUploadDone
         * @property {string|null} [key] UploadDone key
         * @property {sfiles.IUploadedFile|null} [file] UploadDone file
         */

        /**
         * Constructs a new UploadDone.
         * @memberof sfiles
         * @classdesc Represents an UploadDone.
         * @implements IUploadDone
         * @constructor
         * @param {sfiles.IUploadDone=} [properties] Properties to set
         */
        function UploadDone(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UploadDone key.
         * @member {string} key
         * @memberof sfiles.UploadDone
         * @instance
         */
        UploadDone.prototype.key = "";

        /**
         * UploadDone file.
         * @member {sfiles.IUploadedFile|null|undefined} file
         * @memberof sfiles.UploadDone
         * @instance
         */
        UploadDone.prototype.file = null;

        /**
         * Creates a new UploadDone instance using the specified properties.
         * @function create
         * @memberof sfiles.UploadDone
         * @static
         * @param {sfiles.IUploadDone=} [properties] Properties to set
         * @returns {sfiles.UploadDone} UploadDone instance
         */
        UploadDone.create = function create(properties) {
            return new UploadDone(properties);
        };

        /**
         * Encodes the specified UploadDone message. Does not implicitly {@link sfiles.UploadDone.verify|verify} messages.
         * @function encode
         * @memberof sfiles.UploadDone
         * @static
         * @param {sfiles.IUploadDone} message UploadDone message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UploadDone.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.key != null && Object.hasOwnProperty.call(message, "key"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.key);
            if (message.file != null && Object.hasOwnProperty.call(message, "file"))
                $root.sfiles.UploadedFile.encode(message.file, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified UploadDone message, length delimited. Does not implicitly {@link sfiles.UploadDone.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sfiles.UploadDone
         * @static
         * @param {sfiles.IUploadDone} message UploadDone message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UploadDone.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an UploadDone message from the specified reader or buffer.
         * @function decode
         * @memberof sfiles.UploadDone
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sfiles.UploadDone} UploadDone
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UploadDone.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sfiles.UploadDone();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.key = reader.string();
                        break;
                    }
                case 2: {
                        message.file = $root.sfiles.UploadedFile.decode(reader, reader.uint32());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an UploadDone message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sfiles.UploadDone
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sfiles.UploadDone} UploadDone
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UploadDone.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an UploadDone message.
         * @function verify
         * @memberof sfiles.UploadDone
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UploadDone.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.key != null && message.hasOwnProperty("key"))
                if (!$util.isString(message.key))
                    return "key: string expected";
            if (message.file != null && message.hasOwnProperty("file")) {
                let error = $root.sfiles.UploadedFile.verify(message.file);
                if (error)
                    return "file." + error;
            }
            return null;
        };

        /**
         * Creates an UploadDone message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sfiles.UploadDone
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sfiles.UploadDone} UploadDone
         */
        UploadDone.fromObject = function fromObject(object) {
            if (object instanceof $root.sfiles.UploadDone)
                return object;
            let message = new $root.sfiles.UploadDone();
            if (object.key != null)
                message.key = String(object.key);
            if (object.file != null) {
                if (typeof object.file !== "object")
                    throw TypeError(".sfiles.UploadDone.file: object expected");
                message.file = $root.sfiles.UploadedFile.fromObject(object.file);
            }
            return message;
        };

        /**
         * Creates a plain object from an UploadDone message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sfiles.UploadDone
         * @static
         * @param {sfiles.UploadDone} message UploadDone
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UploadDone.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.key = "";
                object.file = null;
            }
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.file != null && message.hasOwnProperty("file"))
                object.file = $root.sfiles.UploadedFile.toObject(message.file, options);
            return object;
        };

        /**
         * Converts this UploadDone to JSON.
         * @function toJSON
         * @memberof sfiles.UploadDone
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UploadDone.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for UploadDone
         * @function getTypeUrl
         * @memberof sfiles.UploadDone
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        UploadDone.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/sfiles.UploadDone";
        };

        return UploadDone;
    })();

    sfiles.UploadedFile = (function() {

        /**
         * Properties of an UploadedFile.
         * @memberof sfiles
         * @interface IUploadedFile
         * @property {string|null} [localKey] UploadedFile localKey
         * @property {string|null} [url] UploadedFile url
         * @property {string|null} [id] UploadedFile id
         * @property {string|null} [mime] UploadedFile mime
         * @property {string|null} [thumbUrl] UploadedFile thumbUrl
         * @property {string|null} [name] UploadedFile name
         * @property {boolean|null} [downloadable] UploadedFile downloadable
         */

        /**
         * Constructs a new UploadedFile.
         * @memberof sfiles
         * @classdesc Represents an UploadedFile.
         * @implements IUploadedFile
         * @constructor
         * @param {sfiles.IUploadedFile=} [properties] Properties to set
         */
        function UploadedFile(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UploadedFile localKey.
         * @member {string} localKey
         * @memberof sfiles.UploadedFile
         * @instance
         */
        UploadedFile.prototype.localKey = "";

        /**
         * UploadedFile url.
         * @member {string} url
         * @memberof sfiles.UploadedFile
         * @instance
         */
        UploadedFile.prototype.url = "";

        /**
         * UploadedFile id.
         * @member {string} id
         * @memberof sfiles.UploadedFile
         * @instance
         */
        UploadedFile.prototype.id = "";

        /**
         * UploadedFile mime.
         * @member {string} mime
         * @memberof sfiles.UploadedFile
         * @instance
         */
        UploadedFile.prototype.mime = "";

        /**
         * UploadedFile thumbUrl.
         * @member {string} thumbUrl
         * @memberof sfiles.UploadedFile
         * @instance
         */
        UploadedFile.prototype.thumbUrl = "";

        /**
         * UploadedFile name.
         * @member {string} name
         * @memberof sfiles.UploadedFile
         * @instance
         */
        UploadedFile.prototype.name = "";

        /**
         * UploadedFile downloadable.
         * @member {boolean} downloadable
         * @memberof sfiles.UploadedFile
         * @instance
         */
        UploadedFile.prototype.downloadable = false;

        /**
         * Creates a new UploadedFile instance using the specified properties.
         * @function create
         * @memberof sfiles.UploadedFile
         * @static
         * @param {sfiles.IUploadedFile=} [properties] Properties to set
         * @returns {sfiles.UploadedFile} UploadedFile instance
         */
        UploadedFile.create = function create(properties) {
            return new UploadedFile(properties);
        };

        /**
         * Encodes the specified UploadedFile message. Does not implicitly {@link sfiles.UploadedFile.verify|verify} messages.
         * @function encode
         * @memberof sfiles.UploadedFile
         * @static
         * @param {sfiles.IUploadedFile} message UploadedFile message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UploadedFile.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.localKey != null && Object.hasOwnProperty.call(message, "localKey"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.localKey);
            if (message.url != null && Object.hasOwnProperty.call(message, "url"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.url);
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.id);
            if (message.mime != null && Object.hasOwnProperty.call(message, "mime"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.mime);
            if (message.thumbUrl != null && Object.hasOwnProperty.call(message, "thumbUrl"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.thumbUrl);
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.name);
            if (message.downloadable != null && Object.hasOwnProperty.call(message, "downloadable"))
                writer.uint32(/* id 7, wireType 0 =*/56).bool(message.downloadable);
            return writer;
        };

        /**
         * Encodes the specified UploadedFile message, length delimited. Does not implicitly {@link sfiles.UploadedFile.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sfiles.UploadedFile
         * @static
         * @param {sfiles.IUploadedFile} message UploadedFile message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UploadedFile.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an UploadedFile message from the specified reader or buffer.
         * @function decode
         * @memberof sfiles.UploadedFile
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sfiles.UploadedFile} UploadedFile
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UploadedFile.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sfiles.UploadedFile();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.localKey = reader.string();
                        break;
                    }
                case 2: {
                        message.url = reader.string();
                        break;
                    }
                case 3: {
                        message.id = reader.string();
                        break;
                    }
                case 4: {
                        message.mime = reader.string();
                        break;
                    }
                case 5: {
                        message.thumbUrl = reader.string();
                        break;
                    }
                case 6: {
                        message.name = reader.string();
                        break;
                    }
                case 7: {
                        message.downloadable = reader.bool();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an UploadedFile message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sfiles.UploadedFile
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sfiles.UploadedFile} UploadedFile
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UploadedFile.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an UploadedFile message.
         * @function verify
         * @memberof sfiles.UploadedFile
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UploadedFile.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.localKey != null && message.hasOwnProperty("localKey"))
                if (!$util.isString(message.localKey))
                    return "localKey: string expected";
            if (message.url != null && message.hasOwnProperty("url"))
                if (!$util.isString(message.url))
                    return "url: string expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.mime != null && message.hasOwnProperty("mime"))
                if (!$util.isString(message.mime))
                    return "mime: string expected";
            if (message.thumbUrl != null && message.hasOwnProperty("thumbUrl"))
                if (!$util.isString(message.thumbUrl))
                    return "thumbUrl: string expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            if (message.downloadable != null && message.hasOwnProperty("downloadable"))
                if (typeof message.downloadable !== "boolean")
                    return "downloadable: boolean expected";
            return null;
        };

        /**
         * Creates an UploadedFile message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sfiles.UploadedFile
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sfiles.UploadedFile} UploadedFile
         */
        UploadedFile.fromObject = function fromObject(object) {
            if (object instanceof $root.sfiles.UploadedFile)
                return object;
            let message = new $root.sfiles.UploadedFile();
            if (object.localKey != null)
                message.localKey = String(object.localKey);
            if (object.url != null)
                message.url = String(object.url);
            if (object.id != null)
                message.id = String(object.id);
            if (object.mime != null)
                message.mime = String(object.mime);
            if (object.thumbUrl != null)
                message.thumbUrl = String(object.thumbUrl);
            if (object.name != null)
                message.name = String(object.name);
            if (object.downloadable != null)
                message.downloadable = Boolean(object.downloadable);
            return message;
        };

        /**
         * Creates a plain object from an UploadedFile message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sfiles.UploadedFile
         * @static
         * @param {sfiles.UploadedFile} message UploadedFile
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UploadedFile.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.localKey = "";
                object.url = "";
                object.id = "";
                object.mime = "";
                object.thumbUrl = "";
                object.name = "";
                object.downloadable = false;
            }
            if (message.localKey != null && message.hasOwnProperty("localKey"))
                object.localKey = message.localKey;
            if (message.url != null && message.hasOwnProperty("url"))
                object.url = message.url;
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.mime != null && message.hasOwnProperty("mime"))
                object.mime = message.mime;
            if (message.thumbUrl != null && message.hasOwnProperty("thumbUrl"))
                object.thumbUrl = message.thumbUrl;
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.downloadable != null && message.hasOwnProperty("downloadable"))
                object.downloadable = message.downloadable;
            return object;
        };

        /**
         * Converts this UploadedFile to JSON.
         * @function toJSON
         * @memberof sfiles.UploadedFile
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UploadedFile.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for UploadedFile
         * @function getTypeUrl
         * @memberof sfiles.UploadedFile
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        UploadedFile.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/sfiles.UploadedFile";
        };

        return UploadedFile;
    })();

    sfiles.UploadStart = (function() {

        /**
         * Properties of an UploadStart.
         * @memberof sfiles
         * @interface IUploadStart
         * @property {string|null} [localKey] UploadStart localKey
         * @property {string|null} [extension] UploadStart extension
         * @property {string|null} [name] UploadStart name
         * @property {string|null} [mime] UploadStart mime
         */

        /**
         * Constructs a new UploadStart.
         * @memberof sfiles
         * @classdesc Represents an UploadStart.
         * @implements IUploadStart
         * @constructor
         * @param {sfiles.IUploadStart=} [properties] Properties to set
         */
        function UploadStart(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UploadStart localKey.
         * @member {string} localKey
         * @memberof sfiles.UploadStart
         * @instance
         */
        UploadStart.prototype.localKey = "";

        /**
         * UploadStart extension.
         * @member {string} extension
         * @memberof sfiles.UploadStart
         * @instance
         */
        UploadStart.prototype.extension = "";

        /**
         * UploadStart name.
         * @member {string} name
         * @memberof sfiles.UploadStart
         * @instance
         */
        UploadStart.prototype.name = "";

        /**
         * UploadStart mime.
         * @member {string} mime
         * @memberof sfiles.UploadStart
         * @instance
         */
        UploadStart.prototype.mime = "";

        /**
         * Creates a new UploadStart instance using the specified properties.
         * @function create
         * @memberof sfiles.UploadStart
         * @static
         * @param {sfiles.IUploadStart=} [properties] Properties to set
         * @returns {sfiles.UploadStart} UploadStart instance
         */
        UploadStart.create = function create(properties) {
            return new UploadStart(properties);
        };

        /**
         * Encodes the specified UploadStart message. Does not implicitly {@link sfiles.UploadStart.verify|verify} messages.
         * @function encode
         * @memberof sfiles.UploadStart
         * @static
         * @param {sfiles.IUploadStart} message UploadStart message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UploadStart.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.localKey != null && Object.hasOwnProperty.call(message, "localKey"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.localKey);
            if (message.extension != null && Object.hasOwnProperty.call(message, "extension"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.extension);
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.name);
            if (message.mime != null && Object.hasOwnProperty.call(message, "mime"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.mime);
            return writer;
        };

        /**
         * Encodes the specified UploadStart message, length delimited. Does not implicitly {@link sfiles.UploadStart.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sfiles.UploadStart
         * @static
         * @param {sfiles.IUploadStart} message UploadStart message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UploadStart.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an UploadStart message from the specified reader or buffer.
         * @function decode
         * @memberof sfiles.UploadStart
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sfiles.UploadStart} UploadStart
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UploadStart.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sfiles.UploadStart();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.localKey = reader.string();
                        break;
                    }
                case 2: {
                        message.extension = reader.string();
                        break;
                    }
                case 3: {
                        message.name = reader.string();
                        break;
                    }
                case 4: {
                        message.mime = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an UploadStart message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sfiles.UploadStart
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sfiles.UploadStart} UploadStart
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UploadStart.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an UploadStart message.
         * @function verify
         * @memberof sfiles.UploadStart
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UploadStart.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.localKey != null && message.hasOwnProperty("localKey"))
                if (!$util.isString(message.localKey))
                    return "localKey: string expected";
            if (message.extension != null && message.hasOwnProperty("extension"))
                if (!$util.isString(message.extension))
                    return "extension: string expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            if (message.mime != null && message.hasOwnProperty("mime"))
                if (!$util.isString(message.mime))
                    return "mime: string expected";
            return null;
        };

        /**
         * Creates an UploadStart message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sfiles.UploadStart
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sfiles.UploadStart} UploadStart
         */
        UploadStart.fromObject = function fromObject(object) {
            if (object instanceof $root.sfiles.UploadStart)
                return object;
            let message = new $root.sfiles.UploadStart();
            if (object.localKey != null)
                message.localKey = String(object.localKey);
            if (object.extension != null)
                message.extension = String(object.extension);
            if (object.name != null)
                message.name = String(object.name);
            if (object.mime != null)
                message.mime = String(object.mime);
            return message;
        };

        /**
         * Creates a plain object from an UploadStart message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sfiles.UploadStart
         * @static
         * @param {sfiles.UploadStart} message UploadStart
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UploadStart.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.localKey = "";
                object.extension = "";
                object.name = "";
                object.mime = "";
            }
            if (message.localKey != null && message.hasOwnProperty("localKey"))
                object.localKey = message.localKey;
            if (message.extension != null && message.hasOwnProperty("extension"))
                object.extension = message.extension;
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.mime != null && message.hasOwnProperty("mime"))
                object.mime = message.mime;
            return object;
        };

        /**
         * Converts this UploadStart to JSON.
         * @function toJSON
         * @memberof sfiles.UploadStart
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UploadStart.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for UploadStart
         * @function getTypeUrl
         * @memberof sfiles.UploadStart
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        UploadStart.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/sfiles.UploadStart";
        };

        return UploadStart;
    })();

    sfiles.DeleteFile = (function() {

        /**
         * Properties of a DeleteFile.
         * @memberof sfiles
         * @interface IDeleteFile
         * @property {sfiles.IUploadedFile|null} [file] DeleteFile file
         */

        /**
         * Constructs a new DeleteFile.
         * @memberof sfiles
         * @classdesc Represents a DeleteFile.
         * @implements IDeleteFile
         * @constructor
         * @param {sfiles.IDeleteFile=} [properties] Properties to set
         */
        function DeleteFile(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * DeleteFile file.
         * @member {sfiles.IUploadedFile|null|undefined} file
         * @memberof sfiles.DeleteFile
         * @instance
         */
        DeleteFile.prototype.file = null;

        /**
         * Creates a new DeleteFile instance using the specified properties.
         * @function create
         * @memberof sfiles.DeleteFile
         * @static
         * @param {sfiles.IDeleteFile=} [properties] Properties to set
         * @returns {sfiles.DeleteFile} DeleteFile instance
         */
        DeleteFile.create = function create(properties) {
            return new DeleteFile(properties);
        };

        /**
         * Encodes the specified DeleteFile message. Does not implicitly {@link sfiles.DeleteFile.verify|verify} messages.
         * @function encode
         * @memberof sfiles.DeleteFile
         * @static
         * @param {sfiles.IDeleteFile} message DeleteFile message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DeleteFile.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.file != null && Object.hasOwnProperty.call(message, "file"))
                $root.sfiles.UploadedFile.encode(message.file, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified DeleteFile message, length delimited. Does not implicitly {@link sfiles.DeleteFile.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sfiles.DeleteFile
         * @static
         * @param {sfiles.IDeleteFile} message DeleteFile message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DeleteFile.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a DeleteFile message from the specified reader or buffer.
         * @function decode
         * @memberof sfiles.DeleteFile
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sfiles.DeleteFile} DeleteFile
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DeleteFile.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sfiles.DeleteFile();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.file = $root.sfiles.UploadedFile.decode(reader, reader.uint32());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a DeleteFile message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sfiles.DeleteFile
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sfiles.DeleteFile} DeleteFile
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DeleteFile.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a DeleteFile message.
         * @function verify
         * @memberof sfiles.DeleteFile
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        DeleteFile.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.file != null && message.hasOwnProperty("file")) {
                let error = $root.sfiles.UploadedFile.verify(message.file);
                if (error)
                    return "file." + error;
            }
            return null;
        };

        /**
         * Creates a DeleteFile message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sfiles.DeleteFile
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sfiles.DeleteFile} DeleteFile
         */
        DeleteFile.fromObject = function fromObject(object) {
            if (object instanceof $root.sfiles.DeleteFile)
                return object;
            let message = new $root.sfiles.DeleteFile();
            if (object.file != null) {
                if (typeof object.file !== "object")
                    throw TypeError(".sfiles.DeleteFile.file: object expected");
                message.file = $root.sfiles.UploadedFile.fromObject(object.file);
            }
            return message;
        };

        /**
         * Creates a plain object from a DeleteFile message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sfiles.DeleteFile
         * @static
         * @param {sfiles.DeleteFile} message DeleteFile
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DeleteFile.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.file = null;
            if (message.file != null && message.hasOwnProperty("file"))
                object.file = $root.sfiles.UploadedFile.toObject(message.file, options);
            return object;
        };

        /**
         * Converts this DeleteFile to JSON.
         * @function toJSON
         * @memberof sfiles.DeleteFile
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DeleteFile.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for DeleteFile
         * @function getTypeUrl
         * @memberof sfiles.DeleteFile
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        DeleteFile.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/sfiles.DeleteFile";
        };

        return DeleteFile;
    })();

    sfiles.UploadEnd = (function() {

        /**
         * Properties of an UploadEnd.
         * @memberof sfiles
         * @interface IUploadEnd
         */

        /**
         * Constructs a new UploadEnd.
         * @memberof sfiles
         * @classdesc Represents an UploadEnd.
         * @implements IUploadEnd
         * @constructor
         * @param {sfiles.IUploadEnd=} [properties] Properties to set
         */
        function UploadEnd(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new UploadEnd instance using the specified properties.
         * @function create
         * @memberof sfiles.UploadEnd
         * @static
         * @param {sfiles.IUploadEnd=} [properties] Properties to set
         * @returns {sfiles.UploadEnd} UploadEnd instance
         */
        UploadEnd.create = function create(properties) {
            return new UploadEnd(properties);
        };

        /**
         * Encodes the specified UploadEnd message. Does not implicitly {@link sfiles.UploadEnd.verify|verify} messages.
         * @function encode
         * @memberof sfiles.UploadEnd
         * @static
         * @param {sfiles.IUploadEnd} message UploadEnd message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UploadEnd.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified UploadEnd message, length delimited. Does not implicitly {@link sfiles.UploadEnd.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sfiles.UploadEnd
         * @static
         * @param {sfiles.IUploadEnd} message UploadEnd message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UploadEnd.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an UploadEnd message from the specified reader or buffer.
         * @function decode
         * @memberof sfiles.UploadEnd
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sfiles.UploadEnd} UploadEnd
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UploadEnd.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.sfiles.UploadEnd();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an UploadEnd message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sfiles.UploadEnd
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sfiles.UploadEnd} UploadEnd
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UploadEnd.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an UploadEnd message.
         * @function verify
         * @memberof sfiles.UploadEnd
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UploadEnd.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates an UploadEnd message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sfiles.UploadEnd
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sfiles.UploadEnd} UploadEnd
         */
        UploadEnd.fromObject = function fromObject(object) {
            if (object instanceof $root.sfiles.UploadEnd)
                return object;
            return new $root.sfiles.UploadEnd();
        };

        /**
         * Creates a plain object from an UploadEnd message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sfiles.UploadEnd
         * @static
         * @param {sfiles.UploadEnd} message UploadEnd
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UploadEnd.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this UploadEnd to JSON.
         * @function toJSON
         * @memberof sfiles.UploadEnd
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UploadEnd.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for UploadEnd
         * @function getTypeUrl
         * @memberof sfiles.UploadEnd
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        UploadEnd.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/sfiles.UploadEnd";
        };

        return UploadEnd;
    })();

    return sfiles;
})();

export const socket_api = $root.socket_api = (() => {

    /**
     * Namespace socket_api.
     * @exports socket_api
     * @namespace
     */
    const socket_api = {};

    socket_api.Ack = (function() {

        /**
         * Properties of an Ack.
         * @memberof socket_api
         * @interface IAck
         * @property {string|null} [uuid] Ack uuid
         * @property {string|null} [errorMessage] Ack errorMessage
         * @property {number|null} [errorCode] Ack errorCode
         */

        /**
         * Constructs a new Ack.
         * @memberof socket_api
         * @classdesc Represents an Ack.
         * @implements IAck
         * @constructor
         * @param {socket_api.IAck=} [properties] Properties to set
         */
        function Ack(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Ack uuid.
         * @member {string} uuid
         * @memberof socket_api.Ack
         * @instance
         */
        Ack.prototype.uuid = "";

        /**
         * Ack errorMessage.
         * @member {string} errorMessage
         * @memberof socket_api.Ack
         * @instance
         */
        Ack.prototype.errorMessage = "";

        /**
         * Ack errorCode.
         * @member {number} errorCode
         * @memberof socket_api.Ack
         * @instance
         */
        Ack.prototype.errorCode = 0;

        /**
         * Creates a new Ack instance using the specified properties.
         * @function create
         * @memberof socket_api.Ack
         * @static
         * @param {socket_api.IAck=} [properties] Properties to set
         * @returns {socket_api.Ack} Ack instance
         */
        Ack.create = function create(properties) {
            return new Ack(properties);
        };

        /**
         * Encodes the specified Ack message. Does not implicitly {@link socket_api.Ack.verify|verify} messages.
         * @function encode
         * @memberof socket_api.Ack
         * @static
         * @param {socket_api.IAck} message Ack message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Ack.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uuid != null && Object.hasOwnProperty.call(message, "uuid"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.uuid);
            if (message.errorMessage != null && Object.hasOwnProperty.call(message, "errorMessage"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.errorMessage);
            if (message.errorCode != null && Object.hasOwnProperty.call(message, "errorCode"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.errorCode);
            return writer;
        };

        /**
         * Encodes the specified Ack message, length delimited. Does not implicitly {@link socket_api.Ack.verify|verify} messages.
         * @function encodeDelimited
         * @memberof socket_api.Ack
         * @static
         * @param {socket_api.IAck} message Ack message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Ack.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an Ack message from the specified reader or buffer.
         * @function decode
         * @memberof socket_api.Ack
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {socket_api.Ack} Ack
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Ack.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.socket_api.Ack();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.uuid = reader.string();
                        break;
                    }
                case 2: {
                        message.errorMessage = reader.string();
                        break;
                    }
                case 4: {
                        message.errorCode = reader.int32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an Ack message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof socket_api.Ack
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {socket_api.Ack} Ack
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Ack.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an Ack message.
         * @function verify
         * @memberof socket_api.Ack
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Ack.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.uuid != null && message.hasOwnProperty("uuid"))
                if (!$util.isString(message.uuid))
                    return "uuid: string expected";
            if (message.errorMessage != null && message.hasOwnProperty("errorMessage"))
                if (!$util.isString(message.errorMessage))
                    return "errorMessage: string expected";
            if (message.errorCode != null && message.hasOwnProperty("errorCode"))
                if (!$util.isInteger(message.errorCode))
                    return "errorCode: integer expected";
            return null;
        };

        /**
         * Creates an Ack message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof socket_api.Ack
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {socket_api.Ack} Ack
         */
        Ack.fromObject = function fromObject(object) {
            if (object instanceof $root.socket_api.Ack)
                return object;
            let message = new $root.socket_api.Ack();
            if (object.uuid != null)
                message.uuid = String(object.uuid);
            if (object.errorMessage != null)
                message.errorMessage = String(object.errorMessage);
            if (object.errorCode != null)
                message.errorCode = object.errorCode | 0;
            return message;
        };

        /**
         * Creates a plain object from an Ack message. Also converts values to other types if specified.
         * @function toObject
         * @memberof socket_api.Ack
         * @static
         * @param {socket_api.Ack} message Ack
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Ack.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.uuid = "";
                object.errorMessage = "";
                object.errorCode = 0;
            }
            if (message.uuid != null && message.hasOwnProperty("uuid"))
                object.uuid = message.uuid;
            if (message.errorMessage != null && message.hasOwnProperty("errorMessage"))
                object.errorMessage = message.errorMessage;
            if (message.errorCode != null && message.hasOwnProperty("errorCode"))
                object.errorCode = message.errorCode;
            return object;
        };

        /**
         * Converts this Ack to JSON.
         * @function toJSON
         * @memberof socket_api.Ack
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Ack.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Ack
         * @function getTypeUrl
         * @memberof socket_api.Ack
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Ack.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/socket_api.Ack";
        };

        return Ack;
    })();

    socket_api.IlolAck = (function() {

        /**
         * Properties of an IlolAck.
         * @memberof socket_api
         * @interface IIlolAck
         * @property {string|null} [sourceEventId] IlolAck sourceEventId
         */

        /**
         * Constructs a new IlolAck.
         * @memberof socket_api
         * @classdesc Represents an IlolAck.
         * @implements IIlolAck
         * @constructor
         * @param {socket_api.IIlolAck=} [properties] Properties to set
         */
        function IlolAck(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * IlolAck sourceEventId.
         * @member {string} sourceEventId
         * @memberof socket_api.IlolAck
         * @instance
         */
        IlolAck.prototype.sourceEventId = "";

        /**
         * Creates a new IlolAck instance using the specified properties.
         * @function create
         * @memberof socket_api.IlolAck
         * @static
         * @param {socket_api.IIlolAck=} [properties] Properties to set
         * @returns {socket_api.IlolAck} IlolAck instance
         */
        IlolAck.create = function create(properties) {
            return new IlolAck(properties);
        };

        /**
         * Encodes the specified IlolAck message. Does not implicitly {@link socket_api.IlolAck.verify|verify} messages.
         * @function encode
         * @memberof socket_api.IlolAck
         * @static
         * @param {socket_api.IIlolAck} message IlolAck message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        IlolAck.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.sourceEventId != null && Object.hasOwnProperty.call(message, "sourceEventId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.sourceEventId);
            return writer;
        };

        /**
         * Encodes the specified IlolAck message, length delimited. Does not implicitly {@link socket_api.IlolAck.verify|verify} messages.
         * @function encodeDelimited
         * @memberof socket_api.IlolAck
         * @static
         * @param {socket_api.IIlolAck} message IlolAck message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        IlolAck.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an IlolAck message from the specified reader or buffer.
         * @function decode
         * @memberof socket_api.IlolAck
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {socket_api.IlolAck} IlolAck
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        IlolAck.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.socket_api.IlolAck();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.sourceEventId = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an IlolAck message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof socket_api.IlolAck
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {socket_api.IlolAck} IlolAck
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        IlolAck.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an IlolAck message.
         * @function verify
         * @memberof socket_api.IlolAck
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        IlolAck.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.sourceEventId != null && message.hasOwnProperty("sourceEventId"))
                if (!$util.isString(message.sourceEventId))
                    return "sourceEventId: string expected";
            return null;
        };

        /**
         * Creates an IlolAck message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof socket_api.IlolAck
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {socket_api.IlolAck} IlolAck
         */
        IlolAck.fromObject = function fromObject(object) {
            if (object instanceof $root.socket_api.IlolAck)
                return object;
            let message = new $root.socket_api.IlolAck();
            if (object.sourceEventId != null)
                message.sourceEventId = String(object.sourceEventId);
            return message;
        };

        /**
         * Creates a plain object from an IlolAck message. Also converts values to other types if specified.
         * @function toObject
         * @memberof socket_api.IlolAck
         * @static
         * @param {socket_api.IlolAck} message IlolAck
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        IlolAck.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.sourceEventId = "";
            if (message.sourceEventId != null && message.hasOwnProperty("sourceEventId"))
                object.sourceEventId = message.sourceEventId;
            return object;
        };

        /**
         * Converts this IlolAck to JSON.
         * @function toJSON
         * @memberof socket_api.IlolAck
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        IlolAck.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for IlolAck
         * @function getTypeUrl
         * @memberof socket_api.IlolAck
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        IlolAck.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/socket_api.IlolAck";
        };

        return IlolAck;
    })();

    socket_api.IlolError = (function() {

        /**
         * Properties of an IlolError.
         * @memberof socket_api
         * @interface IIlolError
         * @property {string|null} [sourceEventId] IlolError sourceEventId
         * @property {string|null} [reason] IlolError reason
         */

        /**
         * Constructs a new IlolError.
         * @memberof socket_api
         * @classdesc Represents an IlolError.
         * @implements IIlolError
         * @constructor
         * @param {socket_api.IIlolError=} [properties] Properties to set
         */
        function IlolError(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * IlolError sourceEventId.
         * @member {string} sourceEventId
         * @memberof socket_api.IlolError
         * @instance
         */
        IlolError.prototype.sourceEventId = "";

        /**
         * IlolError reason.
         * @member {string} reason
         * @memberof socket_api.IlolError
         * @instance
         */
        IlolError.prototype.reason = "";

        /**
         * Creates a new IlolError instance using the specified properties.
         * @function create
         * @memberof socket_api.IlolError
         * @static
         * @param {socket_api.IIlolError=} [properties] Properties to set
         * @returns {socket_api.IlolError} IlolError instance
         */
        IlolError.create = function create(properties) {
            return new IlolError(properties);
        };

        /**
         * Encodes the specified IlolError message. Does not implicitly {@link socket_api.IlolError.verify|verify} messages.
         * @function encode
         * @memberof socket_api.IlolError
         * @static
         * @param {socket_api.IIlolError} message IlolError message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        IlolError.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.sourceEventId != null && Object.hasOwnProperty.call(message, "sourceEventId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.sourceEventId);
            if (message.reason != null && Object.hasOwnProperty.call(message, "reason"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.reason);
            return writer;
        };

        /**
         * Encodes the specified IlolError message, length delimited. Does not implicitly {@link socket_api.IlolError.verify|verify} messages.
         * @function encodeDelimited
         * @memberof socket_api.IlolError
         * @static
         * @param {socket_api.IIlolError} message IlolError message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        IlolError.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an IlolError message from the specified reader or buffer.
         * @function decode
         * @memberof socket_api.IlolError
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {socket_api.IlolError} IlolError
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        IlolError.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.socket_api.IlolError();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.sourceEventId = reader.string();
                        break;
                    }
                case 2: {
                        message.reason = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an IlolError message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof socket_api.IlolError
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {socket_api.IlolError} IlolError
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        IlolError.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an IlolError message.
         * @function verify
         * @memberof socket_api.IlolError
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        IlolError.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.sourceEventId != null && message.hasOwnProperty("sourceEventId"))
                if (!$util.isString(message.sourceEventId))
                    return "sourceEventId: string expected";
            if (message.reason != null && message.hasOwnProperty("reason"))
                if (!$util.isString(message.reason))
                    return "reason: string expected";
            return null;
        };

        /**
         * Creates an IlolError message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof socket_api.IlolError
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {socket_api.IlolError} IlolError
         */
        IlolError.fromObject = function fromObject(object) {
            if (object instanceof $root.socket_api.IlolError)
                return object;
            let message = new $root.socket_api.IlolError();
            if (object.sourceEventId != null)
                message.sourceEventId = String(object.sourceEventId);
            if (object.reason != null)
                message.reason = String(object.reason);
            return message;
        };

        /**
         * Creates a plain object from an IlolError message. Also converts values to other types if specified.
         * @function toObject
         * @memberof socket_api.IlolError
         * @static
         * @param {socket_api.IlolError} message IlolError
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        IlolError.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.sourceEventId = "";
                object.reason = "";
            }
            if (message.sourceEventId != null && message.hasOwnProperty("sourceEventId"))
                object.sourceEventId = message.sourceEventId;
            if (message.reason != null && message.hasOwnProperty("reason"))
                object.reason = message.reason;
            return object;
        };

        /**
         * Converts this IlolError to JSON.
         * @function toJSON
         * @memberof socket_api.IlolError
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        IlolError.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for IlolError
         * @function getTypeUrl
         * @memberof socket_api.IlolError
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        IlolError.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/socket_api.IlolError";
        };

        return IlolError;
    })();

    socket_api.AsyncProgress = (function() {

        /**
         * Properties of an AsyncProgress.
         * @memberof socket_api
         * @interface IAsyncProgress
         * @property {string|null} [key] AsyncProgress key
         * @property {number|null} [progress] AsyncProgress progress
         * @property {string|null} [info] AsyncProgress info
         * @property {boolean|null} [done] AsyncProgress done
         * @property {string|null} [errorMessage] AsyncProgress errorMessage
         * @property {number|null} [errorCode] AsyncProgress errorCode
         */

        /**
         * Constructs a new AsyncProgress.
         * @memberof socket_api
         * @classdesc Represents an AsyncProgress.
         * @implements IAsyncProgress
         * @constructor
         * @param {socket_api.IAsyncProgress=} [properties] Properties to set
         */
        function AsyncProgress(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AsyncProgress key.
         * @member {string} key
         * @memberof socket_api.AsyncProgress
         * @instance
         */
        AsyncProgress.prototype.key = "";

        /**
         * AsyncProgress progress.
         * @member {number} progress
         * @memberof socket_api.AsyncProgress
         * @instance
         */
        AsyncProgress.prototype.progress = 0;

        /**
         * AsyncProgress info.
         * @member {string} info
         * @memberof socket_api.AsyncProgress
         * @instance
         */
        AsyncProgress.prototype.info = "";

        /**
         * AsyncProgress done.
         * @member {boolean} done
         * @memberof socket_api.AsyncProgress
         * @instance
         */
        AsyncProgress.prototype.done = false;

        /**
         * AsyncProgress errorMessage.
         * @member {string} errorMessage
         * @memberof socket_api.AsyncProgress
         * @instance
         */
        AsyncProgress.prototype.errorMessage = "";

        /**
         * AsyncProgress errorCode.
         * @member {number} errorCode
         * @memberof socket_api.AsyncProgress
         * @instance
         */
        AsyncProgress.prototype.errorCode = 0;

        /**
         * Creates a new AsyncProgress instance using the specified properties.
         * @function create
         * @memberof socket_api.AsyncProgress
         * @static
         * @param {socket_api.IAsyncProgress=} [properties] Properties to set
         * @returns {socket_api.AsyncProgress} AsyncProgress instance
         */
        AsyncProgress.create = function create(properties) {
            return new AsyncProgress(properties);
        };

        /**
         * Encodes the specified AsyncProgress message. Does not implicitly {@link socket_api.AsyncProgress.verify|verify} messages.
         * @function encode
         * @memberof socket_api.AsyncProgress
         * @static
         * @param {socket_api.IAsyncProgress} message AsyncProgress message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AsyncProgress.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.key != null && Object.hasOwnProperty.call(message, "key"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.key);
            if (message.progress != null && Object.hasOwnProperty.call(message, "progress"))
                writer.uint32(/* id 2, wireType 1 =*/17).double(message.progress);
            if (message.info != null && Object.hasOwnProperty.call(message, "info"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.info);
            if (message.done != null && Object.hasOwnProperty.call(message, "done"))
                writer.uint32(/* id 4, wireType 0 =*/32).bool(message.done);
            if (message.errorMessage != null && Object.hasOwnProperty.call(message, "errorMessage"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.errorMessage);
            if (message.errorCode != null && Object.hasOwnProperty.call(message, "errorCode"))
                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.errorCode);
            return writer;
        };

        /**
         * Encodes the specified AsyncProgress message, length delimited. Does not implicitly {@link socket_api.AsyncProgress.verify|verify} messages.
         * @function encodeDelimited
         * @memberof socket_api.AsyncProgress
         * @static
         * @param {socket_api.IAsyncProgress} message AsyncProgress message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AsyncProgress.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an AsyncProgress message from the specified reader or buffer.
         * @function decode
         * @memberof socket_api.AsyncProgress
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {socket_api.AsyncProgress} AsyncProgress
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AsyncProgress.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.socket_api.AsyncProgress();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.key = reader.string();
                        break;
                    }
                case 2: {
                        message.progress = reader.double();
                        break;
                    }
                case 3: {
                        message.info = reader.string();
                        break;
                    }
                case 4: {
                        message.done = reader.bool();
                        break;
                    }
                case 5: {
                        message.errorMessage = reader.string();
                        break;
                    }
                case 6: {
                        message.errorCode = reader.int32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an AsyncProgress message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof socket_api.AsyncProgress
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {socket_api.AsyncProgress} AsyncProgress
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AsyncProgress.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an AsyncProgress message.
         * @function verify
         * @memberof socket_api.AsyncProgress
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        AsyncProgress.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.key != null && message.hasOwnProperty("key"))
                if (!$util.isString(message.key))
                    return "key: string expected";
            if (message.progress != null && message.hasOwnProperty("progress"))
                if (typeof message.progress !== "number")
                    return "progress: number expected";
            if (message.info != null && message.hasOwnProperty("info"))
                if (!$util.isString(message.info))
                    return "info: string expected";
            if (message.done != null && message.hasOwnProperty("done"))
                if (typeof message.done !== "boolean")
                    return "done: boolean expected";
            if (message.errorMessage != null && message.hasOwnProperty("errorMessage"))
                if (!$util.isString(message.errorMessage))
                    return "errorMessage: string expected";
            if (message.errorCode != null && message.hasOwnProperty("errorCode"))
                if (!$util.isInteger(message.errorCode))
                    return "errorCode: integer expected";
            return null;
        };

        /**
         * Creates an AsyncProgress message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof socket_api.AsyncProgress
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {socket_api.AsyncProgress} AsyncProgress
         */
        AsyncProgress.fromObject = function fromObject(object) {
            if (object instanceof $root.socket_api.AsyncProgress)
                return object;
            let message = new $root.socket_api.AsyncProgress();
            if (object.key != null)
                message.key = String(object.key);
            if (object.progress != null)
                message.progress = Number(object.progress);
            if (object.info != null)
                message.info = String(object.info);
            if (object.done != null)
                message.done = Boolean(object.done);
            if (object.errorMessage != null)
                message.errorMessage = String(object.errorMessage);
            if (object.errorCode != null)
                message.errorCode = object.errorCode | 0;
            return message;
        };

        /**
         * Creates a plain object from an AsyncProgress message. Also converts values to other types if specified.
         * @function toObject
         * @memberof socket_api.AsyncProgress
         * @static
         * @param {socket_api.AsyncProgress} message AsyncProgress
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AsyncProgress.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.key = "";
                object.progress = 0;
                object.info = "";
                object.done = false;
                object.errorMessage = "";
                object.errorCode = 0;
            }
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.progress != null && message.hasOwnProperty("progress"))
                object.progress = options.json && !isFinite(message.progress) ? String(message.progress) : message.progress;
            if (message.info != null && message.hasOwnProperty("info"))
                object.info = message.info;
            if (message.done != null && message.hasOwnProperty("done"))
                object.done = message.done;
            if (message.errorMessage != null && message.hasOwnProperty("errorMessage"))
                object.errorMessage = message.errorMessage;
            if (message.errorCode != null && message.hasOwnProperty("errorCode"))
                object.errorCode = message.errorCode;
            return object;
        };

        /**
         * Converts this AsyncProgress to JSON.
         * @function toJSON
         * @memberof socket_api.AsyncProgress
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AsyncProgress.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for AsyncProgress
         * @function getTypeUrl
         * @memberof socket_api.AsyncProgress
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        AsyncProgress.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/socket_api.AsyncProgress";
        };

        return AsyncProgress;
    })();

    socket_api.UpgradeApiVersion = (function() {

        /**
         * Properties of an UpgradeApiVersion.
         * @memberof socket_api
         * @interface IUpgradeApiVersion
         * @property {number|null} [latest] UpgradeApiVersion latest
         */

        /**
         * Constructs a new UpgradeApiVersion.
         * @memberof socket_api
         * @classdesc Represents an UpgradeApiVersion.
         * @implements IUpgradeApiVersion
         * @constructor
         * @param {socket_api.IUpgradeApiVersion=} [properties] Properties to set
         */
        function UpgradeApiVersion(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpgradeApiVersion latest.
         * @member {number} latest
         * @memberof socket_api.UpgradeApiVersion
         * @instance
         */
        UpgradeApiVersion.prototype.latest = 0;

        /**
         * Creates a new UpgradeApiVersion instance using the specified properties.
         * @function create
         * @memberof socket_api.UpgradeApiVersion
         * @static
         * @param {socket_api.IUpgradeApiVersion=} [properties] Properties to set
         * @returns {socket_api.UpgradeApiVersion} UpgradeApiVersion instance
         */
        UpgradeApiVersion.create = function create(properties) {
            return new UpgradeApiVersion(properties);
        };

        /**
         * Encodes the specified UpgradeApiVersion message. Does not implicitly {@link socket_api.UpgradeApiVersion.verify|verify} messages.
         * @function encode
         * @memberof socket_api.UpgradeApiVersion
         * @static
         * @param {socket_api.IUpgradeApiVersion} message UpgradeApiVersion message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpgradeApiVersion.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.latest != null && Object.hasOwnProperty.call(message, "latest"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.latest);
            return writer;
        };

        /**
         * Encodes the specified UpgradeApiVersion message, length delimited. Does not implicitly {@link socket_api.UpgradeApiVersion.verify|verify} messages.
         * @function encodeDelimited
         * @memberof socket_api.UpgradeApiVersion
         * @static
         * @param {socket_api.IUpgradeApiVersion} message UpgradeApiVersion message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpgradeApiVersion.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an UpgradeApiVersion message from the specified reader or buffer.
         * @function decode
         * @memberof socket_api.UpgradeApiVersion
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {socket_api.UpgradeApiVersion} UpgradeApiVersion
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpgradeApiVersion.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.socket_api.UpgradeApiVersion();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.latest = reader.int32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an UpgradeApiVersion message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof socket_api.UpgradeApiVersion
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {socket_api.UpgradeApiVersion} UpgradeApiVersion
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpgradeApiVersion.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an UpgradeApiVersion message.
         * @function verify
         * @memberof socket_api.UpgradeApiVersion
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UpgradeApiVersion.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.latest != null && message.hasOwnProperty("latest"))
                if (!$util.isInteger(message.latest))
                    return "latest: integer expected";
            return null;
        };

        /**
         * Creates an UpgradeApiVersion message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof socket_api.UpgradeApiVersion
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {socket_api.UpgradeApiVersion} UpgradeApiVersion
         */
        UpgradeApiVersion.fromObject = function fromObject(object) {
            if (object instanceof $root.socket_api.UpgradeApiVersion)
                return object;
            let message = new $root.socket_api.UpgradeApiVersion();
            if (object.latest != null)
                message.latest = object.latest | 0;
            return message;
        };

        /**
         * Creates a plain object from an UpgradeApiVersion message. Also converts values to other types if specified.
         * @function toObject
         * @memberof socket_api.UpgradeApiVersion
         * @static
         * @param {socket_api.UpgradeApiVersion} message UpgradeApiVersion
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpgradeApiVersion.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.latest = 0;
            if (message.latest != null && message.hasOwnProperty("latest"))
                object.latest = message.latest;
            return object;
        };

        /**
         * Converts this UpgradeApiVersion to JSON.
         * @function toJSON
         * @memberof socket_api.UpgradeApiVersion
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpgradeApiVersion.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for UpgradeApiVersion
         * @function getTypeUrl
         * @memberof socket_api.UpgradeApiVersion
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        UpgradeApiVersion.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/socket_api.UpgradeApiVersion";
        };

        return UpgradeApiVersion;
    })();

    /**
     * AckErrorCode enum.
     * @name socket_api.AckErrorCode
     * @enum {number}
     * @property {number} error_code_none=0 error_code_none value
     * @property {number} error_code_unauthorized=401 error_code_unauthorized value
     */
    socket_api.AckErrorCode = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "error_code_none"] = 0;
        values[valuesById[401] = "error_code_unauthorized"] = 401;
        return values;
    })();

    return socket_api;
})();

export { $root as default };
